webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      requeridoRegla: [function (v) {
        return !!v || 'Requerido';
      }
      // v => !!v || 'Requerido',
      // v => (v && v.length <= 10) || 'Name must be less than 10 characters'
      ],
      dniRegla: [function (v) {
        return v && v.length >= 8 || 'DNI incompleto';
      }],
      operacionRegla: [function (v) {
        return v && v.length >= 8 || 'Número de operación incompleto';
      }],
      rucRegla: [function (v) {
        return v && v.length >= 11 || 'RUC incompleto';
      }],
      emailRegla: [function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Correo debe ser válido'
        );
      }],
      emailOpcionalRegla: [function (v) {
        return (/^$|^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Correo debe ser válido'
        );
      }]
    };
  },
  methods: {
    crearSolicitud: function crearSolicitud() {
      var solicitudApi = {
        tokenId: encodeURIComponent(localStorage.getItem('tokenId')),
        local: localStorage.getItem('local')
      };
      return solicitudApi;
    },
    formatoFecha: function formatoFecha(fecha) {
      if (!fecha) return null;

      var _fecha$split = fecha.split('-'),
          _fecha$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_fecha$split, 3),
          year = _fecha$split2[0],
          month = _fecha$split2[1],
          day = _fecha$split2[2];

      return day + '/' + month + '/' + year;
    },
    parseDate: function parseDate(fecha) {
      if (!fecha) return null;

      var _fecha$split3 = fecha.split('/'),
          _fecha$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_fecha$split3, 3),
          day = _fecha$split4[0],
          month = _fecha$split4[1],
          year = _fecha$split4[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    }
  }
});

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      departamentos: [{ id: '01', nombre: 'AMAZONAS' }, { id: '02', nombre: 'ÁNCASH' }, { id: '03', nombre: 'APURÍMAC' }, { id: '04', nombre: 'AREQUIPA' }, { id: '05', nombre: 'AYACUCHO' }, { id: '06', nombre: 'CAJAMARCA' }, { id: '07', nombre: 'CALLAO' }, { id: '08', nombre: 'CUSCO' }, { id: '09', nombre: 'HUANCAVELICA' }, { id: '10', nombre: 'HUANUCO' }, { id: '10', nombre: 'HUÁNUCO' }, { id: '11', nombre: 'ICA' }, { id: '12', nombre: 'JUNÍN' }, { id: '12', nombre: 'JUNIN' }, { id: '13', nombre: 'LA LIBERTAD' }, { id: '14', nombre: 'LAMBAYEQUE' }, { id: '15', nombre: 'LIMA' }, { id: '16', nombre: 'LORETO' }, { id: '17', nombre: 'MADRE DE DIOS' }, { id: '18', nombre: 'MOQUEGUA' }, { id: '19', nombre: 'PASCO' }, { id: '20', nombre: 'PIURA' }, { id: '21', nombre: 'PUNO' }, { id: '22', nombre: 'SAN MARTÍN' }, { id: '23', nombre: 'TACNA' }, { id: '24', nombre: 'TUMBES' }, { id: '25', nombre: 'UCAYALI' }],
      listaProvincias: {
        '': [{ id: '', nombre: '' }],
        '01': [{ id: '0101', nombre: 'CHACHAPOYAS' }, { id: '0102', nombre: 'BAGUA' }, { id: '0103', nombre: 'BONGARÁ' }, { id: '0104', nombre: 'CONDORCANQUI' }, { id: '0105', nombre: 'LUYA' }, { id: '0106', nombre: 'RODRÍGUEZ DE MENDOZA' }, { id: '0107', nombre: 'UTCUBAMBA' }],
        '02': [{ id: '0201', nombre: 'HUARAZ' }, { id: '0202', nombre: 'AIJA' }, { id: '0203', nombre: 'ANTONIO RAYMONDI' }, { id: '0204', nombre: 'ASUNCIÓN' }, { id: '0205', nombre: 'BOLOGNESI' }, { id: '0206', nombre: 'CARHUAZ' }, { id: '0207', nombre: 'CARLOS FERMÍN FITZCARRALD' }, { id: '0208', nombre: 'CASMA' }, { id: '0209', nombre: 'CORONGO' }, { id: '0210', nombre: 'HUARI' }, { id: '0211', nombre: 'HUARMEY' }, { id: '0212', nombre: 'HUAYLAS' }, { id: '0213', nombre: 'MARISCAL LUZURIAGA' }, { id: '0214', nombre: 'OCROS' }, { id: '0215', nombre: 'PALLASCA' }, { id: '0216', nombre: 'POMABAMBA' }, { id: '0217', nombre: 'RECUAY' }, { id: '0218', nombre: 'SANTA' }, { id: '0219', nombre: 'SIHUAS' }, { id: '0220', nombre: 'YUNGAY' }],
        '03': [{ id: '0301', nombre: 'ABANCAY' }, { id: '0302', nombre: 'ANDAHUAYLAS' }, { id: '0303', nombre: 'ANTABAMBA' }, { id: '0304', nombre: 'AYMARAES' }, { id: '0305', nombre: 'COTABAMBAS' }, { id: '0306', nombre: 'CHINCHEROS' }, { id: '0307', nombre: 'GRAU' }],
        '04': [{ id: '0401', nombre: 'AREQUIPA' }, { id: '0402', nombre: 'CAMANÁ' }, { id: '0403', nombre: 'CARAVELÍ' }, { id: '0404', nombre: 'CASTILLA' }, { id: '0405', nombre: 'CAYLLOMA' }, { id: '0406', nombre: 'CONDESUYOS' }, { id: '0407', nombre: 'ISLAY' }, { id: '0408', nombre: 'LA UNIÒN' }],
        '05': [{ id: '0501', nombre: 'HUAMANGA' }, { id: '0502', nombre: 'CANGALLO' }, { id: '0503', nombre: 'HUANCA SANCOS' }, { id: '0504', nombre: 'HUANTA' }, { id: '0505', nombre: 'LA MAR' }, { id: '0506', nombre: 'LUCANAS' }, { id: '0507', nombre: 'PARINACOCHAS' }, { id: '0508', nombre: 'PÀUCAR DEL SARA SARA' }, { id: '0509', nombre: 'SUCRE' }, { id: '0510', nombre: 'VÍCTOR FAJARDO' }, { id: '0511', nombre: 'VILCAS HUAMÁN' }],
        '06': [{ id: '0601', nombre: 'CAJAMARCA' }, { id: '0602', nombre: 'CAJABAMBA' }, { id: '0603', nombre: 'CELENDÍN' }, { id: '0604', nombre: 'CHOTA' }, { id: '0605', nombre: 'CONTUMAZÁ' }, { id: '0606', nombre: 'CUTERVO' }, { id: '0607', nombre: 'HUALGAYOC' }, { id: '0608', nombre: 'JAÉN' }, { id: '0609', nombre: 'SAN IGNACIO' }, { id: '0610', nombre: 'SAN MARCOS' }, { id: '0611', nombre: 'SAN MIGUEL' }, { id: '0612', nombre: 'SAN PABLO' }, { id: '0613', nombre: 'SANTA CRUZ' }],
        '07': [{ id: '0701', nombre: 'PROV. CONST. DEL CALLAO' }],
        '08': [{ id: '0801', nombre: 'CUSCO' }, { id: '0802', nombre: 'ACOMAYO' }, { id: '0803', nombre: 'ANTA' }, { id: '0804', nombre: 'CALCA' }, { id: '0805', nombre: 'CANAS' }, { id: '0806', nombre: 'CANCHIS' }, { id: '0807', nombre: 'CHUMBIVILCAS' }, { id: '0808', nombre: 'ESPINAR' }, { id: '0809', nombre: 'LA CONVENCIÓN' }, { id: '0810', nombre: 'PARURO' }, { id: '0811', nombre: 'PAUCARTAMBO' }, { id: '0812', nombre: 'QUISPICANCHI' }, { id: '0813', nombre: 'URUBAMBA' }],
        '09': [{ id: '0901', nombre: 'HUANCAVELICA' }, { id: '0902', nombre: 'ACOBAMBA' }, { id: '0903', nombre: 'ANGARAES' }, { id: '0904', nombre: 'CASTROVIRREYNA' }, { id: '0905', nombre: 'CHURCAMPA' }, { id: '0906', nombre: 'HUAYTARÁ' }, { id: '0907', nombre: 'TAYACAJA' }],
        '10': [{ id: '1001', nombre: 'HUÁNUCO' }, { id: '1002', nombre: 'AMBO' }, { id: '1003', nombre: 'DOS DE MAYO' }, { id: '1004', nombre: 'HUACAYBAMBA' }, { id: '1005', nombre: 'HUAMALÍES' }, { id: '1006', nombre: 'LEONCIO PRADO' }, { id: '1007', nombre: 'MARAÑÓN' }, { id: '1008', nombre: 'PACHITEA' }, { id: '1009', nombre: 'PUERTO INCA' }, { id: '1010', nombre: 'LAURICOCHA' }, { id: '1011', nombre: 'YAROWILCA' }],
        '11': [{ id: '1101', nombre: 'ICA' }, { id: '1102', nombre: 'CHINCHA' }, { id: '1103', nombre: 'NASCA' }, { id: '1104', nombre: 'PALPA' }, { id: '1105', nombre: 'PISCO' }],
        '12': [{ id: '1201', nombre: 'HUANCAYO' }, { id: '1202', nombre: 'CONCEPCIÓN' }, { id: '1203', nombre: 'CHANCHAMAYO' }, { id: '1204', nombre: 'JAUJA' }, { id: '1205', nombre: 'JUNÍN' }, { id: '1206', nombre: 'SATIPO' }, { id: '1207', nombre: 'TARMA' }, { id: '1208', nombre: 'YAULI' }, { id: '1209', nombre: 'CHUPACA' }],
        '13': [{ id: '1301', nombre: 'TRUJILLO' }, { id: '1302', nombre: 'ASCOPE' }, { id: '1303', nombre: 'BOLÍVAR' }, { id: '1304', nombre: 'CHEPÉN' }, { id: '1305', nombre: 'JULCÁN' }, { id: '1306', nombre: 'OTUZCO' }, { id: '1307', nombre: 'PACASMAYO' }, { id: '1308', nombre: 'PATAZ' }, { id: '1309', nombre: 'SÁNCHEZ CARRIÓN' }, { id: '1310', nombre: 'SANTIAGO DE CHUCO' }, { id: '1311', nombre: 'GRAN CHIMÚ' }, { id: '1312', nombre: 'VIRÚ' }],
        '14': [{ id: '1401', nombre: 'CHICLAYO' }, { id: '1402', nombre: 'FERREÑAFE' }, { id: '1403', nombre: 'LAMBAYEQUE' }],
        '15': [{ id: '1501', nombre: 'LIMA' }, { id: '1502', nombre: 'BARRANCA' }, { id: '1503', nombre: 'CAJATAMBO' }, { id: '1504', nombre: 'CANTA' }, { id: '1505', nombre: 'CAÑETE' }, { id: '1506', nombre: 'HUARAL' }, { id: '1507', nombre: 'HUAROCHIRÍ' }, { id: '1508', nombre: 'HUAURA' }, { id: '1509', nombre: 'OYÓN' }, { id: '1510', nombre: 'YAUYOS' }],
        '16': [{ id: '1601', nombre: 'MAYNAS' }, { id: '1602', nombre: 'ALTO AMAZONAS' }, { id: '1603', nombre: 'LORETO' }, { id: '1604', nombre: 'MARISCAL RAMÓN CASTILLA' }, { id: '1605', nombre: 'REQUENA' }, { id: '1606', nombre: 'UCAYALI' }, { id: '1607', nombre: 'DATEM DEL MARAÑÓN' }, { id: '1608', nombre: 'PUTUMAYO' }],
        '17': [{ id: '1701', nombre: 'TAMBOPATA' }, { id: '1702', nombre: 'MANU' }, { id: '1703', nombre: 'TAHUAMANU' }],
        '18': [{ id: '1801', nombre: 'MARISCAL NIETO' }, { id: '1802', nombre: 'GENERAL SÁNCHEZ CERRO' }, { id: '1803', nombre: 'ILO' }],
        '19': [{ id: '1901', nombre: 'PASCO' }, { id: '1902', nombre: 'DANIEL ALCIDES CARRIÓN' }, { id: '1903', nombre: 'OXAPAMPA' }],
        '20': [{ id: '2001', nombre: 'PIURA' }, { id: '2002', nombre: 'AYABACA' }, { id: '2003', nombre: 'HUANCABAMBA' }, { id: '2004', nombre: 'MORROPÓN' }, { id: '2005', nombre: 'PAITA' }, { id: '2006', nombre: 'SULLANA' }, { id: '2007', nombre: 'TALARA' }, { id: '2008', nombre: 'SECHURA' }],
        '21': [{ id: '2101', nombre: 'PUNO' }, { id: '2102', nombre: 'AZÁNGARO' }, { id: '2103', nombre: 'CARABAYA' }, { id: '2104', nombre: 'CHUCUITO' }, { id: '2105', nombre: 'EL COLLAO' }, { id: '2106', nombre: 'HUANCANÉ' }, { id: '2107', nombre: 'LAMPA' }, { id: '2108', nombre: 'MELGAR' }, { id: '2109', nombre: 'MOHO' }, { id: '2110', nombre: 'SAN ANTONIO DE PUTINA' }, { id: '2111', nombre: 'SAN ROMÁN' }, { id: '2112', nombre: 'SANDIA' }, { id: '2113', nombre: 'YUNGUYO' }],
        '22': [{ id: '2201', nombre: 'MOYOBAMBA' }, { id: '2202', nombre: 'BELLAVISTA' }, { id: '2203', nombre: 'EL DORADO' }, { id: '2204', nombre: 'HUALLAGA' }, { id: '2205', nombre: 'LAMAS' }, { id: '2206', nombre: 'MARISCAL CÁCERES' }, { id: '2207', nombre: 'PICOTA' }, { id: '2208', nombre: 'RIOJA' }, { id: '2209', nombre: 'SAN MARTÍN' }, { id: '2210', nombre: 'TOCACHE' }],
        '23': [{ id: '2301', nombre: 'TACNA' }, { id: '2302', nombre: 'CANDARAVE' }, { id: '2303', nombre: 'JORGE BASADRE' }, { id: '2304', nombre: 'TARATA' }],
        '24': [{ id: '2401', nombre: 'TUMBES' }, { id: '2402', nombre: 'CONTRALMIRANTE VILLAR' }, { id: '2403', nombre: 'ZARUMILLA' }],
        '25': [{ id: '2501', nombre: 'CORONEL PORTILLO' }, { id: '2502', nombre: 'ATALAYA' }, { id: '2503', nombre: 'PADRE ABAD' }, { id: '2504', nombre: 'PURÚS' }]
      },
      listaDistritos: {
        '': [{ id: '', nombre: '' }],
        '0101': [{ id: '010101', nombre: 'CHACHAPOYAS' }, { id: '010102', nombre: 'ASUNCIÓN' }, { id: '010103', nombre: 'BALSAS' }, { id: '010104', nombre: 'CHETO' }, { id: '010105', nombre: 'CHILIQUIN' }, { id: '010106', nombre: 'CHUQUIBAMBA' }, { id: '010107', nombre: 'GRANADA' }, { id: '010108', nombre: 'HUANCAS' }, { id: '010109', nombre: 'LA JALCA' }, { id: '010110', nombre: 'LEIMEBAMBA' }, { id: '010111', nombre: 'LEVANTO' }, { id: '010112', nombre: 'MAGDALENA' }, { id: '010113', nombre: 'MARISCAL CASTILLA' }, { id: '010114', nombre: 'MOLINOPAMPA' }, { id: '010115', nombre: 'MONTEVIDEO' }, { id: '010116', nombre: 'OLLEROS' }, { id: '010117', nombre: 'QUINJALCA' }, { id: '010118', nombre: 'SAN FRANCISCO DE DAGUAS' }, { id: '010119', nombre: 'SAN ISIDRO DE MAINO' }, { id: '010120', nombre: 'SOLOCO' }, { id: '010121', nombre: 'SONCHE' }],
        '0102': [{ id: '010201', nombre: 'BAGUA' }, { id: '010202', nombre: 'ARAMANGO' }, { id: '010203', nombre: 'COPALLIN' }, { id: '010204', nombre: 'EL PARCO' }, { id: '010205', nombre: 'IMAZA' }, { id: '010206', nombre: 'LA PECA' }],
        '0103': [{ id: '010301', nombre: 'JUMBILLA' }, { id: '010302', nombre: 'CHISQUILLA' }, { id: '010303', nombre: 'CHURUJA' }, { id: '010304', nombre: 'COROSHA' }, { id: '010305', nombre: 'CUISPES' }, { id: '010306', nombre: 'FLORIDA' }, { id: '010307', nombre: 'JAZAN' }, { id: '010308', nombre: 'RECTA' }, { id: '010309', nombre: 'SAN CARLOS' }, { id: '010310', nombre: 'SHIPASBAMBA' }, { id: '010311', nombre: 'VALERA' }, { id: '010312', nombre: 'YAMBRASBAMBA' }],
        '0104': [{ id: '010401', nombre: 'NIEVA' }, { id: '010402', nombre: 'EL CENEPA' }, { id: '010403', nombre: 'RÍO SANTIAGO' }],
        '0105': [{ id: '010501', nombre: 'LAMUD' }, { id: '010502', nombre: 'CAMPORREDONDO' }, { id: '010503', nombre: 'COCABAMBA' }, { id: '010504', nombre: 'COLCAMAR' }, { id: '010505', nombre: 'CONILA' }, { id: '010506', nombre: 'INGUILPATA' }, { id: '010507', nombre: 'LONGUITA' }, { id: '010508', nombre: 'LONYA CHICO' }, { id: '010509', nombre: 'LUYA' }, { id: '010510', nombre: 'LUYA VIEJO' }, { id: '010511', nombre: 'MARÍA' }, { id: '010512', nombre: 'OCALLI' }, { id: '010513', nombre: 'OCUMAL' }, { id: '010514', nombre: 'PISUQUIA' }, { id: '010515', nombre: 'PROVIDENCIA' }, { id: '010516', nombre: 'SAN CRISTÓBAL' }, { id: '010517', nombre: 'SAN FRANCISCO DE YESO' }, { id: '010518', nombre: 'SAN JERÓNIMO' }, { id: '010519', nombre: 'SAN JUAN DE LOPECANCHA' }, { id: '010520', nombre: 'SANTA CATALINA' }, { id: '010521', nombre: 'SANTO TOMAS' }, { id: '010522', nombre: 'TINGO' }, { id: '010523', nombre: 'TRITA' }],
        '0106': [{ id: '010601', nombre: 'SAN NICOLÁS' }, { id: '010602', nombre: 'CHIRIMOTO' }, { id: '010603', nombre: 'COCHAMAL' }, { id: '010604', nombre: 'HUAMBO' }, { id: '010605', nombre: 'LIMABAMBA' }, { id: '010606', nombre: 'LONGAR' }, { id: '010607', nombre: 'MARISCAL BENAVIDES' }, { id: '010608', nombre: 'MILPUC' }, { id: '010609', nombre: 'OMIA' }, { id: '010610', nombre: 'SANTA ROSA' }, { id: '010611', nombre: 'TOTORA' }, { id: '010612', nombre: 'VISTA ALEGRE' }],
        '0107': [{ id: '010701', nombre: 'BAGUA GRANDE' }, { id: '010702', nombre: 'CAJARURO' }, { id: '010703', nombre: 'CUMBA' }, { id: '010704', nombre: 'EL MILAGRO' }, { id: '010705', nombre: 'JAMALCA' }, { id: '010706', nombre: 'LONYA GRANDE' }, { id: '010707', nombre: 'YAMON' }],
        '0201': [{ id: '020101', nombre: 'HUARAZ' }, { id: '020102', nombre: 'COCHABAMBA' }, { id: '020103', nombre: 'COLCABAMBA' }, { id: '020104', nombre: 'HUANCHAY' }, { id: '020105', nombre: 'INDEPENDENCIA' }, { id: '020106', nombre: 'JANGAS' }, { id: '020107', nombre: 'LA LIBERTAD' }, { id: '020108', nombre: 'OLLEROS' }, { id: '020109', nombre: 'PAMPAS GRANDE' }, { id: '020110', nombre: 'PARIACOTO' }, { id: '020111', nombre: 'PIRA' }, { id: '020112', nombre: 'TARICA' }],
        '0202': [{ id: '020201', nombre: 'AIJA' }, { id: '020202', nombre: 'CORIS' }, { id: '020203', nombre: 'HUACLLAN' }, { id: '020204', nombre: 'LA MERCED' }, { id: '020205', nombre: 'SUCCHA' }],
        '0203': [{ id: '020301', nombre: 'LLAMELLIN' }, { id: '020302', nombre: 'ACZO' }, { id: '020303', nombre: 'CHACCHO' }, { id: '020304', nombre: 'CHINGAS' }, { id: '020305', nombre: 'MIRGAS' }, { id: '020306', nombre: 'SAN JUAN DE RONTOY' }],
        '0204': [{ id: '020401', nombre: 'CHACAS' }, { id: '020402', nombre: 'ACOCHACA' }],
        '0205': [{ id: '020501', nombre: 'CHIQUIAN' }, { id: '020502', nombre: 'ABELARDO PARDO LEZAMETA' }, { id: '020503', nombre: 'ANTONIO RAYMONDI' }, { id: '020504', nombre: 'AQUIA' }, { id: '020505', nombre: 'CAJACAY' }, { id: '020506', nombre: 'CANIS' }, { id: '020507', nombre: 'COLQUIOC' }, { id: '020508', nombre: 'HUALLANCA' }, { id: '020509', nombre: 'HUASTA' }, { id: '020510', nombre: 'HUAYLLACAYAN' }, { id: '020511', nombre: 'LA PRIMAVERA' }, { id: '020512', nombre: 'MANGAS' }, { id: '020513', nombre: 'PACLLON' }, { id: '020514', nombre: 'SAN MIGUEL DE CORPANQUI' }, { id: '020515', nombre: 'TICLLOS' }],
        '0206': [{ id: '020601', nombre: 'CARHUAZ' }, { id: '020602', nombre: 'ACOPAMPA' }, { id: '020603', nombre: 'AMASHCA' }, { id: '020604', nombre: 'ANTA' }, { id: '020605', nombre: 'ATAQUERO' }, { id: '020606', nombre: 'MARCARA' }, { id: '020607', nombre: 'PARIAHUANCA' }, { id: '020608', nombre: 'SAN MIGUEL DE ACO' }, { id: '020609', nombre: 'SHILLA' }, { id: '020610', nombre: 'TINCO' }, { id: '020611', nombre: 'YUNGAR' }],
        '0207': [{ id: '020701', nombre: 'SAN LUIS' }, { id: '020702', nombre: 'SAN NICOLÁS' }, { id: '020703', nombre: 'YAUYA' }],
        '0208': [{ id: '020801', nombre: 'CASMA' }, { id: '020802', nombre: 'BUENA VISTA ALTA' }, { id: '020803', nombre: 'COMANDANTE NOEL' }, { id: '020804', nombre: 'YAUTAN' }],
        '0209': [{ id: '020901', nombre: 'CORONGO' }, { id: '020902', nombre: 'ACO' }, { id: '020903', nombre: 'BAMBAS' }, { id: '020904', nombre: 'CUSCA' }, { id: '020905', nombre: 'LA PAMPA' }, { id: '020906', nombre: 'YANAC' }, { id: '020907', nombre: 'YUPAN' }],
        '0210': [{ id: '021001', nombre: 'HUARI' }, { id: '021002', nombre: 'ANRA' }, { id: '021003', nombre: 'CAJAY' }, { id: '021004', nombre: 'CHAVIN DE HUANTAR' }, { id: '021005', nombre: 'HUACACHI' }, { id: '021006', nombre: 'HUACCHIS' }, { id: '021007', nombre: 'HUACHIS' }, { id: '021008', nombre: 'HUANTAR' }, { id: '021009', nombre: 'MASIN' }, { id: '021010', nombre: 'PAUCAS' }, { id: '021011', nombre: 'PONTO' }, { id: '021012', nombre: 'RAHUAPAMPA' }, { id: '021013', nombre: 'RAPAYAN' }, { id: '021014', nombre: 'SAN MARCOS' }, { id: '021015', nombre: 'SAN PEDRO DE CHANA' }, { id: '021016', nombre: 'UCO' }],
        '0211': [{ id: '021101', nombre: 'HUARMEY' }, { id: '021102', nombre: 'COCHAPETI' }, { id: '021103', nombre: 'CULEBRAS' }, { id: '021104', nombre: 'HUAYAN' }, { id: '021105', nombre: 'MALVAS' }],
        '0212': [{ id: '021201', nombre: 'CARAZ' }, { id: '021202', nombre: 'HUALLANCA' }, { id: '021203', nombre: 'HUATA' }, { id: '021204', nombre: 'HUAYLAS' }, { id: '021205', nombre: 'MATO' }, { id: '021206', nombre: 'PAMPAROMAS' }, { id: '021207', nombre: 'PUEBLO LIBRE' }, { id: '021208', nombre: 'SANTA CRUZ' }, { id: '021209', nombre: 'SANTO TORIBIO' }, { id: '021210', nombre: 'YURACMARCA' }],
        '0213': [{ id: '021301', nombre: 'PISCOBAMBA' }, { id: '021302', nombre: 'CASCA' }, { id: '021303', nombre: 'ELEAZAR GUZMÁN BARRON' }, { id: '021304', nombre: 'FIDEL OLIVAS ESCUDERO' }, { id: '021305', nombre: 'LLAMA' }, { id: '021306', nombre: 'LLUMPA' }, { id: '021307', nombre: 'LUCMA' }, { id: '021308', nombre: 'MUSGA' }],
        '0214': [{ id: '021401', nombre: 'OCROS' }, { id: '021402', nombre: 'ACAS' }, { id: '021403', nombre: 'CAJAMARQUILLA' }, { id: '021404', nombre: 'CARHUAPAMPA' }, { id: '021405', nombre: 'COCHAS' }, { id: '021406', nombre: 'CONGAS' }, { id: '021407', nombre: 'LLIPA' }, { id: '021408', nombre: 'SAN CRISTÓBAL DE RAJAN' }, { id: '021409', nombre: 'SAN PEDRO' }, { id: '021410', nombre: 'SANTIAGO DE CHILCAS' }],
        '0215': [{ id: '021501', nombre: 'CABANA' }, { id: '021502', nombre: 'BOLOGNESI' }, { id: '021503', nombre: 'CONCHUCOS' }, { id: '021504', nombre: 'HUACASCHUQUE' }, { id: '021505', nombre: 'HUANDOVAL' }, { id: '021506', nombre: 'LACABAMBA' }, { id: '021507', nombre: 'LLAPO' }, { id: '021508', nombre: 'PALLASCA' }, { id: '021509', nombre: 'PAMPAS' }, { id: '021510', nombre: 'SANTA ROSA' }, { id: '021511', nombre: 'TAUCA' }],
        '0216': [{ id: '021601', nombre: 'POMABAMBA' }, { id: '021602', nombre: 'HUAYLLAN' }, { id: '021603', nombre: 'PAROBAMBA' }, { id: '021604', nombre: 'QUINUABAMBA' }],
        '0217': [{ id: '021701', nombre: 'RECUAY' }, { id: '021702', nombre: 'CATAC' }, { id: '021703', nombre: 'COTAPARACO' }, { id: '021704', nombre: 'HUAYLLAPAMPA' }, { id: '021705', nombre: 'LLACLLIN' }, { id: '021706', nombre: 'MARCA' }, { id: '021707', nombre: 'PAMPAS CHICO' }, { id: '021708', nombre: 'PARARIN' }, { id: '021709', nombre: 'TAPACOCHA' }, { id: '021710', nombre: 'TICAPAMPA' }],
        '0218': [{ id: '021801', nombre: 'CHIMBOTE' }, { id: '021802', nombre: 'CÁCERES DEL PERÚ' }, { id: '021803', nombre: 'COISHCO' }, { id: '021804', nombre: 'MACATE' }, { id: '021805', nombre: 'MORO' }, { id: '021806', nombre: 'NEPEÑA' }, { id: '021807', nombre: 'SAMANCO' }, { id: '021808', nombre: 'SANTA' }, { id: '021809', nombre: 'NUEVO CHIMBOTE' }],
        '0219': [{ id: '021901', nombre: 'SIHUAS' }, { id: '021902', nombre: 'ACOBAMBA' }, { id: '021903', nombre: 'ALFONSO UGARTE' }, { id: '021904', nombre: 'CASHAPAMPA' }, { id: '021905', nombre: 'CHINGALPO' }, { id: '021906', nombre: 'HUAYLLABAMBA' }, { id: '021907', nombre: 'QUICHES' }, { id: '021908', nombre: 'RAGASH' }, { id: '021909', nombre: 'SAN JUAN' }, { id: '021910', nombre: 'SICSIBAMBA' }],
        '0220': [{ id: '022001', nombre: 'YUNGAY' }, { id: '022002', nombre: 'CASCAPARA' }, { id: '022003', nombre: 'MANCOS' }, { id: '022004', nombre: 'MATACOTO' }, { id: '022005', nombre: 'QUILLO' }, { id: '022006', nombre: 'RANRAHIRCA' }, { id: '022007', nombre: 'SHUPLUY' }, { id: '022008', nombre: 'YANAMA' }],
        '0301': [{ id: '030101', nombre: 'ABANCAY' }, { id: '030102', nombre: 'CHACOCHE' }, { id: '030103', nombre: 'CIRCA' }, { id: '030104', nombre: 'CURAHUASI' }, { id: '030105', nombre: 'HUANIPACA' }, { id: '030106', nombre: 'LAMBRAMA' }, { id: '030107', nombre: 'PICHIRHUA' }, { id: '030108', nombre: 'SAN PEDRO DE CACHORA' }, { id: '030109', nombre: 'TAMBURCO' }],
        '0302': [{ id: '030201', nombre: 'ANDAHUAYLAS' }, { id: '030202', nombre: 'ANDARAPA' }, { id: '030203', nombre: 'CHIARA' }, { id: '030204', nombre: 'HUANCARAMA' }, { id: '030205', nombre: 'HUANCARAY' }, { id: '030206', nombre: 'HUAYANA' }, { id: '030207', nombre: 'KISHUARA' }, { id: '030208', nombre: 'PACOBAMBA' }, { id: '030209', nombre: 'PACUCHA' }, { id: '030210', nombre: 'PAMPACHIRI' }, { id: '030211', nombre: 'POMACOCHA' }, { id: '030212', nombre: 'SAN ANTONIO DE CACHI' }, { id: '030213', nombre: 'SAN JERÓNIMO' }, { id: '030214', nombre: 'SAN MIGUEL DE CHACCRAMPA' }, { id: '030215', nombre: 'SANTA MARÍA DE CHICMO' }, { id: '030216', nombre: 'TALAVERA' }, { id: '030217', nombre: 'TUMAY HUARACA' }, { id: '030218', nombre: 'TURPO' }, { id: '030219', nombre: 'KAQUIABAMBA' }, { id: '030220', nombre: 'JOSÉ MARÍA ARGUEDAS' }],
        '0303': [{ id: '030301', nombre: 'ANTABAMBA' }, { id: '030302', nombre: 'EL ORO' }, { id: '030303', nombre: 'HUAQUIRCA' }, { id: '030304', nombre: 'JUAN ESPINOZA MEDRANO' }, { id: '030305', nombre: 'OROPESA' }, { id: '030306', nombre: 'PACHACONAS' }, { id: '030307', nombre: 'SABAINO' }],
        '0304': [{ id: '030401', nombre: 'CHALHUANCA' }, { id: '030402', nombre: 'CAPAYA' }, { id: '030403', nombre: 'CARAYBAMBA' }, { id: '030404', nombre: 'CHAPIMARCA' }, { id: '030405', nombre: 'COLCABAMBA' }, { id: '030406', nombre: 'COTARUSE' }, { id: '030407', nombre: 'IHUAYLLO' }, { id: '030408', nombre: 'JUSTO APU SAHUARAURA' }, { id: '030409', nombre: 'LUCRE' }, { id: '030410', nombre: 'POCOHUANCA' }, { id: '030411', nombre: 'SAN JUAN DE CHACÑA' }, { id: '030412', nombre: 'SAÑAYCA' }, { id: '030413', nombre: 'SORAYA' }, { id: '030414', nombre: 'TAPAIRIHUA' }, { id: '030415', nombre: 'TINTAY' }, { id: '030416', nombre: 'TORAYA' }, { id: '030417', nombre: 'YANACA' }],
        '0305': [{ id: '030501', nombre: 'TAMBOBAMBA' }, { id: '030502', nombre: 'COTABAMBAS' }, { id: '030503', nombre: 'COYLLURQUI' }, { id: '030504', nombre: 'HAQUIRA' }, { id: '030505', nombre: 'MARA' }, { id: '030506', nombre: 'CHALLHUAHUACHO' }],
        '0306': [{ id: '030601', nombre: 'CHINCHEROS' }, { id: '030602', nombre: 'ANCO_HUALLO' }, { id: '030603', nombre: 'COCHARCAS' }, { id: '030604', nombre: 'HUACCANA' }, { id: '030605', nombre: 'OCOBAMBA' }, { id: '030606', nombre: 'ONGOY' }, { id: '030607', nombre: 'URANMARCA' }, { id: '030608', nombre: 'RANRACANCHA' }, { id: '030609', nombre: 'ROCCHACC' }, { id: '030610', nombre: 'EL PORVENIR' }, { id: '030611', nombre: 'LOS CHANKAS' }],
        '0307': [{ id: '030701', nombre: 'CHUQUIBAMBILLA' }, { id: '030702', nombre: 'CURPAHUASI' }, { id: '030703', nombre: 'GAMARRA' }, { id: '030704', nombre: 'HUAYLLATI' }, { id: '030705', nombre: 'MAMARA' }, { id: '030706', nombre: 'MICAELA BASTIDAS' }, { id: '030707', nombre: 'PATAYPAMPA' }, { id: '030708', nombre: 'PROGRESO' }, { id: '030709', nombre: 'SAN ANTONIO' }, { id: '030710', nombre: 'SANTA ROSA' }, { id: '030711', nombre: 'TURPAY' }, { id: '030712', nombre: 'VILCABAMBA' }, { id: '030713', nombre: 'VIRUNDO' }, { id: '030714', nombre: 'CURASCO' }],
        '0401': [{ id: '040101', nombre: 'AREQUIPA' }, { id: '040102', nombre: 'ALTO SELVA ALEGRE' }, { id: '040103', nombre: 'CAYMA' }, { id: '040104', nombre: 'CERRO COLORADO' }, { id: '040105', nombre: 'CHARACATO' }, { id: '040106', nombre: 'CHIGUATA' }, { id: '040107', nombre: 'JACOBO HUNTER' }, { id: '040108', nombre: 'LA JOYA' }, { id: '040109', nombre: 'MARIANO MELGAR' }, { id: '040110', nombre: 'MIRAFLORES' }, { id: '040111', nombre: 'MOLLEBAYA' }, { id: '040112', nombre: 'PAUCARPATA' }, { id: '040113', nombre: 'POCSI' }, { id: '040114', nombre: 'POLOBAYA' }, { id: '040115', nombre: 'QUEQUEÑA' }, { id: '040116', nombre: 'SABANDIA' }, { id: '040117', nombre: 'SACHACA' }, { id: '040118', nombre: 'SAN JUAN DE SIGUAS' }, { id: '040119', nombre: 'SAN JUAN DE TARUCANI' }, { id: '040120', nombre: 'SANTA ISABEL DE SIGUAS' }, { id: '040121', nombre: 'SANTA RITA DE SIGUAS' }, { id: '040122', nombre: 'SOCABAYA' }, { id: '040123', nombre: 'TIABAYA' }, { id: '040124', nombre: 'UCHUMAYO' }, { id: '040125', nombre: 'VITOR' }, { id: '040126', nombre: 'YANAHUARA' }, { id: '040127', nombre: 'YARABAMBA' }, { id: '040128', nombre: 'YURA' }, { id: '040129', nombre: 'JOSÉ LUIS BUSTAMANTE Y RIVERO' }],
        '0402': [{ id: '040201', nombre: 'CAMANÁ' }, { id: '040202', nombre: 'JOSÉ MARÍA QUIMPER' }, { id: '040203', nombre: 'MARIANO NICOLÁS VALCÁRCEL' }, { id: '040204', nombre: 'MARISCAL CÁCERES' }, { id: '040205', nombre: 'NICOLÁS DE PIEROLA' }, { id: '040206', nombre: 'OCOÑA' }, { id: '040207', nombre: 'QUILCA' }, { id: '040208', nombre: 'SAMUEL PASTOR' }],
        '0403': [{ id: '040301', nombre: 'CARAVELÍ' }, { id: '040302', nombre: 'ACARÍ' }, { id: '040303', nombre: 'ATICO' }, { id: '040304', nombre: 'ATIQUIPA' }, { id: '040305', nombre: 'BELLA UNIÓN' }, { id: '040306', nombre: 'CAHUACHO' }, { id: '040307', nombre: 'CHALA' }, { id: '040308', nombre: 'CHAPARRA' }, { id: '040309', nombre: 'HUANUHUANU' }, { id: '040310', nombre: 'JAQUI' }, { id: '040311', nombre: 'LOMAS' }, { id: '040312', nombre: 'QUICACHA' }, { id: '040313', nombre: 'YAUCA' }],
        '0404': [{ id: '040401', nombre: 'APLAO' }, { id: '040402', nombre: 'ANDAGUA' }, { id: '040403', nombre: 'AYO' }, { id: '040404', nombre: 'CHACHAS' }, { id: '040405', nombre: 'CHILCAYMARCA' }, { id: '040406', nombre: 'CHOCO' }, { id: '040407', nombre: 'HUANCARQUI' }, { id: '040408', nombre: 'MACHAGUAY' }, { id: '040409', nombre: 'ORCOPAMPA' }, { id: '040410', nombre: 'PAMPACOLCA' }, { id: '040411', nombre: 'TIPAN' }, { id: '040412', nombre: 'UÑON' }, { id: '040413', nombre: 'URACA' }, { id: '040414', nombre: 'VIRACO' }],
        '0405': [{ id: '040501', nombre: 'CHIVAY' }, { id: '040502', nombre: 'ACHOMA' }, { id: '040503', nombre: 'CABANACONDE' }, { id: '040504', nombre: 'CALLALLI' }, { id: '040505', nombre: 'CAYLLOMA' }, { id: '040506', nombre: 'COPORAQUE' }, { id: '040507', nombre: 'HUAMBO' }, { id: '040508', nombre: 'HUANCA' }, { id: '040509', nombre: 'ICHUPAMPA' }, { id: '040510', nombre: 'LARI' }, { id: '040511', nombre: 'LLUTA' }, { id: '040512', nombre: 'MACA' }, { id: '040513', nombre: 'MADRIGAL' }, { id: '040514', nombre: 'SAN ANTONIO DE CHUCA' }, { id: '040515', nombre: 'SIBAYO' }, { id: '040516', nombre: 'TAPAY' }, { id: '040517', nombre: 'TISCO' }, { id: '040518', nombre: 'TUTI' }, { id: '040519', nombre: 'YANQUE' }, { id: '040520', nombre: 'MAJES' }, { id: '040521', nombre: 'MAJES' }],
        '0406': [{ id: '040601', nombre: 'CHUQUIBAMBA' }, { id: '040602', nombre: 'ANDARAY' }, { id: '040603', nombre: 'CAYARANI' }, { id: '040604', nombre: 'CHICHAS' }, { id: '040605', nombre: 'IRAY' }, { id: '040606', nombre: 'RÍO GRANDE' }, { id: '040607', nombre: 'SALAMANCA' }, { id: '040608', nombre: 'YANAQUIHUA' }],
        '0407': [{ id: '040701', nombre: 'MOLLENDO' }, { id: '040702', nombre: 'COCACHACRA' }, { id: '040703', nombre: 'DEAN VALDIVIA' }, { id: '040704', nombre: 'ISLAY' }, { id: '040705', nombre: 'MEJIA' }, { id: '040706', nombre: 'PUNTA DE BOMBÓN' }],
        '0408': [{ id: '040801', nombre: 'COTAHUASI' }, { id: '040802', nombre: 'ALCA' }, { id: '040803', nombre: 'CHARCANA' }, { id: '040804', nombre: 'HUAYNACOTAS' }, { id: '040805', nombre: 'PAMPAMARCA' }, { id: '040806', nombre: 'PUYCA' }, { id: '040807', nombre: 'QUECHUALLA' }, { id: '040808', nombre: 'SAYLA' }, { id: '040809', nombre: 'TAURIA' }, { id: '040810', nombre: 'TOMEPAMPA' }, { id: '040811', nombre: 'TORO' }],
        '0501': [{ id: '050101', nombre: 'AYACUCHO' }, { id: '050102', nombre: 'ACOCRO' }, { id: '050103', nombre: 'ACOS VINCHOS' }, { id: '050104', nombre: 'CARMEN ALTO' }, { id: '050105', nombre: 'CHIARA' }, { id: '050106', nombre: 'OCROS' }, { id: '050107', nombre: 'PACAYCASA' }, { id: '050108', nombre: 'QUINUA' }, { id: '050109', nombre: 'SAN JOSÉ DE TICLLAS' }, { id: '050110', nombre: 'SAN JUAN BAUTISTA' }, { id: '050111', nombre: 'SANTIAGO DE PISCHA' }, { id: '050112', nombre: 'SOCOS' }, { id: '050113', nombre: 'TAMBILLO' }, { id: '050114', nombre: 'VINCHOS' }, { id: '050115', nombre: 'JESÚS NAZARENO' }, { id: '050116', nombre: 'ANDRÉS AVELINO CÁCERES DORREGARAY' }],
        '0502': [{ id: '050201', nombre: 'CANGALLO' }, { id: '050202', nombre: 'CHUSCHI' }, { id: '050203', nombre: 'LOS MOROCHUCOS' }, { id: '050204', nombre: 'MARÍA PARADO DE BELLIDO' }, { id: '050205', nombre: 'PARAS' }, { id: '050206', nombre: 'TOTOS' }],
        '0503': [{ id: '050301', nombre: 'SANCOS' }, { id: '050302', nombre: 'CARAPO' }, { id: '050303', nombre: 'SACSAMARCA' }, { id: '050304', nombre: 'SANTIAGO DE LUCANAMARCA' }],
        '0504': [{ id: '050401', nombre: 'HUANTA' }, { id: '050402', nombre: 'AYAHUANCO' }, { id: '050403', nombre: 'HUAMANGUILLA' }, { id: '050404', nombre: 'IGUAIN' }, { id: '050405', nombre: 'LURICOCHA' }, { id: '050406', nombre: 'SANTILLANA' }, { id: '050407', nombre: 'SIVIA' }, { id: '050408', nombre: 'LLOCHEGUA' }, { id: '050409', nombre: 'CANAYRE' }, { id: '050410', nombre: 'UCHURACCAY' }, { id: '050411', nombre: 'PUCACOLPA' }, { id: '050412', nombre: 'CHACA' }],
        '0505': [{ id: '050501', nombre: 'SAN MIGUEL' }, { id: '050502', nombre: 'ANCO' }, { id: '050503', nombre: 'AYNA' }, { id: '050504', nombre: 'CHILCAS' }, { id: '050505', nombre: 'CHUNGUI' }, { id: '050506', nombre: 'LUIS CARRANZA' }, { id: '050507', nombre: 'SANTA ROSA' }, { id: '050508', nombre: 'TAMBO' }, { id: '050509', nombre: 'SAMUGARI' }, { id: '050510', nombre: 'ANCHIHUAY' }, { id: '050511', nombre: 'ORONCCOY' }],
        '0506': [{ id: '050601', nombre: 'PUQUIO' }, { id: '050602', nombre: 'AUCARA' }, { id: '050603', nombre: 'CABANA' }, { id: '050604', nombre: 'CARMEN SALCEDO' }, { id: '050605', nombre: 'CHAVIÑA' }, { id: '050606', nombre: 'CHIPAO' }, { id: '050607', nombre: 'HUAC-HUAS' }, { id: '050608', nombre: 'LARAMATE' }, { id: '050609', nombre: 'LEONCIO PRADO' }, { id: '050610', nombre: 'LLAUTA' }, { id: '050611', nombre: 'LUCANAS' }, { id: '050612', nombre: 'OCAÑA' }, { id: '050613', nombre: 'OTOCA' }, { id: '050614', nombre: 'SAISA' }, { id: '050615', nombre: 'SAN CRISTÓBAL' }, { id: '050616', nombre: 'SAN JUAN' }, { id: '050617', nombre: 'SAN PEDRO' }, { id: '050618', nombre: 'SAN PEDRO DE PALCO' }, { id: '050619', nombre: 'SANCOS' }, { id: '050620', nombre: 'SANTA ANA DE HUAYCAHUACHO' }, { id: '050621', nombre: 'SANTA LUCIA' }],
        '0507': [{ id: '050701', nombre: 'CORACORA' }, { id: '050702', nombre: 'CHUMPI' }, { id: '050703', nombre: 'CORONEL CASTAÑEDA' }, { id: '050704', nombre: 'PACAPAUSA' }, { id: '050705', nombre: 'PULLO' }, { id: '050706', nombre: 'PUYUSCA' }, { id: '050707', nombre: 'SAN FRANCISCO DE RAVACAYCO' }, { id: '050708', nombre: 'UPAHUACHO' }],
        '0508': [{ id: '050801', nombre: 'PAUSA' }, { id: '050802', nombre: 'COLTA' }, { id: '050803', nombre: 'CORCULLA' }, { id: '050804', nombre: 'LAMPA' }, { id: '050805', nombre: 'MARCABAMBA' }, { id: '050806', nombre: 'OYOLO' }, { id: '050807', nombre: 'PARARCA' }, { id: '050808', nombre: 'SAN JAVIER DE ALPABAMBA' }, { id: '050809', nombre: 'SAN JOSÉ DE USHUA' }, { id: '050810', nombre: 'SARA SARA' }],
        '0509': [{ id: '050901', nombre: 'QUEROBAMBA' }, { id: '050902', nombre: 'BELÉN' }, { id: '050903', nombre: 'CHALCOS' }, { id: '050904', nombre: 'CHILCAYOC' }, { id: '050905', nombre: 'HUACAÑA' }, { id: '050906', nombre: 'MORCOLLA' }, { id: '050907', nombre: 'PAICO' }, { id: '050908', nombre: 'SAN PEDRO DE LARCAY' }, { id: '050909', nombre: 'SAN SALVADOR DE QUIJE' }, { id: '050910', nombre: 'SANTIAGO DE PAUCARAY' }, { id: '050911', nombre: 'SORAS' }],
        '0510': [{ id: '051001', nombre: 'HUANCAPI' }, { id: '051002', nombre: 'ALCAMENCA' }, { id: '051003', nombre: 'APONGO' }, { id: '051004', nombre: 'ASQUIPATA' }, { id: '051005', nombre: 'CANARIA' }, { id: '051006', nombre: 'CAYARA' }, { id: '051007', nombre: 'COLCA' }, { id: '051008', nombre: 'HUAMANQUIQUIA' }, { id: '051009', nombre: 'HUANCARAYLLA' }, { id: '051010', nombre: 'HUAYA' }, { id: '051011', nombre: 'SARHUA' }, { id: '051012', nombre: 'VILCANCHOS' }],
        '0511': [{ id: '051101', nombre: 'VILCAS HUAMAN' }, { id: '051102', nombre: 'ACCOMARCA' }, { id: '051103', nombre: 'CARHUANCA' }, { id: '051104', nombre: 'CONCEPCIÓN' }, { id: '051105', nombre: 'HUAMBALPA' }, { id: '051106', nombre: 'INDEPENDENCIA' }, { id: '051107', nombre: 'SAURAMA' }, { id: '051108', nombre: 'VISCHONGO' }],
        '0601': [{ id: '060101', nombre: 'CAJAMARCA' }, { id: '060102', nombre: 'ASUNCIÓN' }, { id: '060103', nombre: 'CHETILLA' }, { id: '060104', nombre: 'COSPAN' }, { id: '060105', nombre: 'ENCAÑADA' }, { id: '060106', nombre: 'JESÚS' }, { id: '060107', nombre: 'LLACANORA' }, { id: '060108', nombre: 'LOS BAÑOS DEL INCA' }, { id: '060109', nombre: 'MAGDALENA' }, { id: '060110', nombre: 'MATARA' }, { id: '060111', nombre: 'NAMORA' }, { id: '060112', nombre: 'SAN JUAN' }, { id: '060113', nombre: 'CENTRO TURISTICO BAÑO' }],
        '0602': [{ id: '060201', nombre: 'CAJABAMBA' }, { id: '060202', nombre: 'CACHACHI' }, { id: '060203', nombre: 'CONDEBAMBA' }, { id: '060204', nombre: 'SITACOCHA' }],
        '0603': [{ id: '060301', nombre: 'CELENDÍN' }, { id: '060302', nombre: 'CHUMUCH' }, { id: '060303', nombre: 'CORTEGANA' }, { id: '060304', nombre: 'HUASMIN' }, { id: '060305', nombre: 'JORGE CHÁVEZ' }, { id: '060306', nombre: 'JOSÉ GÁLVEZ' }, { id: '060307', nombre: 'MIGUEL IGLESIAS' }, { id: '060308', nombre: 'OXAMARCA' }, { id: '060309', nombre: 'SOROCHUCO' }, { id: '060310', nombre: 'SUCRE' }, { id: '060311', nombre: 'UTCO' }, { id: '060312', nombre: 'LA LIBERTAD DE PALLAN' }],
        '0604': [{ id: '060401', nombre: 'CHOTA' }, { id: '060402', nombre: 'ANGUIA' }, { id: '060403', nombre: 'CHADIN' }, { id: '060404', nombre: 'CHIGUIRIP' }, { id: '060405', nombre: 'CHIMBAN' }, { id: '060406', nombre: 'CHOROPAMPA' }, { id: '060407', nombre: 'COCHABAMBA' }, { id: '060408', nombre: 'CONCHAN' }, { id: '060409', nombre: 'HUAMBOS' }, { id: '060410', nombre: 'LAJAS' }, { id: '060411', nombre: 'LLAMA' }, { id: '060412', nombre: 'MIRACOSTA' }, { id: '060413', nombre: 'PACCHA' }, { id: '060414', nombre: 'PION' }, { id: '060415', nombre: 'QUEROCOTO' }, { id: '060416', nombre: 'SAN JUAN DE LICUPIS' }, { id: '060417', nombre: 'TACABAMBA' }, { id: '060418', nombre: 'TOCMOCHE' }, { id: '060419', nombre: 'CHALAMARCA' }],
        '0605': [{ id: '060501', nombre: 'CONTUMAZA' }, { id: '060502', nombre: 'CHILETE' }, { id: '060503', nombre: 'CUPISNIQUE' }, { id: '060504', nombre: 'GUZMANGO' }, { id: '060505', nombre: 'SAN BENITO' }, { id: '060506', nombre: 'SANTA CRUZ DE TOLEDO' }, { id: '060507', nombre: 'TANTARICA' }, { id: '060508', nombre: 'YONAN' }],
        '0606': [{ id: '060601', nombre: 'CUTERVO' }, { id: '060602', nombre: 'CALLAYUC' }, { id: '060603', nombre: 'CHOROS' }, { id: '060604', nombre: 'CUJILLO' }, { id: '060605', nombre: 'LA RAMADA' }, { id: '060606', nombre: 'PIMPINGOS' }, { id: '060607', nombre: 'QUEROCOTILLO' }, { id: '060608', nombre: 'SAN ANDRÉS DE CUTERVO' }, { id: '060609', nombre: 'SAN JUAN DE CUTERVO' }, { id: '060610', nombre: 'SAN LUIS DE LUCMA' }, { id: '060611', nombre: 'SANTA CRUZ' }, { id: '060612', nombre: 'SANTO DOMINGO DE LA CAPILLA' }, { id: '060613', nombre: 'SANTO TOMAS' }, { id: '060614', nombre: 'SOCOTA' }, { id: '060615', nombre: 'TORIBIO CASANOVA' }],
        '0607': [{ id: '060701', nombre: 'BAMBAMARCA' }, { id: '060702', nombre: 'CHUGUR' }, { id: '060703', nombre: 'HUALGAYOC' }],
        '0608': [{ id: '060801', nombre: 'JAÉN' }, { id: '060802', nombre: 'BELLAVISTA' }, { id: '060803', nombre: 'CHONTALI' }, { id: '060804', nombre: 'COLASAY' }, { id: '060805', nombre: 'HUABAL' }, { id: '060806', nombre: 'LAS PIRIAS' }, { id: '060807', nombre: 'POMAHUACA' }, { id: '060808', nombre: 'PUCARA' }, { id: '060809', nombre: 'SALLIQUE' }, { id: '060810', nombre: 'SAN FELIPE' }, { id: '060811', nombre: 'SAN JOSÉ DEL ALTO' }, { id: '060812', nombre: 'SANTA ROSA' }],
        '0609': [{ id: '060901', nombre: 'SAN IGNACIO' }, { id: '060902', nombre: 'CHIRINOS' }, { id: '060903', nombre: 'HUARANGO' }, { id: '060904', nombre: 'LA COIPA' }, { id: '060905', nombre: 'NAMBALLE' }, { id: '060906', nombre: 'SAN JOSÉ DE LOURDES' }, { id: '060907', nombre: 'TABACONAS' }],
        '0610': [{ id: '061001', nombre: 'PEDRO GÁLVEZ' }, { id: '061002', nombre: 'CHANCAY' }, { id: '061003', nombre: 'EDUARDO VILLANUEVA' }, { id: '061004', nombre: 'GREGORIO PITA' }, { id: '061005', nombre: 'ICHOCAN' }, { id: '061006', nombre: 'JOSÉ MANUEL QUIROZ' }, { id: '061007', nombre: 'JOSÉ SABOGAL' }],
        '0611': [{ id: '061101', nombre: 'SAN MIGUEL' }, { id: '061102', nombre: 'BOLÍVAR' }, { id: '061103', nombre: 'CALQUIS' }, { id: '061104', nombre: 'CATILLUC' }, { id: '061105', nombre: 'EL PRADO' }, { id: '061106', nombre: 'LA FLORIDA' }, { id: '061107', nombre: 'LLAPA' }, { id: '061108', nombre: 'NANCHOC' }, { id: '061109', nombre: 'NIEPOS' }, { id: '061110', nombre: 'SAN GREGORIO' }, { id: '061111', nombre: 'SAN SILVESTRE DE COCHAN' }, { id: '061112', nombre: 'TONGOD' }, { id: '061113', nombre: 'UNIÓN AGUA BLANCA' }],
        '0612': [{ id: '061201', nombre: 'SAN PABLO' }, { id: '061202', nombre: 'SAN BERNARDINO' }, { id: '061203', nombre: 'SAN LUIS' }, { id: '061204', nombre: 'TUMBADEN' }],
        '0613': [{ id: '061301', nombre: 'SANTA CRUZ' }, { id: '061302', nombre: 'ANDABAMBA' }, { id: '061303', nombre: 'CATACHE' }, { id: '061304', nombre: 'CHANCAYBAÑOS' }, { id: '061305', nombre: 'LA ESPERANZA' }, { id: '061306', nombre: 'NINABAMBA' }, { id: '061307', nombre: 'PULAN' }, { id: '061308', nombre: 'SAUCEPAMPA' }, { id: '061309', nombre: 'SEXI' }, { id: '061310', nombre: 'UTICYACU' }, { id: '061311', nombre: 'YAUYUCAN' }],
        '0701': [{ id: '070101', nombre: 'CALLAO' }, { id: '070102', nombre: 'BELLAVISTA' }, { id: '070103', nombre: 'CARMEN DE LA LEGUA REYNOSO' }, { id: '070104', nombre: 'LA PERLA' }, { id: '070105', nombre: 'LA PUNTA' }, { id: '070106', nombre: 'VENTANILLA' }, { id: '070107', nombre: 'MI PERÚ' }],
        '0801': [{ id: '080101', nombre: 'CUSCO' }, { id: '080102', nombre: 'CCORCA' }, { id: '080103', nombre: 'POROY' }, { id: '080104', nombre: 'SAN JERÓNIMO' }, { id: '080105', nombre: 'SAN SEBASTIAN' }, { id: '080106', nombre: 'SANTIAGO' }, { id: '080107', nombre: 'SAYLLA' }, { id: '080108', nombre: 'WANCHAQ' }],
        '0802': [{ id: '080201', nombre: 'ACOMAYO' }, { id: '080202', nombre: 'ACOPIA' }, { id: '080203', nombre: 'ACOS' }, { id: '080204', nombre: 'MOSOC LLACTA' }, { id: '080205', nombre: 'POMACANCHI' }, { id: '080206', nombre: 'RONDOCAN' }, { id: '080207', nombre: 'SANGARARA' }],
        '0803': [{ id: '080301', nombre: 'ANTA' }, { id: '080302', nombre: 'ANCAHUASI' }, { id: '080303', nombre: 'CACHIMAYO' }, { id: '080304', nombre: 'CHINCHAYPUJIO' }, { id: '080305', nombre: 'HUAROCONDO' }, { id: '080306', nombre: 'LIMATAMBO' }, { id: '080307', nombre: 'MOLLEPATA' }, { id: '080308', nombre: 'PUCYURA' }, { id: '080309', nombre: 'ZURITE' }],
        '0804': [{ id: '080401', nombre: 'CALCA' }, { id: '080402', nombre: 'COYA' }, { id: '080403', nombre: 'LAMAY' }, { id: '080404', nombre: 'LARES' }, { id: '080405', nombre: 'PISAC' }, { id: '080406', nombre: 'SAN SALVADOR' }, { id: '080407', nombre: 'TARAY' }, { id: '080408', nombre: 'YANATILE' }],
        '0805': [{ id: '080501', nombre: 'YANAOCA' }, { id: '080502', nombre: 'CHECCA' }, { id: '080503', nombre: 'KUNTURKANKI' }, { id: '080504', nombre: 'LANGUI' }, { id: '080505', nombre: 'LAYO' }, { id: '080506', nombre: 'PAMPAMARCA' }, { id: '080507', nombre: 'QUEHUE' }, { id: '080508', nombre: 'TUPAC AMARU' }],
        '0806': [{ id: '080601', nombre: 'SICUANI' }, { id: '080602', nombre: 'CHECACUPE' }, { id: '080603', nombre: 'COMBAPATA' }, { id: '080604', nombre: 'MARANGANI' }, { id: '080605', nombre: 'PITUMARCA' }, { id: '080606', nombre: 'SAN PABLO' }, { id: '080607', nombre: 'SAN PEDRO' }, { id: '080608', nombre: 'TINTA' }],
        '0807': [{ id: '080701', nombre: 'SANTO TOMAS' }, { id: '080702', nombre: 'CAPACMARCA' }, { id: '080703', nombre: 'CHAMACA' }, { id: '080704', nombre: 'COLQUEMARCA' }, { id: '080705', nombre: 'LIVITACA' }, { id: '080706', nombre: 'LLUSCO' }, { id: '080707', nombre: 'QUIÑOTA' }, { id: '080708', nombre: 'VELILLE' }],
        '0808': [{ id: '080801', nombre: 'ESPINAR' }, { id: '080802', nombre: 'CONDOROMA' }, { id: '080803', nombre: 'COPORAQUE' }, { id: '080804', nombre: 'OCORURO' }, { id: '080805', nombre: 'PALLPATA' }, { id: '080806', nombre: 'PICHIGUA' }, { id: '080807', nombre: 'SUYCKUTAMBO' }, { id: '080808', nombre: 'ALTO PICHIGUA' }],
        '0809': [{ id: '080901', nombre: 'SANTA ANA' }, { id: '080902', nombre: 'ECHARATE' }, { id: '080903', nombre: 'HUAYOPATA' }, { id: '080904', nombre: 'MARANURA' }, { id: '080905', nombre: 'OCOBAMBA' }, { id: '080906', nombre: 'QUELLOUNO' }, { id: '080907', nombre: 'KIMBIRI' }, { id: '080908', nombre: 'SANTA TERESA' }, { id: '080909', nombre: 'VILCABAMBA' }, { id: '080910', nombre: 'PICHARI' }, { id: '080911', nombre: 'INKAWASI' }, { id: '080912', nombre: 'VILLA VIRGEN' }, { id: '080913', nombre: 'VILLA KINTIARINA' }, { id: '080914', nombre: 'MEGANTONI' }],
        '0810': [{ id: '081001', nombre: 'PARURO' }, { id: '081002', nombre: 'ACCHA' }, { id: '081003', nombre: 'CCAPI' }, { id: '081004', nombre: 'COLCHA' }, { id: '081005', nombre: 'HUANOQUITE' }, { id: '081006', nombre: 'OMACHA' }, { id: '081007', nombre: 'PACCARITAMBO' }, { id: '081008', nombre: 'PILLPINTO' }, { id: '081009', nombre: 'YAURISQUE' }],
        '0811': [{ id: '081101', nombre: 'PAUCARTAMBO' }, { id: '081102', nombre: 'CAICAY' }, { id: '081103', nombre: 'CHALLABAMBA' }, { id: '081104', nombre: 'COLQUEPATA' }, { id: '081105', nombre: 'HUANCARANI' }, { id: '081106', nombre: 'KOSÑIPATA' }],
        '0812': [{ id: '081201', nombre: 'URCOS' }, { id: '081202', nombre: 'ANDAHUAYLILLAS' }, { id: '081203', nombre: 'CAMANTI' }, { id: '081204', nombre: 'CCARHUAYO' }, { id: '081205', nombre: 'CCATCA' }, { id: '081206', nombre: 'CUSIPATA' }, { id: '081207', nombre: 'HUARO' }, { id: '081208', nombre: 'LUCRE' }, { id: '081209', nombre: 'MARCAPATA' }, { id: '081210', nombre: 'OCONGATE' }, { id: '081211', nombre: 'OROPESA' }, { id: '081212', nombre: 'QUIQUIJANA' }],
        '0813': [{ id: '081301', nombre: 'URUBAMBA' }, { id: '081302', nombre: 'CHINCHERO' }, { id: '081303', nombre: 'HUAYLLABAMBA' }, { id: '081304', nombre: 'MACHUPICCHU' }, { id: '081305', nombre: 'MARAS' }, { id: '081306', nombre: 'OLLANTAYTAMBO' }, { id: '081307', nombre: 'YUCAY' }],
        '0901': [{ id: '090101', nombre: 'HUANCAVELICA' }, { id: '090102', nombre: 'ACOBAMBILLA' }, { id: '090103', nombre: 'ACORIA' }, { id: '090104', nombre: 'CONAYCA' }, { id: '090105', nombre: 'CUENCA' }, { id: '090106', nombre: 'HUACHOCOLPA' }, { id: '090107', nombre: 'HUAYLLAHUARA' }, { id: '090108', nombre: 'IZCUCHACA' }, { id: '090109', nombre: 'LARIA' }, { id: '090110', nombre: 'MANTA' }, { id: '090111', nombre: 'MARISCAL CÁCERES' }, { id: '090112', nombre: 'MOYA' }, { id: '090113', nombre: 'NUEVO OCCORO' }, { id: '090114', nombre: 'PALCA' }, { id: '090115', nombre: 'PILCHACA' }, { id: '090116', nombre: 'VILCA' }, { id: '090117', nombre: 'YAULI' }, { id: '090118', nombre: 'ASCENSIÓN' }, { id: '090119', nombre: 'HUANDO' }],
        '0902': [{ id: '090201', nombre: 'ACOBAMBA' }, { id: '090202', nombre: 'ANDABAMBA' }, { id: '090203', nombre: 'ANTA' }, { id: '090204', nombre: 'CAJA' }, { id: '090205', nombre: 'MARCAS' }, { id: '090206', nombre: 'PAUCARA' }, { id: '090207', nombre: 'POMACOCHA' }, { id: '090208', nombre: 'ROSARIO' }],
        '0903': [{ id: '090301', nombre: 'LIRCAY' }, { id: '090302', nombre: 'ANCHONGA' }, { id: '090303', nombre: 'CALLANMARCA' }, { id: '090304', nombre: 'CCOCHACCASA' }, { id: '090305', nombre: 'CHINCHO' }, { id: '090306', nombre: 'CONGALLA' }, { id: '090307', nombre: 'HUANCA-HUANCA' }, { id: '090308', nombre: 'HUAYLLAY GRANDE' }, { id: '090309', nombre: 'JULCAMARCA' }, { id: '090310', nombre: 'SAN ANTONIO DE ANTAPARCO' }, { id: '090311', nombre: 'SANTO TOMAS DE PATA' }, { id: '090312', nombre: 'SECCLLA' }],
        '0904': [{ id: '090401', nombre: 'CASTROVIRREYNA' }, { id: '090402', nombre: 'ARMA' }, { id: '090403', nombre: 'AURAHUA' }, { id: '090404', nombre: 'CAPILLAS' }, { id: '090405', nombre: 'CHUPAMARCA' }, { id: '090406', nombre: 'COCAS' }, { id: '090407', nombre: 'HUACHOS' }, { id: '090408', nombre: 'HUAMATAMBO' }, { id: '090409', nombre: 'MOLLEPAMPA' }, { id: '090410', nombre: 'SAN JUAN' }, { id: '090411', nombre: 'SANTA ANA' }, { id: '090412', nombre: 'TANTARA' }, { id: '090413', nombre: 'TICRAPO' }],
        '0905': [{ id: '090501', nombre: 'CHURCAMPA' }, { id: '090502', nombre: 'ANCO' }, { id: '090503', nombre: 'CHINCHIHUASI' }, { id: '090504', nombre: 'EL CARMEN' }, { id: '090505', nombre: 'LA MERCED' }, { id: '090506', nombre: 'LOCROJA' }, { id: '090507', nombre: 'PAUCARBAMBA' }, { id: '090508', nombre: 'SAN MIGUEL DE MAYOCC' }, { id: '090509', nombre: 'SAN PEDRO DE CORIS' }, { id: '090510', nombre: 'PACHAMARCA' }, { id: '090511', nombre: 'COSME' }],
        '0906': [{ id: '090601', nombre: 'HUAYTARA' }, { id: '090602', nombre: 'AYAVI' }, { id: '090603', nombre: 'CÓRDOVA' }, { id: '090604', nombre: 'HUAYACUNDO ARMA' }, { id: '090605', nombre: 'LARAMARCA' }, { id: '090606', nombre: 'OCOYO' }, { id: '090607', nombre: 'PILPICHACA' }, { id: '090608', nombre: 'QUERCO' }, { id: '090609', nombre: 'QUITO-ARMA' }, { id: '090610', nombre: 'SAN ANTONIO DE CUSICANCHA' }, { id: '090611', nombre: 'SAN FRANCISCO DE SANGAYAICO' }, { id: '090612', nombre: 'SAN ISIDRO' }, { id: '090613', nombre: 'SANTIAGO DE CHOCORVOS' }, { id: '090614', nombre: 'SANTIAGO DE QUIRAHUARA' }, { id: '090615', nombre: 'SANTO DOMINGO DE CAPILLAS' }, { id: '090616', nombre: 'TAMBO' }],
        '0907': [{ id: '090701', nombre: 'PAMPAS' }, { id: '090702', nombre: 'ACOSTAMBO' }, { id: '090703', nombre: 'ACRAQUIA' }, { id: '090704', nombre: 'AHUAYCHA' }, { id: '090705', nombre: 'COLCABAMBA' }, { id: '090706', nombre: 'DANIEL HERNÁNDEZ' }, { id: '090707', nombre: 'HUACHOCOLPA' }, { id: '090708', nombre: 'HUANDO' }, { id: '090709', nombre: 'HUARIBAMBA' }, { id: '090710', nombre: 'ÑAHUIMPUQUIO' }, { id: '090711', nombre: 'PAZOS' }, { id: '090712', nombre: 'PACHAMARCA' }, { id: '090713', nombre: 'QUISHUAR' }, { id: '090714', nombre: 'SALCABAMBA' }, { id: '090715', nombre: 'SALCAHUASI' }, { id: '090716', nombre: 'SAN MARCOS DE ROCCHAC' }, { id: '090717', nombre: 'SURCUBAMBA' }, { id: '090718', nombre: 'TINTAY PUNCU' }, { id: '090719', nombre: 'QUICHUAS' }, { id: '090720', nombre: 'ANDAYMARCA' }, { id: '090721', nombre: 'ROBLE' }, { id: '090722', nombre: 'PICHOS' }, { id: '090723', nombre: 'SANTIAGO DE TUCUMA' }],
        '1001': [{ id: '100101', nombre: 'HUANUCO' }, { id: '100102', nombre: 'AMARILIS' }, { id: '100103', nombre: 'CHINCHAO' }, { id: '100104', nombre: 'CHURUBAMBA' }, { id: '100105', nombre: 'MARGOS' }, { id: '100106', nombre: 'QUISQUI (KICHKI)' }, { id: '100107', nombre: 'SAN FRANCISCO DE CAYRAN' }, { id: '100108', nombre: 'SAN PEDRO DE CHAULAN' }, { id: '100109', nombre: 'SANTA MARÍA DEL VALLE' }, { id: '100110', nombre: 'YARUMAYO' }, { id: '100111', nombre: 'PILLCO MARCA' }, { id: '100112', nombre: 'YACUS' }, { id: '100113', nombre: 'SAN PABLO DE PILLAO' }],
        '1002': [{ id: '100201', nombre: 'AMBO' }, { id: '100202', nombre: 'CAYNA' }, { id: '100203', nombre: 'COLPAS' }, { id: '100204', nombre: 'CONCHAMARCA' }, { id: '100205', nombre: 'HUACAR' }, { id: '100206', nombre: 'SAN FRANCISCO' }, { id: '100207', nombre: 'SAN RAFAEL' }, { id: '100208', nombre: 'TOMAY KICHWA' }],
        '1003': [{ id: '100301', nombre: 'LA UNIÓN' }, { id: '100302', nombre: 'APARICIO POMARES' }, { id: '100303', nombre: 'BAÑOS' }, { id: '100304', nombre: 'CAHUAC' }, { id: '100305', nombre: 'CHACABAMBA' }, { id: '100306', nombre: 'CHAVINILLO' }, { id: '100307', nombre: 'CHUQUIS' }, { id: '100308', nombre: 'JACAS CHICO' }, { id: '100309', nombre: 'JESUS' }, { id: '100310', nombre: 'JIVIA' }, { id: '100311', nombre: 'MARÍAS' }, { id: '100312', nombre: 'OBAS' }, { id: '100313', nombre: 'PACHAS' }, { id: '100314', nombre: 'PAMPAMARCA' }, { id: '100315', nombre: 'QUEROPALCA' }, { id: '100316', nombre: 'QUIVILLA' }, { id: '100317', nombre: 'RIPAN' }, { id: '100318', nombre: 'RONDOS' }, { id: '100319', nombre: 'SAN FRANCISCO DE ASIS' }, { id: '100320', nombre: 'SAN MIGUEL DE CAURI' }, { id: '100321', nombre: 'SHUNQUI' }, { id: '100322', nombre: 'SILLAPATA' }, { id: '100323', nombre: 'YANAS' }],
        '1004': [{ id: '100401', nombre: 'HUACAYBAMBA' }, { id: '100402', nombre: 'CANCHABAMBA' }, { id: '100403', nombre: 'COCHABAMBA' }, { id: '100404', nombre: 'PINRA' }],
        '1005': [{ id: '100501', nombre: 'LLATA' }, { id: '100502', nombre: 'ARANCAY' }, { id: '100503', nombre: 'CHAVÍN DE PARIARCA' }, { id: '100504', nombre: 'JACAS GRANDE' }, { id: '100505', nombre: 'JIRCAN' }, { id: '100506', nombre: 'MIRAFLORES' }, { id: '100507', nombre: 'MONZÓN' }, { id: '100508', nombre: 'PUNCHAO' }, { id: '100509', nombre: 'PUÑOS' }, { id: '100510', nombre: 'SINGA' }, { id: '100511', nombre: 'TANTAMAYO' }],
        '1006': [{ id: '100601', nombre: 'RUPA-RUPA' }, { id: '100602', nombre: 'DANIEL ALOMÍA ROBLES' }, { id: '100603', nombre: 'HERMÍLIO VALDIZAN' }, { id: '100604', nombre: 'JOSÉ CRESPO Y CASTILLO' }, { id: '100605', nombre: 'LUYANDO' }, { id: '100606', nombre: 'MARIANO DAMASO BERAUN' }, { id: '100607', nombre: 'PUCAYACU' }, { id: '100608', nombre: 'CASTILLO GRANDE' }, { id: '100609', nombre: 'PUEBLO NUEVO' }, { id: '100610', nombre: 'SANTO DOMINGO DE ANDA' }],
        '1007': [{ id: '100701', nombre: 'HUACRACHUCO' }, { id: '100702', nombre: 'CHOLON' }, { id: '100703', nombre: 'SAN BUENAVENTURA' }, { id: '100704', nombre: 'LA MORADA' }, { id: '100705', nombre: 'SANTA ROSA DE ALTO YANAJANCA' }],
        '1008': [{ id: '100801', nombre: 'PANAO' }, { id: '100802', nombre: 'CHAGLLA' }, { id: '100803', nombre: 'MOLINO' }, { id: '100804', nombre: 'UMARI' }],
        '1009': [{ id: '100901', nombre: 'PUERTO INCA' }, { id: '100902', nombre: 'CODO DEL POZUZO' }, { id: '100903', nombre: 'HONORIA' }, { id: '100904', nombre: 'TOURNAVISTA' }, { id: '100905', nombre: 'YUYAPICHIS' }],
        '1010': [{ id: '101001', nombre: 'JESÚS' }, { id: '101002', nombre: 'BAÑOS' }, { id: '101003', nombre: 'JIVIA' }, { id: '101004', nombre: 'QUEROPALCA' }, { id: '101005', nombre: 'RONDOS' }, { id: '101006', nombre: 'SAN FRANCISCO DE ASÍS' }, { id: '101007', nombre: 'SAN MIGUEL DE CAURI' }],
        '1011': [{ id: '101101', nombre: 'CHAVINILLO' }, { id: '101102', nombre: 'CAHUAC' }, { id: '101103', nombre: 'CHACABAMBA' }, { id: '101104', nombre: 'APARICIO POMARES' }, { id: '101105', nombre: 'JACAS CHICO' }, { id: '101106', nombre: 'OBAS' }, { id: '101107', nombre: 'PAMPAMARCA' }, { id: '101108', nombre: 'CHORAS' }],
        '1101': [{ id: '110101', nombre: 'ICA' }, { id: '110102', nombre: 'LA TINGUIÑA' }, { id: '110103', nombre: 'LOS AQUIJES' }, { id: '110104', nombre: 'OCUCAJE' }, { id: '110105', nombre: 'PACHACUTEC' }, { id: '110106', nombre: 'PARCONA' }, { id: '110107', nombre: 'PUEBLO NUEVO' }, { id: '110108', nombre: 'SALAS' }, { id: '110109', nombre: 'SAN JOSÉ DE LOS MOLINOS' }, { id: '110110', nombre: 'SAN JUAN BAUTISTA' }, { id: '110111', nombre: 'SANTIAGO' }, { id: '110112', nombre: 'SUBTANJALLA' }, { id: '110113', nombre: 'TATE' }, { id: '110114', nombre: 'YAUCA DEL ROSARIO' }],
        '1102': [{ id: '110201', nombre: 'CHINCHA ALTA' }, { id: '110202', nombre: 'ALTO LARAN' }, { id: '110203', nombre: 'CHAVIN' }, { id: '110204', nombre: 'CHINCHA BAJA' }, { id: '110205', nombre: 'EL CARMEN' }, { id: '110206', nombre: 'GROCIO PRADO' }, { id: '110207', nombre: 'PUEBLO NUEVO' }, { id: '110208', nombre: 'SAN JUAN DE YANAC' }, { id: '110209', nombre: 'SAN PEDRO DE HUACARPANA' }, { id: '110210', nombre: 'SUNAMPE' }, { id: '110211', nombre: 'TAMBO DE MORA' }],
        '1103': [{ id: '110301', nombre: 'NASCA' }, { id: '110302', nombre: 'CHANGUILLO' }, { id: '110303', nombre: 'EL INGENIO' }, { id: '110304', nombre: 'MARCONA' }, { id: '110305', nombre: 'VISTA ALEGRE' }],
        '1104': [{ id: '110401', nombre: 'PALPA' }, { id: '110402', nombre: 'LLIPATA' }, { id: '110403', nombre: 'RÍO GRANDE' }, { id: '110404', nombre: 'SANTA CRUZ' }, { id: '110405', nombre: 'TIBILLO' }],
        '1105': [{ id: '110501', nombre: 'PISCO' }, { id: '110502', nombre: 'HUANCANO' }, { id: '110503', nombre: 'HUMAY' }, { id: '110504', nombre: 'INDEPENDENCIA' }, { id: '110505', nombre: 'PARACAS' }, { id: '110506', nombre: 'SAN ANDRÉS' }, { id: '110507', nombre: 'SAN CLEMENTE' }, { id: '110508', nombre: 'TUPAC AMARU INCA' }],
        '1201': [{ id: '120101', nombre: 'HUANCAYO' }, { id: '120102', nombre: '3 DE DICIEMBRE' }, { id: '120103', nombre: 'AHUAC' }, { id: '120104', nombre: 'CARHUACALLANGA' }, { id: '120105', nombre: 'CHACAPAMPA' }, { id: '120106', nombre: 'CHICCHE' }, { id: '120107', nombre: 'CHILCA' }, { id: '120108', nombre: 'CHONGOS ALTO' }, { id: '120109', nombre: 'CHONGOS BAJO' }, { id: '120110', nombre: 'CHUPACA' }, { id: '120111', nombre: 'CHUPURO' }, { id: '120112', nombre: 'COLCA' }, { id: '120113', nombre: 'CULLHUAS' }, { id: '120114', nombre: 'EL TAMBO' }, { id: '120115', nombre: 'HUACHAC' }, { id: '120116', nombre: 'HUACRAPUQUIO' }, { id: '120117', nombre: 'HUALHUAS' }, { id: '120118', nombre: 'HUAMANCACA CHICO' }, { id: '120119', nombre: 'HUANCAN' }, { id: '120120', nombre: 'HUASICANCHA' }, { id: '120121', nombre: 'HUAYUCACHI' }, { id: '120122', nombre: 'INGENIO' }, { id: '120123', nombre: 'JARPA' }, { id: '120124', nombre: 'PARIAHUANCA' }, { id: '120125', nombre: 'PILCOMAYO' }, { id: '120126', nombre: 'PUCARA' }, { id: '120127', nombre: 'QUICHUAY' }, { id: '120128', nombre: 'QUILCAS' }, { id: '120129', nombre: 'SAN AGUSTÍN' }, { id: '120130', nombre: 'SAN JERÓNIMO DE TUNAN' }, { id: '120131', nombre: 'SAN JUAN DE YSCOS' }, { id: '120132', nombre: 'SAÑO' }, { id: '120133', nombre: 'SAPALLANGA' }, { id: '120134', nombre: 'SICAYA' }, { id: '120135', nombre: 'SANTO DOMINGO DE ACOBAMBA' }, { id: '120136', nombre: 'VIQUES' }, { id: '120137', nombre: 'YANACANCHA' }],
        '1202': [{ id: '120201', nombre: 'CONCEPCIÓN' }, { id: '120202', nombre: 'ACO' }, { id: '120203', nombre: 'ANDAMARCA' }, { id: '120204', nombre: 'CHAMBARA' }, { id: '120205', nombre: 'COCHAS' }, { id: '120206', nombre: 'COMAS' }, { id: '120207', nombre: 'HEROÍNAS TOLEDO' }, { id: '120208', nombre: 'MANZANARES' }, { id: '120209', nombre: 'MARISCAL CASTILLA' }, { id: '120210', nombre: 'MATAHUASI' }, { id: '120211', nombre: 'MITO' }, { id: '120212', nombre: 'NUEVE DE JULIO' }, { id: '120213', nombre: 'ORCOTUNA' }, { id: '120214', nombre: 'SAN JOSÉ DE QUERO' }, { id: '120215', nombre: 'SANTA ROSA DE OCOPA' }],
        '1203': [{ id: '120301', nombre: 'CHANCHAMAYO' }, { id: '120302', nombre: 'PERENE' }, { id: '120303', nombre: 'PICHANAQUI' }, { id: '120304', nombre: 'SAN LUIS DE SHUARO' }, { id: '120305', nombre: 'SAN RAMÓN' }, { id: '120306', nombre: 'VITOC' }],
        '1204': [{ id: '120401', nombre: 'JAUJA' }, { id: '120402', nombre: 'ACOLLA' }, { id: '120403', nombre: 'APATA' }, { id: '120404', nombre: 'ATAURA' }, { id: '120405', nombre: 'CANCHAYLLO' }, { id: '120406', nombre: 'CURICACA' }, { id: '120407', nombre: 'EL MANTARO' }, { id: '120408', nombre: 'HUAMALI' }, { id: '120409', nombre: 'HUARIPAMPA' }, { id: '120410', nombre: 'HUERTAS' }, { id: '120411', nombre: 'JANJAILLO' }, { id: '120412', nombre: 'JULCÁN' }, { id: '120413', nombre: 'LEONOR ORDÓÑEZ' }, { id: '120414', nombre: 'LLOCLLAPAMPA' }, { id: '120415', nombre: 'MARCO' }, { id: '120416', nombre: 'MASMA' }, { id: '120417', nombre: 'MASMA CHICCHE' }, { id: '120418', nombre: 'MOLINOS' }, { id: '120419', nombre: 'MONOBAMBA' }, { id: '120420', nombre: 'MUQUI' }, { id: '120421', nombre: 'MUQUIYAUYO' }, { id: '120422', nombre: 'PACA' }, { id: '120423', nombre: 'PACCHA' }, { id: '120424', nombre: 'PANCAN' }, { id: '120425', nombre: 'PARCO' }, { id: '120426', nombre: 'POMACANCHA' }, { id: '120427', nombre: 'RICRAN' }, { id: '120428', nombre: 'SAN LORENZO' }, { id: '120429', nombre: 'SAN PEDRO DE CHUNAN' }, { id: '120430', nombre: 'SAUSA' }, { id: '120431', nombre: 'SINCOS' }, { id: '120432', nombre: 'TUNAN MARCA' }, { id: '120433', nombre: 'YAULI' }, { id: '120434', nombre: 'YAUYOS' }],
        '1205': [{ id: '120501', nombre: 'JUNIN' }, { id: '120502', nombre: 'CARHUAMAYO' }, { id: '120503', nombre: 'ONDORES' }, { id: '120504', nombre: 'ULCUMAYO' }],
        '1206': [{ id: '120601', nombre: 'SATIPO' }, { id: '120602', nombre: 'COVIRIALI' }, { id: '120603', nombre: 'LLAYLLA' }, { id: '120604', nombre: 'MAZAMARI' }, { id: '120605', nombre: 'PAMPA HERMOSA' }, { id: '120606', nombre: 'PANGOA' }, { id: '120607', nombre: 'RÍO NEGRO' }, { id: '120608', nombre: 'RÍO TAMBO' }, { id: '120609', nombre: 'VIZCATAN DEL ENE' }],
        '1207': [{ id: '120701', nombre: 'TARMA' }, { id: '120702', nombre: 'ACOBAMBA' }, { id: '120703', nombre: 'HUARICOLCA' }, { id: '120704', nombre: 'HUASAHUASI' }, { id: '120705', nombre: 'LA UNIÓN' }, { id: '120706', nombre: 'PALCA' }, { id: '120707', nombre: 'PALCAMAYO' }, { id: '120708', nombre: 'SAN PEDRO DE CAJAS' }, { id: '120709', nombre: 'TAPO' }],
        '1208': [{ id: '120801', nombre: 'LA OROYA' }, { id: '120802', nombre: 'CHACAPALPA' }, { id: '120803', nombre: 'HUAY-HUAY' }, { id: '120804', nombre: 'MARCAPOMACOCHA' }, { id: '120805', nombre: 'MOROCOCHA' }, { id: '120806', nombre: 'PACCHA' }, { id: '120807', nombre: 'SANTA BÁRBARA DE CARHUACAYAN' }, { id: '120808', nombre: 'SANTA ROSA DE SACCO' }, { id: '120809', nombre: 'SUITUCANCHA' }, { id: '120810', nombre: 'YAULI' }],
        '1209': [{ id: '120901', nombre: 'CHUPACA' }, { id: '120902', nombre: 'AHUAC' }, { id: '120903', nombre: 'CHONGOS BAJO' }, { id: '120904', nombre: 'HUACHAC' }, { id: '120905', nombre: 'HUAMANCACA CHICO' }, { id: '120906', nombre: 'SAN JUAN DE ISCOS' }, { id: '120907', nombre: 'SAN JUAN DE JARPA' }, { id: '120908', nombre: 'TRES DE DICIEMBRE' }, { id: '120909', nombre: 'YANACANCHA' }],
        '1301': [{ id: '130101', nombre: 'TRUJILLO' }, { id: '130102', nombre: 'EL PORVENIR' }, { id: '130103', nombre: 'FLORENCIA DE MORA' }, { id: '130104', nombre: 'HUANCHACO' }, { id: '130105', nombre: 'LA ESPERANZA' }, { id: '130106', nombre: 'LAREDO' }, { id: '130107', nombre: 'MOCHE' }, { id: '130108', nombre: 'POROTO' }, { id: '130109', nombre: 'SALAVERRY' }, { id: '130110', nombre: 'SIMBAL' }, { id: '130111', nombre: 'VICTOR LARCO HERRERA' }, { id: '130112', nombre: 'VIRU' }, { id: '130113', nombre: 'CENTRO POBLADO MENOR VILL' }, { id: '130114', nombre: 'CENTRO POBLADO MENOR HUAN' }],
        '1302': [{ id: '130201', nombre: 'ASCOPE' }, { id: '130202', nombre: 'CHICAMA' }, { id: '130203', nombre: 'CHOCOPE' }, { id: '130204', nombre: 'MAGDALENA DE CAO' }, { id: '130205', nombre: 'PAIJAN' }, { id: '130206', nombre: 'RÁZURI' }, { id: '130207', nombre: 'SANTIAGO DE CAO' }, { id: '130208', nombre: 'CASA GRANDE' }],
        '1303': [{ id: '130301', nombre: 'BOLÍVAR' }, { id: '130302', nombre: 'BAMBAMARCA' }, { id: '130303', nombre: 'CONDORMARCA' }, { id: '130304', nombre: 'LONGOTEA' }, { id: '130305', nombre: 'UCHUMARCA' }, { id: '130306', nombre: 'UCUNCHA' }],
        '1304': [{ id: '130401', nombre: 'CHEPEN' }, { id: '130402', nombre: 'PACANGA' }, { id: '130403', nombre: 'PUEBLO NUEVO' }],
        '1305': [{ id: '130501', nombre: 'JULCAN' }, { id: '130502', nombre: 'CALAMARCA' }, { id: '130503', nombre: 'CARABAMBA' }, { id: '130504', nombre: 'HUASO' }],
        '1306': [{ id: '130601', nombre: 'OTUZCO' }, { id: '130602', nombre: 'AGALLPAMPA' }, { id: '130603', nombre: 'CASCAS' }, { id: '130604', nombre: 'CHARAT' }, { id: '130605', nombre: 'HUARANCHAL' }, { id: '130606', nombre: 'LA CUESTA' }, { id: '130607', nombre: 'LUCMA' }, { id: '130608', nombre: 'MACHE' }, { id: '130609', nombre: 'MARMOT (20)' }, { id: '130610', nombre: 'PARANDAY' }, { id: '130611', nombre: 'SALPO' }, { id: '130612', nombre: 'SAYAPULLO' }, { id: '130613', nombre: 'SINSICAP' }, { id: '130614', nombre: 'USQUIL' }],
        '1307': [{ id: '130701', nombre: 'SAN PEDRO DE LLOC' }, { id: '130702', nombre: 'GUADALUPE' }, { id: '130703', nombre: 'JEQUETEPEQUE' }, { id: '130704', nombre: 'PACASMAYO' }, { id: '130705', nombre: 'SAN JOSÉ' }],
        '1308': [{ id: '130801', nombre: 'TAYABAMBA' }, { id: '130802', nombre: 'BULDIBUYO' }, { id: '130803', nombre: 'CHILLIA' }, { id: '130804', nombre: 'HUANCASPATA' }, { id: '130805', nombre: 'HUAYLILLAS' }, { id: '130806', nombre: 'HUAYO' }, { id: '130807', nombre: 'ONGON' }, { id: '130808', nombre: 'PARCOY' }, { id: '130809', nombre: 'PATAZ' }, { id: '130810', nombre: 'PIAS' }, { id: '130811', nombre: 'SANTIAGO DE CHALLAS' }, { id: '130812', nombre: 'TAURIJA' }, { id: '130813', nombre: 'URPAY' }],
        '1309': [{ id: '130901', nombre: 'HUAMACHUCO' }, { id: '130902', nombre: 'CHUGAY' }, { id: '130903', nombre: 'COCHORCO' }, { id: '130904', nombre: 'CURGOS' }, { id: '130905', nombre: 'MARCABAL' }, { id: '130906', nombre: 'SANAGORAN' }, { id: '130907', nombre: 'SARIN' }, { id: '130908', nombre: 'SARTIMBAMBA' }],
        '1310': [{ id: '131001', nombre: 'SANTIAGO DE CHUCO' }, { id: '131002', nombre: 'ANGASMARCA' }, { id: '131003', nombre: 'CACHICADAN' }, { id: '131004', nombre: 'MOLLEBAMBA' }, { id: '131005', nombre: 'MOLLEPATA' }, { id: '131006', nombre: 'QUIRUVILCA' }, { id: '131007', nombre: 'SANTA CRUZ DE CHUCA' }, { id: '131008', nombre: 'SITABAMBA' }],
        '1311': [{ id: '131101', nombre: 'CASCAS' }, { id: '131102', nombre: 'LUCMA' }, { id: '131103', nombre: 'MARMOT' }, { id: '131104', nombre: 'SAYAPULLO' }],
        '1312': [{ id: '131201', nombre: 'VIRU' }, { id: '131202', nombre: 'CHAO' }, { id: '131203', nombre: 'GUADALUPITO' }],
        '1401': [{ id: '140101', nombre: 'CHICLAYO' }, { id: '140102', nombre: 'CHONGOYAPE' }, { id: '140103', nombre: 'ETEN' }, { id: '140104', nombre: 'ETEN PUERTO' }, { id: '140105', nombre: 'JOSÉ LEONARDO ORTIZ' }, { id: '140106', nombre: 'LA VICTORIA' }, { id: '140107', nombre: 'LAGUNAS' }, { id: '140108', nombre: 'MONSEFU' }, { id: '140109', nombre: 'NUEVA ARICA' }, { id: '140110', nombre: 'OYOTUN' }, { id: '140111', nombre: 'PICSI' }, { id: '140112', nombre: 'PIMENTEL' }, { id: '140113', nombre: 'REQUE' }, { id: '140114', nombre: 'SANTA ROSA' }, { id: '140115', nombre: 'SAÑA' }, { id: '140116', nombre: 'CAYALTI' }, { id: '140117', nombre: 'PATAPO' }, { id: '140118', nombre: 'POMALCA' }, { id: '140119', nombre: 'PUCALA' }, { id: '140120', nombre: 'TUMAN' }],
        '1402': [{ id: '140201', nombre: 'FERREÑAFE' }, { id: '140202', nombre: 'CAÑARIS' }, { id: '140203', nombre: 'INCAHUASI' }, { id: '140204', nombre: 'MANUEL ANTONIO MESONES MURO' }, { id: '140205', nombre: 'PITIPO' }, { id: '140206', nombre: 'PUEBLO NUEVO' }],
        '1403': [{ id: '140301', nombre: 'LAMBAYEQUE' }, { id: '140302', nombre: 'CHOCHOPE' }, { id: '140303', nombre: 'ILLIMO' }, { id: '140304', nombre: 'JAYANCA' }, { id: '140305', nombre: 'MOCHUMI' }, { id: '140306', nombre: 'MORROPE' }, { id: '140307', nombre: 'MOTUPE' }, { id: '140308', nombre: 'OLMOS' }, { id: '140309', nombre: 'PACORA' }, { id: '140310', nombre: 'SALAS' }, { id: '140311', nombre: 'SAN JOSÉ' }, { id: '140312', nombre: 'TUCUME' }],
        '1501': [{ id: '150101', nombre: 'LIMA' }, { id: '150102', nombre: 'ANCÓN' }, { id: '150103', nombre: 'ATE' }, { id: '150104', nombre: 'BARRANCO' }, { id: '150105', nombre: 'BREÑA' }, { id: '150106', nombre: 'CARABAYLLO' }, { id: '150107', nombre: 'CHACLACAYO' }, { id: '150108', nombre: 'CHORRILLOS' }, { id: '150109', nombre: 'CIENEGUILLA' }, { id: '150110', nombre: 'COMAS' }, { id: '150111', nombre: 'EL AGUSTINO' }, { id: '150112', nombre: 'INDEPENDENCIA' }, { id: '150113', nombre: 'JESÚS MARÍA' }, { id: '150114', nombre: 'LA MOLINA' }, { id: '150115', nombre: 'LA VICTORIA' }, { id: '150116', nombre: 'LINCE' }, { id: '150117', nombre: 'LOS OLIVOS' }, { id: '150118', nombre: 'LURIGANCHO' }, { id: '150119', nombre: 'LURIN' }, { id: '150120', nombre: 'MAGDALENA DEL MAR' }, { id: '150121', nombre: 'PUEBLO LIBRE' }, { id: '150122', nombre: 'MIRAFLORES' }, { id: '150123', nombre: 'PACHACAMAC' }, { id: '150124', nombre: 'PUCUSANA' }, { id: '150125', nombre: 'PUENTE PIEDRA' }, { id: '150126', nombre: 'PUNTA HERMOSA' }, { id: '150127', nombre: 'PUNTA NEGRA' }, { id: '150128', nombre: 'RÍMAC' }, { id: '150129', nombre: 'SAN BARTOLO' }, { id: '150130', nombre: 'SAN BORJA' }, { id: '150131', nombre: 'SAN ISIDRO' }, { id: '150132', nombre: 'SAN JUAN DE LURIGANCHO' }, { id: '150133', nombre: 'SAN JUAN DE MIRAFLORES' }, { id: '150134', nombre: 'SAN LUIS' }, { id: '150135', nombre: 'SAN MARTÍN DE PORRES' }, { id: '150136', nombre: 'SAN MIGUEL' }, { id: '150137', nombre: 'SANTA ANITA' }, { id: '150138', nombre: 'SANTA MARÍA DEL MAR' }, { id: '150139', nombre: 'SANTA ROSA' }, { id: '150140', nombre: 'SANTIAGO DE SURCO' }, { id: '150141', nombre: 'SURQUILLO' }, { id: '150142', nombre: 'VILLA EL SALVADOR' }, { id: '150143', nombre: 'VILLA MARÍA DEL TRIUNFO' }, { id: '150144', nombre: 'CENTRO POBLADO MENOR SAN' }],
        '1502': [{ id: '150201', nombre: 'BARRANCA' }, { id: '150202', nombre: 'PARAMONGA' }, { id: '150203', nombre: 'PATIVILCA' }, { id: '150204', nombre: 'SUPE' }, { id: '150205', nombre: 'SUPE PUERTO' }],
        '1503': [{ id: '150301', nombre: 'CAJATAMBO' }, { id: '150302', nombre: 'COPA' }, { id: '150303', nombre: 'GORGOR' }, { id: '150304', nombre: 'HUANCAPON' }, { id: '150305', nombre: 'MANAS' }],
        '1504': [{ id: '150401', nombre: 'CANTA' }, { id: '150402', nombre: 'ARAHUAY' }, { id: '150403', nombre: 'HUAMANTANGA' }, { id: '150404', nombre: 'HUAROS' }, { id: '150405', nombre: 'LACHAQUI' }, { id: '150406', nombre: 'SAN BUENAVENTURA' }, { id: '150407', nombre: 'SANTA ROSA DE QUIVES' }],
        '1505': [{ id: '150501', nombre: 'SAN VICENTE DE CAÑETE' }, { id: '150502', nombre: 'ASIA' }, { id: '150503', nombre: 'CALANGO' }, { id: '150504', nombre: 'CERRO AZUL' }, { id: '150505', nombre: 'CHILCA' }, { id: '150506', nombre: 'COAYLLO' }, { id: '150507', nombre: 'IMPERIAL' }, { id: '150508', nombre: 'LUNAHUANA' }, { id: '150509', nombre: 'MALA' }, { id: '150510', nombre: 'NUEVO IMPERIAL' }, { id: '150511', nombre: 'PACARAN' }, { id: '150512', nombre: 'QUILMANA' }, { id: '150513', nombre: 'SAN ANTONIO' }, { id: '150514', nombre: 'SAN LUIS' }, { id: '150515', nombre: 'SANTA CRUZ DE FLORES' }, { id: '150516', nombre: 'ZÚÑIGA' }],
        '1506': [{ id: '150601', nombre: 'HUARAL' }, { id: '150602', nombre: 'ATAVILLOS ALTO' }, { id: '150603', nombre: 'ATAVILLOS BAJO' }, { id: '150604', nombre: 'AUCALLAMA' }, { id: '150605', nombre: 'CHANCAY' }, { id: '150606', nombre: 'IHUARI' }, { id: '150607', nombre: 'LAMPIAN' }, { id: '150608', nombre: 'PACARAOS' }, { id: '150609', nombre: 'SAN MIGUEL DE ACOS' }, { id: '150610', nombre: 'SANTA CRUZ DE ANDAMARCA' }, { id: '150611', nombre: 'SUMBILCA' }, { id: '150612', nombre: 'VEINTISIETE DE NOVIEMBRE' }],
        '1507': [{ id: '150701', nombre: 'MATUCANA' }, { id: '150702', nombre: 'ANTIOQUIA' }, { id: '150703', nombre: 'CALLAHUANCA' }, { id: '150704', nombre: 'CARAMPOMA' }, { id: '150705', nombre: 'CHICLA' }, { id: '150706', nombre: 'CUENCA' }, { id: '150707', nombre: 'HUACHUPAMPA' }, { id: '150708', nombre: 'HUANZA' }, { id: '150709', nombre: 'HUAROCHIRI' }, { id: '150710', nombre: 'LAHUAYTAMBO' }, { id: '150711', nombre: 'LANGA' }, { id: '150712', nombre: 'LARAOS' }, { id: '150713', nombre: 'MARIATANA' }, { id: '150714', nombre: 'RICARDO PALMA' }, { id: '150715', nombre: 'SAN ANDRÉS DE TUPICOCHA' }, { id: '150716', nombre: 'SAN ANTONIO' }, { id: '150717', nombre: 'SAN BARTOLOMÉ' }, { id: '150718', nombre: 'SAN DAMIAN' }, { id: '150719', nombre: 'SAN JUAN DE IRIS' }, { id: '150720', nombre: 'SAN JUAN DE TANTARANCHE' }, { id: '150721', nombre: 'SAN LORENZO DE QUINTI' }, { id: '150722', nombre: 'SAN MATEO' }, { id: '150723', nombre: 'SAN MATEO DE OTAO' }, { id: '150724', nombre: 'SAN PEDRO DE CASTA' }, { id: '150725', nombre: 'SAN PEDRO DE HUANCAYRE' }, { id: '150726', nombre: 'SANGALLAYA' }, { id: '150727', nombre: 'SANTA CRUZ DE COCACHACRA' }, { id: '150728', nombre: 'SANTA EULALIA' }, { id: '150729', nombre: 'SANTIAGO DE ANCHUCAYA' }, { id: '150730', nombre: 'SANTIAGO DE TUNA' }, { id: '150731', nombre: 'SANTO DOMINGO DE LOS OLLEROS' }, { id: '150732', nombre: 'SURCO' }],
        '1508': [{ id: '150801', nombre: 'HUACHO' }, { id: '150802', nombre: 'AMBAR' }, { id: '150803', nombre: 'CALETA DE CARQUIN' }, { id: '150804', nombre: 'CHECRAS' }, { id: '150805', nombre: 'HUALMAY' }, { id: '150806', nombre: 'HUAURA' }, { id: '150807', nombre: 'LEONCIO PRADO' }, { id: '150808', nombre: 'PACCHO' }, { id: '150809', nombre: 'SANTA LEONOR' }, { id: '150810', nombre: 'SANTA MARÍA' }, { id: '150811', nombre: 'SAYAN' }, { id: '150812', nombre: 'VEGUETA' }],
        '1509': [{ id: '150901', nombre: 'OYON' }, { id: '150902', nombre: 'ANDAJES' }, { id: '150903', nombre: 'CAUJUL' }, { id: '150904', nombre: 'COCHAMARCA' }, { id: '150905', nombre: 'NAVAN' }, { id: '150906', nombre: 'PACHANGARA' }],
        '1510': [{ id: '151001', nombre: 'YAUYOS' }, { id: '151002', nombre: 'ALIS' }, { id: '151003', nombre: 'ALLAUCA' }, { id: '151004', nombre: 'AYAVIRI' }, { id: '151005', nombre: 'AZÁNGARO' }, { id: '151006', nombre: 'CACRA' }, { id: '151007', nombre: 'CARANIA' }, { id: '151008', nombre: 'CATAHUASI' }, { id: '151009', nombre: 'CHOCOS' }, { id: '151010', nombre: 'COCHAS' }, { id: '151011', nombre: 'COLONIA' }, { id: '151012', nombre: 'HONGOS' }, { id: '151013', nombre: 'HUAMPARA' }, { id: '151014', nombre: 'HUANCAYA' }, { id: '151015', nombre: 'HUANGASCAR' }, { id: '151016', nombre: 'HUANTAN' }, { id: '151017', nombre: 'HUAÑEC' }, { id: '151018', nombre: 'LARAOS' }, { id: '151019', nombre: 'LINCHA' }, { id: '151020', nombre: 'MADEAN' }, { id: '151021', nombre: 'MIRAFLORES' }, { id: '151022', nombre: 'OMAS' }, { id: '151023', nombre: 'PUTINZA' }, { id: '151024', nombre: 'QUINCHES' }, { id: '151025', nombre: 'QUINOCAY' }, { id: '151026', nombre: 'SAN JOAQUÍN' }, { id: '151027', nombre: 'SAN PEDRO DE PILAS' }, { id: '151028', nombre: 'TANTA' }, { id: '151029', nombre: 'TAURIPAMPA' }, { id: '151030', nombre: 'TOMAS' }, { id: '151031', nombre: 'TUPE' }, { id: '151032', nombre: 'VIÑAC' }, { id: '151033', nombre: 'VITIS' }],
        '1601': [{ id: '160101', nombre: 'IQUITOS' }, { id: '160102', nombre: 'ALTO NANAY' }, { id: '160103', nombre: 'FERNANDO LORES' }, { id: '160104', nombre: 'INDIANA' }, { id: '160105', nombre: 'LAS AMAZONAS' }, { id: '160106', nombre: 'MAZAN' }, { id: '160107', nombre: 'NAPO' }, { id: '160108', nombre: 'PUNCHANA' }, { id: '160109', nombre: 'PUTUMAYO' }, { id: '160110', nombre: 'TORRES CAUSANA' }, { id: '160112', nombre: 'BELÉN' }, { id: '160113', nombre: 'SAN JUAN BAUTISTA' }],
        '1602': [{ id: '160201', nombre: 'YURIMAGUAS' }, { id: '160202', nombre: 'BALSAPUERTO' }, { id: '160203', nombre: 'BARRANCA' }, { id: '160204', nombre: 'CAHUAPANAS' }, { id: '160205', nombre: 'JEBEROS' }, { id: '160206', nombre: 'LAGUNAS' }, { id: '160207', nombre: 'MANSERICHE' }, { id: '160208', nombre: 'MORONA' }, { id: '160209', nombre: 'PASTAZA' }, { id: '160210', nombre: 'SANTA CRUZ' }, { id: '160211', nombre: 'TENIENTE CESAR LÓPEZ ROJAS' }],
        '1603': [{ id: '160301', nombre: 'NAUTA' }, { id: '160302', nombre: 'PARINARI' }, { id: '160303', nombre: 'TIGRE' }, { id: '160304', nombre: 'TROMPETEROS' }, { id: '160305', nombre: 'URARINAS' }],
        '1604': [{ id: '160401', nombre: 'RAMÓN CASTILLA' }, { id: '160402', nombre: 'PEBAS' }, { id: '160403', nombre: 'YAVARI' }, { id: '160404', nombre: 'SAN PABLO' }],
        '1605': [{ id: '160501', nombre: 'REQUENA' }, { id: '160502', nombre: 'ALTO TAPICHE' }, { id: '160503', nombre: 'CAPELO' }, { id: '160504', nombre: 'EMILIO SAN MARTÍN' }, { id: '160505', nombre: 'MAQUIA' }, { id: '160506', nombre: 'PUINAHUA' }, { id: '160507', nombre: 'SAQUENA' }, { id: '160508', nombre: 'SOPLIN' }, { id: '160509', nombre: 'TAPICHE' }, { id: '160510', nombre: 'JENARO HERRERA' }, { id: '160511', nombre: 'YAQUERANA' }],
        '1606': [{ id: '160601', nombre: 'CONTAMANA' }, { id: '160602', nombre: 'INAHUAYA' }, { id: '160603', nombre: 'PADRE MÁRQUEZ' }, { id: '160604', nombre: 'PAMPA HERMOSA' }, { id: '160605', nombre: 'SARAYACU' }, { id: '160606', nombre: 'VARGAS GUERRA' }],
        '1607': [{ id: '160701', nombre: 'BARRANCA' }, { id: '160702', nombre: 'CAHUAPANAS' }, { id: '160703', nombre: 'MANSERICHE' }, { id: '160704', nombre: 'MORONA' }, { id: '160705', nombre: 'PASTAZA' }, { id: '160706', nombre: 'ANDOAS' }],
        '1608': [{ id: '160801', nombre: 'PUTUMAYO' }, { id: '160802', nombre: 'ROSA PANDURO' }, { id: '160803', nombre: 'TENIENTE MANUEL CLAVERO' }, { id: '160804', nombre: 'YAGUAS' }],
        '1701': [{ id: '170101', nombre: 'TAMBOPATA' }, { id: '170102', nombre: 'INAMBARI' }, { id: '170103', nombre: 'LAS PIEDRAS' }, { id: '170104', nombre: 'LABERINTO' }],
        '1702': [{ id: '170201', nombre: 'MANU' }, { id: '170202', nombre: 'FITZCARRALD' }, { id: '170203', nombre: 'MADRE DE DIOS' }, { id: '170204', nombre: 'HUEPETUHE' }],
        '1703': [{ id: '170301', nombre: 'IÑAPARI' }, { id: '170302', nombre: 'IBERIA' }, { id: '170303', nombre: 'TAHUAMANU' }],
        '1801': [{ id: '180101', nombre: 'MOQUEGUA' }, { id: '180102', nombre: 'CARUMAS' }, { id: '180103', nombre: 'CUCHUMBAYA' }, { id: '180104', nombre: 'SAMEGUA' }, { id: '180105', nombre: 'SAN CRISTÓBAL' }, { id: '180106', nombre: 'TORATA' }],
        '1802': [{ id: '180201', nombre: 'OMATE' }, { id: '180202', nombre: 'CHOJATA' }, { id: '180203', nombre: 'COALAQUE' }, { id: '180204', nombre: 'ICHUÑA' }, { id: '180205', nombre: 'LA CAPILLA' }, { id: '180206', nombre: 'LLOQUE' }, { id: '180207', nombre: 'MATALAQUE' }, { id: '180208', nombre: 'PUQUINA' }, { id: '180209', nombre: 'QUINISTAQUILLAS' }, { id: '180210', nombre: 'UBINAS' }, { id: '180211', nombre: 'YUNGA' }],
        '1803': [{ id: '180301', nombre: 'ILO' }, { id: '180302', nombre: 'EL ALGARROBAL' }, { id: '180303', nombre: 'PACOCHA' }],
        '1901': [{ id: '190101', nombre: 'CHAUPIMARCA' }, { id: '190102', nombre: 'HUACHON' }, { id: '190103', nombre: 'HUARIACA' }, { id: '190104', nombre: 'HUAYLLAY' }, { id: '190105', nombre: 'NINACACA' }, { id: '190106', nombre: 'PALLANCHACRA' }, { id: '190107', nombre: 'PAUCARTAMBO' }, { id: '190108', nombre: 'SAN FRANCISCO DE ASÍS DE YARUSYACAN' }, { id: '190109', nombre: 'SIMON BOLÍVAR' }, { id: '190110', nombre: 'TICLACAYAN' }, { id: '190111', nombre: 'TINYAHUARCO' }, { id: '190112', nombre: 'VICCO' }, { id: '190113', nombre: 'YANACANCHA' }],
        '1902': [{ id: '190201', nombre: 'YANAHUANCA' }, { id: '190202', nombre: 'CHACAYAN' }, { id: '190203', nombre: 'GOYLLARISQUIZGA' }, { id: '190204', nombre: 'PAUCAR' }, { id: '190205', nombre: 'SAN PEDRO DE PILLAO' }, { id: '190206', nombre: 'SANTA ANA DE TUSI' }, { id: '190207', nombre: 'TAPUC' }, { id: '190208', nombre: 'VILCABAMBA' }],
        '1903': [{ id: '190301', nombre: 'OXAPAMPA' }, { id: '190302', nombre: 'CHONTABAMBA' }, { id: '190303', nombre: 'HUANCABAMBA' }, { id: '190304', nombre: 'PALCAZU' }, { id: '190305', nombre: 'POZUZO' }, { id: '190306', nombre: 'PUERTO BERMÚDEZ' }, { id: '190307', nombre: 'VILLA RICA' }, { id: '190308', nombre: 'CONSTITUCIÓN' }],
        '2001': [{ id: '200101', nombre: 'PIURA' }, { id: '200102', nombre: 'BELLAVISTA DE LA UNION' }, { id: '200103', nombre: 'BERNAL' }, { id: '200104', nombre: 'CASTILLA' }, { id: '200105', nombre: 'CATACAOS' }, { id: '200106', nombre: 'CRISTO NOS VALGA' }, { id: '200107', nombre: 'CURA MORI' }, { id: '200108', nombre: 'EL TALLAN' }, { id: '200109', nombre: 'LA ARENA' }, { id: '200110', nombre: 'LA UNIÓN' }, { id: '200111', nombre: 'LAS LOMAS' }, { id: '200112', nombre: 'RINCONADA LLICUAR' }, { id: '200113', nombre: 'SECHURA' }, { id: '200114', nombre: 'TAMBO GRANDE' }, { id: '200115', nombre: 'VEINTISEIS DE OCTUBRE' }],
        '2002': [{ id: '200201', nombre: 'AYABACA' }, { id: '200202', nombre: 'FRIAS' }, { id: '200203', nombre: 'JILILI' }, { id: '200204', nombre: 'LAGUNAS' }, { id: '200205', nombre: 'MONTERO' }, { id: '200206', nombre: 'PACAIPAMPA' }, { id: '200207', nombre: 'PAIMAS' }, { id: '200208', nombre: 'SAPILLICA' }, { id: '200209', nombre: 'SICCHEZ' }, { id: '200210', nombre: 'SUYO' }],
        '2003': [{ id: '200301', nombre: 'HUANCABAMBA' }, { id: '200302', nombre: 'CANCHAQUE' }, { id: '200303', nombre: 'EL CARMEN DE LA FRONTERA' }, { id: '200304', nombre: 'HUARMACA' }, { id: '200305', nombre: 'LALAQUIZ' }, { id: '200306', nombre: 'SAN MIGUEL DE EL FAIQUE' }, { id: '200307', nombre: 'SONDOR' }, { id: '200308', nombre: 'SONDORILLO' }],
        '2004': [{ id: '200401', nombre: 'CHULUCANAS' }, { id: '200402', nombre: 'BUENOS AIRES' }, { id: '200403', nombre: 'CHALACO' }, { id: '200404', nombre: 'LA MATANZA' }, { id: '200405', nombre: 'MORROPON' }, { id: '200406', nombre: 'SALITRAL' }, { id: '200407', nombre: 'SAN JUAN DE BIGOTE' }, { id: '200408', nombre: 'SANTA CATALINA DE MOSSA' }, { id: '200409', nombre: 'SANTO DOMINGO' }, { id: '200410', nombre: 'YAMANGO' }],
        '2005': [{ id: '200501', nombre: 'PAITA' }, { id: '200502', nombre: 'AMOTAPE' }, { id: '200503', nombre: 'ARENAL' }, { id: '200504', nombre: 'COLAN' }, { id: '200505', nombre: 'LA HUACA' }, { id: '200506', nombre: 'TAMARINDO' }, { id: '200507', nombre: 'VICHAYAL' }],
        '2006': [{ id: '200601', nombre: 'SULLANA' }, { id: '200602', nombre: 'BELLAVISTA' }, { id: '200603', nombre: 'IGNACIO ESCUDERO' }, { id: '200604', nombre: 'LANCONES' }, { id: '200605', nombre: 'MARCAVELICA' }, { id: '200606', nombre: 'MIGUEL CHECA' }, { id: '200607', nombre: 'QUERECOTILLO' }, { id: '200608', nombre: 'SALITRAL' }],
        '2007': [{ id: '200701', nombre: 'PARIÑAS' }, { id: '200702', nombre: 'EL ALTO' }, { id: '200703', nombre: 'LA BREA' }, { id: '200704', nombre: 'LOBITOS' }, { id: '200705', nombre: 'LOS ORGANOS' }, { id: '200706', nombre: 'MANCORA' }],
        '2008': [{ id: '200801', nombre: 'SECHURA' }, { id: '200802', nombre: 'BELLAVISTA DE LA UNIÓN' }, { id: '200803', nombre: 'BERNAL' }, { id: '200804', nombre: 'CRISTO NOS VALGA' }, { id: '200805', nombre: 'VICE' }, { id: '200806', nombre: 'RINCONADA LLICUAR' }],
        '2101': [{ id: '210101', nombre: 'PUNO' }, { id: '210102', nombre: 'ACORA' }, { id: '210103', nombre: 'AMANTANI' }, { id: '210104', nombre: 'ATUNCOLLA' }, { id: '210105', nombre: 'CAPACHICA' }, { id: '210106', nombre: 'CHUCUITO' }, { id: '210107', nombre: 'COATA' }, { id: '210108', nombre: 'HUATA' }, { id: '210109', nombre: 'MAÑAZO' }, { id: '210110', nombre: 'PAUCARCOLLA' }, { id: '210111', nombre: 'PICHACANI' }, { id: '210112', nombre: 'PLATERIA' }, { id: '210113', nombre: 'SAN ANTONIO' }, { id: '210114', nombre: 'TIQUILLACA' }, { id: '210115', nombre: 'VILQUE' }],
        '2102': [{ id: '210201', nombre: 'AZÁNGARO' }, { id: '210202', nombre: 'ACHAYA' }, { id: '210203', nombre: 'ARAPA' }, { id: '210204', nombre: 'ASILLO' }, { id: '210205', nombre: 'CAMINACA' }, { id: '210206', nombre: 'CHUPA' }, { id: '210207', nombre: 'JOSÉ DOMINGO CHOQUEHUANCA' }, { id: '210208', nombre: 'MUÑANI' }, { id: '210209', nombre: 'POTONI' }, { id: '210210', nombre: 'SAMAN' }, { id: '210211', nombre: 'SAN ANTON' }, { id: '210212', nombre: 'SAN JOSÉ' }, { id: '210213', nombre: 'SAN JUAN DE SALINAS' }, { id: '210214', nombre: 'SANTIAGO DE PUPUJA' }, { id: '210215', nombre: 'TIRAPATA' }],
        '2103': [{ id: '210301', nombre: 'MACUSANI' }, { id: '210302', nombre: 'AJOYANI' }, { id: '210303', nombre: 'AYAPATA' }, { id: '210304', nombre: 'COASA' }, { id: '210305', nombre: 'CORANI' }, { id: '210306', nombre: 'CRUCERO' }, { id: '210307', nombre: 'ITUATA' }, { id: '210308', nombre: 'OLLACHEA' }, { id: '210309', nombre: 'SAN GABAN' }, { id: '210310', nombre: 'USICAYOS' }],
        '2104': [{ id: '210401', nombre: 'JULI' }, { id: '210402', nombre: 'DESAGUADERO' }, { id: '210403', nombre: 'HUACULLANI' }, { id: '210404', nombre: 'KELLUYO' }, { id: '210405', nombre: 'PISACOMA' }, { id: '210406', nombre: 'POMATA' }, { id: '210407', nombre: 'ZEPITA' }],
        '2105': [{ id: '210501', nombre: 'ILAVE' }, { id: '210502', nombre: 'CAPAZO' }, { id: '210503', nombre: 'PILCUYO' }, { id: '210504', nombre: 'SANTA ROSA' }, { id: '210505', nombre: 'CONDURIRI' }],
        '2106': [{ id: '210601', nombre: 'HUANCANE' }, { id: '210602', nombre: 'COJATA' }, { id: '210603', nombre: 'HUATASANI' }, { id: '210604', nombre: 'INCHUPALLA' }, { id: '210605', nombre: 'PUSI' }, { id: '210606', nombre: 'ROSASPATA' }, { id: '210607', nombre: 'TARACO' }, { id: '210608', nombre: 'VILQUE CHICO' }],
        '2107': [{ id: '210701', nombre: 'LAMPA' }, { id: '210702', nombre: 'CABANILLA' }, { id: '210703', nombre: 'CALAPUJA' }, { id: '210704', nombre: 'NICASIO' }, { id: '210705', nombre: 'OCUVIRI' }, { id: '210706', nombre: 'PALCA' }, { id: '210707', nombre: 'PARATIA' }, { id: '210708', nombre: 'PUCARA' }, { id: '210709', nombre: 'SANTA LUCIA' }, { id: '210710', nombre: 'VILAVILA' }],
        '2108': [{ id: '210801', nombre: 'AYAVIRI' }, { id: '210802', nombre: 'ANTAUTA' }, { id: '210803', nombre: 'CUPI' }, { id: '210804', nombre: 'LLALLI' }, { id: '210805', nombre: 'MACARI' }, { id: '210806', nombre: 'NUÑOA' }, { id: '210807', nombre: 'ORURILLO' }, { id: '210808', nombre: 'SANTA ROSA' }, { id: '210809', nombre: 'UMACHIRI' }],
        '2109': [{ id: '210901', nombre: 'MOHO' }, { id: '210902', nombre: 'CONIMA' }, { id: '210903', nombre: 'HUAYRAPATA' }, { id: '210904', nombre: 'TILALI' }],
        '2110': [{ id: '211001', nombre: 'PUTINA' }, { id: '211002', nombre: 'ANANEA' }, { id: '211003', nombre: 'PEDRO VILCA APAZA' }, { id: '211004', nombre: 'QUILCAPUNCU' }, { id: '211005', nombre: 'SINA' }],
        '2111': [{ id: '211101', nombre: 'JULIACA' }, { id: '211102', nombre: 'CABANA' }, { id: '211103', nombre: 'CABANILLAS' }, { id: '211104', nombre: 'CARACOTO' }, { id: '211105', nombre: 'SAN MIGUEL' }],
        '2112': [{ id: '211201', nombre: 'SANDIA' }, { id: '211202', nombre: 'CUYOCUYO' }, { id: '211203', nombre: 'LIMBANI' }, { id: '211204', nombre: 'PATAMBUCO' }, { id: '211205', nombre: 'PHARA' }, { id: '211206', nombre: 'QUIACA' }, { id: '211207', nombre: 'SAN JUAN DEL ORO' }, { id: '211208', nombre: 'YANAHUAYA' }, { id: '211209', nombre: 'ALTO INAMBARI' }, { id: '211210', nombre: 'SAN PEDRO DE PUTINA PUNCO' }],
        '2113': [{ id: '211301', nombre: 'YUNGUYO' }, { id: '211302', nombre: 'ANAPIA' }, { id: '211303', nombre: 'COPANI' }, { id: '211304', nombre: 'CUTURAPI' }, { id: '211305', nombre: 'OLLARAYA' }, { id: '211306', nombre: 'TINICACHI' }, { id: '211307', nombre: 'UNICACHI' }],
        '2201': [{ id: '220101', nombre: 'MOYOBAMBA' }, { id: '220102', nombre: 'CALZADA' }, { id: '220103', nombre: 'HABANA' }, { id: '220104', nombre: 'JEPELACIO' }, { id: '220105', nombre: 'SORITOR' }, { id: '220106', nombre: 'YANTALO' }],
        '2202': [{ id: '220201', nombre: 'BELLAVISTA' }, { id: '220202', nombre: 'ALTO BIAVO' }, { id: '220203', nombre: 'BAJO BIAVO' }, { id: '220204', nombre: 'HUALLAGA' }, { id: '220205', nombre: 'SAN PABLO' }, { id: '220206', nombre: 'SAN RAFAEL' }],
        '2203': [{ id: '220301', nombre: 'SAN JOSÉ DE SISA' }, { id: '220302', nombre: 'AGUA BLANCA' }, { id: '220303', nombre: 'SAN MARTÍN' }, { id: '220304', nombre: 'SANTA ROSA' }, { id: '220305', nombre: 'SHATOJA' }],
        '2204': [{ id: '220401', nombre: 'SAPOSOA' }, { id: '220402', nombre: 'ALTO SAPOSOA' }, { id: '220403', nombre: 'EL ESLABÓN' }, { id: '220404', nombre: 'PISCOYACU' }, { id: '220405', nombre: 'SACANCHE' }, { id: '220406', nombre: 'TINGO DE SAPOSOA' }],
        '2205': [{ id: '220501', nombre: 'LAMAS' }, { id: '220502', nombre: 'ALONSO DE ALVARADO' }, { id: '220503', nombre: 'BARRANQUITA' }, { id: '220504', nombre: 'CAYNARACHI' }, { id: '220505', nombre: 'CUÑUMBUQUI' }, { id: '220506', nombre: 'PINTO RECODO' }, { id: '220507', nombre: 'RUMISAPA' }, { id: '220508', nombre: 'SAN ROQUE DE CUMBAZA' }, { id: '220509', nombre: 'SHANAO' }, { id: '220510', nombre: 'TABALOSOS' }, { id: '220511', nombre: 'ZAPATERO' }],
        '2206': [{ id: '220601', nombre: 'JUANJUÍ' }, { id: '220602', nombre: 'CAMPANILLA' }, { id: '220603', nombre: 'HUICUNGO' }, { id: '220604', nombre: 'PACHIZA' }, { id: '220605', nombre: 'PAJARILLO' }],
        '2207': [{ id: '220701', nombre: 'PICOTA' }, { id: '220702', nombre: 'BUENOS AIRES' }, { id: '220703', nombre: 'CASPISAPA' }, { id: '220704', nombre: 'PILLUANA' }, { id: '220705', nombre: 'PUCACACA' }, { id: '220706', nombre: 'SAN CRISTÓBAL' }, { id: '220707', nombre: 'SAN HILARIÓN' }, { id: '220708', nombre: 'SHAMBOYACU' }, { id: '220709', nombre: 'TINGO DE PONASA' }, { id: '220710', nombre: 'TRES UNIDOS' }],
        '2208': [{ id: '220801', nombre: 'RIOJA' }, { id: '220802', nombre: 'AWAJUN' }, { id: '220803', nombre: 'ELÍAS SOPLIN VARGAS' }, { id: '220804', nombre: 'NUEVA CAJAMARCA' }, { id: '220805', nombre: 'PARDO MIGUEL' }, { id: '220806', nombre: 'POSIC' }, { id: '220807', nombre: 'SAN FERNANDO' }, { id: '220808', nombre: 'YORONGOS' }, { id: '220809', nombre: 'YURACYACU' }],
        '2209': [{ id: '220901', nombre: 'TARAPOTO' }, { id: '220902', nombre: 'ALBERTO LEVEAU' }, { id: '220903', nombre: 'CACATACHI' }, { id: '220904', nombre: 'CHAZUTA' }, { id: '220905', nombre: 'CHIPURANA' }, { id: '220906', nombre: 'EL PORVENIR' }, { id: '220907', nombre: 'HUIMBAYOC' }, { id: '220908', nombre: 'JUAN GUERRA' }, { id: '220909', nombre: 'LA BANDA DE SHILCAYO' }, { id: '220910', nombre: 'MORALES' }, { id: '220911', nombre: 'PAPAPLAYA' }, { id: '220912', nombre: 'SAN ANTONIO' }, { id: '220913', nombre: 'SAUCE' }, { id: '220914', nombre: 'SHAPAJA' }],
        '2210': [{ id: '221001', nombre: 'TOCACHE' }, { id: '221002', nombre: 'NUEVO PROGRESO' }, { id: '221003', nombre: 'POLVORA' }, { id: '221004', nombre: 'SHUNTE' }, { id: '221005', nombre: 'UCHIZA' }],
        '2301': [{ id: '230101', nombre: 'TACNA' }, { id: '230102', nombre: 'ALTO DE LA ALIANZA' }, { id: '230103', nombre: 'CALANA' }, { id: '230104', nombre: 'CIUDAD NUEVA' }, { id: '230105', nombre: 'INCLAN' }, { id: '230106', nombre: 'PACHIA' }, { id: '230107', nombre: 'PALCA' }, { id: '230108', nombre: 'POCOLLAY' }, { id: '230109', nombre: 'SAMA' }, { id: '230110', nombre: 'CORONEL GREGORIO ALBARRACÍN LANCHIPA' }, { id: '230111', nombre: 'LA YARADA LOS PALOS' }],
        '2302': [{ id: '230201', nombre: 'CANDARAVE' }, { id: '230202', nombre: 'CAIRANI' }, { id: '230203', nombre: 'CAMILACA' }, { id: '230204', nombre: 'CURIBAYA' }, { id: '230205', nombre: 'HUANUARA' }, { id: '230206', nombre: 'QUILAHUANI' }],
        '2303': [{ id: '230301', nombre: 'LOCUMBA' }, { id: '230302', nombre: 'ILABAYA' }, { id: '230303', nombre: 'ITE' }],
        '2304': [{ id: '230401', nombre: 'TARATA' }, { id: '230402', nombre: 'HÉROES ALBARRACÍN' }, { id: '230403', nombre: 'ESTIQUE' }, { id: '230404', nombre: 'ESTIQUE-PAMPA' }, { id: '230405', nombre: 'SITAJARA' }, { id: '230406', nombre: 'SUSAPAYA' }, { id: '230407', nombre: 'TARUCACHI' }, { id: '230408', nombre: 'TICACO' }],
        '2401': [{ id: '240101', nombre: 'TUMBES' }, { id: '240102', nombre: 'CORRALES' }, { id: '240103', nombre: 'LA CRUZ' }, { id: '240104', nombre: 'PAMPAS DE HOSPITAL' }, { id: '240105', nombre: 'SAN JACINTO' }, { id: '240106', nombre: 'SAN JUAN DE LA VIRGEN' }],
        '2402': [{ id: '240201', nombre: 'ZORRITOS' }, { id: '240202', nombre: 'CASITAS' }, { id: '240203', nombre: 'CANOAS DE PUNTA SAL' }],
        '2403': [{ id: '240301', nombre: 'ZARUMILLA' }, { id: '240302', nombre: 'AGUAS VERDES' }, { id: '240303', nombre: 'MATAPALO' }, { id: '240304', nombre: 'PAPAYAL' }],
        '2501': [{ id: '250101', nombre: 'CALLERIA' }, { id: '250102', nombre: 'CAMPOVERDE' }, { id: '250103', nombre: 'IPARIA' }, { id: '250104', nombre: 'MASISEA' }, { id: '250105', nombre: 'YARINACOCHA' }, { id: '250106', nombre: 'NUEVA REQUENA' }, { id: '250107', nombre: 'MANANTAY' }],
        '2502': [{ id: '250201', nombre: 'RAYMONDI' }, { id: '250202', nombre: 'SEPAHUA' }, { id: '250203', nombre: 'TAHUANIA' }, { id: '250204', nombre: 'YURUA' }],
        '2503': [{ id: '250301', nombre: 'PADRE ABAD' }, { id: '250302', nombre: 'IRAZOLA' }, { id: '250303', nombre: 'CURIMANA' }, { id: '250304', nombre: 'NESHUYA' }, { id: '250305', nombre: 'ALEXANDER VON HUMBOLDT' }],
        '2504': [{ id: '250401', nombre: 'PURUS' }]
      }
    };
  }
});

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  data: function data() {
    return {
      tokenId: '',
      login: false,
      loginForm: { open: false },
      loginMsg: '',
      cambiarClave: { open: false },
      drawer: null,
      entorno: '',
      locales: [],
      sedes: [],
      local: '',
      empresa: '',
      usuario: '',
      tipoUsuario: '',
      dialog: false,
      dialogW: '400px',
      etapa: ''
    };
  },
  props: {
    source: String
  },
  beforeMount: function beforeMount() {
    this.entorno = "production";
    this.tokenId = localStorage.getItem('tokenId');
    this.local = localStorage.getItem('local');
    this.variablesApp();
  },

  watch: {
    tokenId: function tokenId(val) {
      localStorage.setItem('tokenId', val);
    },
    local: function local(val) {
      localStorage.setItem('local', val);
      if (val === 'undefined') {
        localStorage.setItem('local', '');
      }
    },
    login: function login(val) {
      if (val === false) {
        this.loginForm.open = true;
      }
    }
  },
  computed: {
    popupSrc: function popupSrc() {
      return "https://www.colegiossanignacio.edu.pe/omsil/" + '/archivos/resultados2.png';
    },
    itemsMenu: function itemsMenu() {
      var menu = [];
      if (this.usuario === 'adminsan') {
        menu = [{ icon: 'account_balance', text: 'Colegios', url: '/Colegios' }, { icon: 'print', text: 'Inscritos', url: '/Estudiantes' }, { icon: 'attach_money', text: 'Verificar pagos', url: '/Pagos' }, { icon: 'comments', text: 'Resultados', url: '/Resultados' }, { icon: 'comments', text: 'Reportes', url: '/Reportes' }, { icon: 'build', text: 'Configuración', url: '/Configuracion' }, { icon: 'person', text: 'Usuarios', url: '/Usuarios' }, { icon: 'location_city', text: 'Sedes', url: '/Sedes' }];
      } else if (this.tipoUsuario === 'ADM') {
        menu = [{ icon: 'account_balance', text: 'Colegios', url: '/Colegios' }, { icon: 'print', text: 'Inscritos', url: '/Estudiantes' }, { icon: 'attach_money', text: 'Verificar pagos', url: '/Pagos' }, { icon: 'comments', text: 'Resultados', url: '/Resultados' }, { icon: 'comments', text: 'Reportes', url: '/Reportes' }];
      } else if (this.tipoUsuario === 'COL') {
        // this.tipoUsuario === 'DEL'
        if (this.etapa === 'I') {
          menu = [{ icon: 'account_balance', text: 'Datos del colegio', url: '/Colegio' }, { icon: 'assignment', text: 'Ficha de inscripción', url: '/FichaInscripcion' }, { icon: 'attach_money', text: 'Ficha de pago', url: '/Pago' }, { icon: 'print', text: 'Verificar inscritos', url: '/Inscritos' }, { icon: 'credit_card', text: 'Credenciales', url: '/Credenciales' }];
        } else {
          menu = [{ icon: 'comments', text: 'Resultado', url: '/Resultado' }];
        }
      } else {
        if (this.etapa === 'I') {
          menu = [{ icon: 'assignment', text: 'Ficha de inscripción', url: '/Ficha' }, { icon: 'attach_money', text: 'Ficha de pago', url: '/Pago' }, { icon: 'credit_card', text: 'Credencial', url: '/Credenciales' }];
        } else {
          menu = [{ icon: 'comments', text: 'Resultado', url: '/Resultado' }];
        }
      }
      return menu;
    }
  },
  methods: {
    variablesApp: function variablesApp() {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicioApp.php', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      this.loading = true;
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.empresa = '';
          _this.usuario = '';
          _this.tipoUsuario = '';
          _this.locales = [];
          _this.local = '';
          localStorage.setItem('local', '');
          _this.$router.push('/Ingresar');
          _this.dialog = datos.d.popup;
          _this.dialogW = datos.d.popupW + 'px';
          _this.etapa = datos.d.etapa;
        } else {
          _this.login = datos.l;
          _this.empresa = datos.d.empresa;
          _this.usuario = datos.d.usuario;
          _this.tipoUsuario = datos.d.tipo;
          _this.locales = datos.d.locales;
          _this.etapa = datos.d.etapa;
          _this.sedes = [];
          for (var idLocal in datos.d.locales) {
            _this.sedes.push({ id: idLocal, nombre: datos.d.locales[idLocal].nombre });
          }
          if (localStorage.getItem('local') !== '') {
            _this.setLocal(localStorage.getItem('local'));
          } else {
            _this.setLocal(datos.d.local);
          }
        }
      });
    },
    cerrar: function cerrar() {
      this.dialog = false;
    },
    setToken: function setToken(token) {
      this.tokenId = token;
      this.login = true;
      if (this.empresa === '') {
        localStorage.setItem('tokenId', token);
        if (this.tipoUsuario !== 'ADM') {
          this.$router.push('/Inicio');
        } else {
          this.$router.push('/Inicio');
        }
        this.variablesApp();
      }
    },
    setLocal: function setLocal(local) {
      for (var buscar in this.locales) {
        if (this.locales[buscar].nombre === local) {
          localStorage.setItem('local', local);
          this.local = local;
          if (this.tipoUsuario !== 'ADM') {
            if (this.etapa === 'R') {
              this.$router.push('/Resultado');
              this.drawer = false;
            } else {
              this.$router.push('/Inicio');
            }
          } else {
            this.$router.push('/Inicio');
          }
          return;
        }
      }
      localStorage.setItem('local', this.local);
      this.$router.push('/Inicio');
    },
    loginOff: function loginOff(msg) {
      this.login = false;
      if (0 in msg) {
        this.loginMsg = msg[0];
      } else {
        this.loginMsg = msg;
      }
      // this.loginForm.open = true
    },
    cerrarSesion: function cerrarSesion() {
      localStorage.setItem('tokenId', '');
      localStorage.setItem('local', '');
      this.empresa = '';
      this.usuario = '';
      this.tipoUsuario = '';
      this.login = false;
      this.$router.push('/Ingresar');
    }
  }
});

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  prefix: '',
  thousands: '',
  decimal: '.',
  precision: 2
});

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inicio',
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ubicacion_js__ = __webpack_require__(31);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__ubicacion_js__["a" /* default */]],
  name: 'login',
  props: ['login', 'msgError', 'etapa'],
  data: function data() {
    return {
      usuario: '',
      clave: '',
      validarInscripcion: true,
      mensaje: '',
      tipoRegistro: 'I',
      tiposColegio: ['ESTATAL', 'PRIVADO'],
      guardar: false,
      grados: [{ id: '3A', nombre: 'INICIAL 3 AÑOS' }, { id: '4A', nombre: 'INICIAL 4 AÑOS' }, { id: '5A', nombre: 'INICIAL 5 AÑOS' }, { id: '1P', nombre: '1º PRIMARIA' }, { id: '2P', nombre: '2º PRIMARIA' }, { id: '3P', nombre: '3º PRIMARIA' }, { id: '4P', nombre: '4º PRIMARIA' }, { id: '5P', nombre: '5º PRIMARIA' }, { id: '6P', nombre: '6º PRIMARIA' }, { id: '1S', nombre: '1º SECUNDARIA' }, { id: '2S', nombre: '2º SECUNDARIA' }, { id: '3S', nombre: '3º SECUNDARIA' }, { id: '4S', nombre: '4º SECUNDARIA' }, { id: '5S', nombre: '5º SECUNDARIA' }],
      sedes: [{ id: '1', nombre: 'PUNO' }, { id: '2', nombre: 'JULIACA' }, { id: '3', nombre: 'ILAVE' }],
      libre: {
        colegio: '',
        tipoColegio: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        nombres: '',
        dni: '',
        telefono: '',
        correo: '',
        grado: '',
        departamento: { id: '21', nombre: 'PUNO' },
        provincia: { id: '', nombre: '' },
        distrito: { id: '', nombre: '' },
        sede: ''
      },
      voucherURL: '',
      voucherArchivo: ''
    };
  },
  computed: {
    formulario: function formulario() {
      if (this.$route.params.tipoIngreso === 'Independiente') {
        return 3;
      } else if (this.$route.params.tipoIngreso === 'Delegacion') {
        return 2;
      } else if (this.$route.params.tipoIngreso === 'Registrar') {
        this.limpiarFormulario();
        this.libre.form = 'alumno';
        return 4;
      } else if (this.$route.params.tipoIngreso === 'RegistrarColegio') {
        this.limpiarFormulario();
        this.libre.form = 'colegio';
        return 5;
      } else {
        return 1;
      }
    },
    provincias: function provincias() {
      return this.listaProvincias[this.libre.departamento.id];
    },
    distritos: function distritos() {
      return this.listaDistritos[this.libre.provincia.id];
    }
  },
  methods: {
    registrarLibre: function registrarLibre() {
      this.$router.push('/Ingresar/Registrar');
    },
    registrarColegio: function registrarColegio() {
      this.$router.push('/Ingresar/RegistrarColegio');
    },
    loginIngresarForm: function loginIngresarForm(valor) {
      if (valor === 'D') {
        this.$router.push('/Ingresar/Delegacion');
      } else if (valor === 'I') {
        this.$router.push('/Ingresar/Independiente');
      } else if (valor === 'RD') {
        this.registrarColegio();
      } else if (valor === 'RI') {
        this.registrarLibre();
      }
    },
    loginIngresar: function loginIngresar() {
      var _this = this;

      this.mensaje = '';
      if (this.formulario === 1) {
        /* if (this.tipoRegistro === 'D') {
          this.$router.push('/Ingresar/Delegacion')
        } else {
          this.$router.push('/Ingresar/Independiente')
        } */
      } else if (this.formulario === 2) {
        var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'login.php', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ usuario: this.usuario, clave: this.clave, tipo: 'C' }), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
        return fetch(myRequest).then(function (response) {
          return response.json();
        }).then(function (datos) {
          if (datos.l === false) {
            _this.mensaje = datos.m;
          } else {
            _this.$emit('set-token', datos.d);
          }
        });
      } else if (this.formulario === 3) {
        var _myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'login.php', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ usuario: this.usuario, clave: this.clave, tipo: 'A' }), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
        return fetch(_myRequest).then(function (response) {
          return response.json();
        }).then(function (datos) {
          if (datos.l === false) {
            _this.mensaje = datos.m;
          } else {
            _this.$emit('set-token', datos.d);
          }
        });
      } else if (this.formulario === 4) {
        if (this.libre.operacion === '') {
          alert('Debe ingresar el número de operación');
          return;
        }
        if (this.libre.monto > 12 || this.libre.monto < 12) {
          alert('El costo de inscripción es de S/12.00');
          return;
        }
        if (this.libre.voucher === undefined) {
          alert('Debe adjuntar el voucher');
          return;
        }
        if (!this.guardar) {
          this.guardar = true;
          var _myRequest2 = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inscribir.php', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.libre), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
          return fetch(_myRequest2).then(function (response) {
            return response.json();
          }).then(function (datos) {
            console.log(datos);
            if (datos.e === 1) {
              // alert(datos.m)
              var dni = _this.libre.dni;
              var _myRequest3 = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'login.php', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ usuario: dni, clave: dni, tipo: 'A' }), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
              return fetch(_myRequest3).then(function (response) {
                return response.json();
              }).then(function (datos) {
                if (datos.l === false) {
                  _this.mensaje = datos.m;
                } else {
                  var token = datos.d;
                  var _myRequest4 = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicioApp.php', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ tokenId: encodeURIComponent(token), local: '' }), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
                  return fetch(_myRequest4).then(function (response) {
                    return response.json();
                  }).then(function (datos) {
                    if (datos.l) {
                      var local = datos.d.local;
                      var _myRequest5 = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=pago&accion=guardar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ tokenId: encodeURIComponent(token), local: local, datos: { monto: _this.libre.monto, operacion: _this.libre.operacion, voucher: _this.libre.voucher } }), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
                      return fetch(_myRequest5).then(function (response) {
                        return response.json();
                      }).then(function (datos) {
                        if (datos.l) {
                          var _myRequest6 = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=ficha&accion=listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ tokenId: encodeURIComponent(token), local: local, datos: { tipo: 'lista', nFilas: 1000, idx: 0, ord: 0, pag: 1, grado: '' } }), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
                          return fetch(_myRequest6).then(function (response) {
                            return response.json();
                          }).then(function (datos) {
                            if (datos.l) {
                              var credencial = datos.d.data;
                              var _myRequest7 = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'credencial.php?', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ tokenId: encodeURIComponent(token), local: local, datos: { datos: credencial } }), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
                              return fetch(_myRequest7).then(function (response) {
                                return response.blob();
                              }).then(function (fileBlob) {
                                var newBlob = new Blob([fileBlob], { type: 'application/pdf' });
                                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                                  window.navigator.msSaveOrOpenBlob(newBlob);
                                  return;
                                }
                                var data = window.URL.createObjectURL(newBlob);
                                var link = document.createElement('a');
                                link.href = data;
                                link.target = '_blank';
                                link.click();
                                _this.guardar = false;
                                _this.limpiarFormulario();
                              });
                            }
                          });
                        }
                      });
                    }
                  });
                  // local":"PUNO","datos":{"monto":"12.00","operacion":"11111113","voucher":
                }
              });
              // this.$router.push('/Ingresar/Independiente')
            } else {
              alert(datos.m);
            }
          });
        }
      } else if (this.formulario === 5) {
        var _myRequest8 = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inscribir.php', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.libre), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
        return fetch(_myRequest8).then(function (response) {
          return response.json();
        }).then(function (datos) {
          if (datos.e === 1) {
            alert(datos.m);
            _this.libre = {
              colegio: '',
              tipoColegio: '',
              apellidoPaterno: '',
              apellidoMaterno: '',
              nombres: '',
              dni: '',
              telefono: '',
              correo: '',
              sede: '',
              form: 'colegio'
            };
            _this.$router.push('/Ingresar/Delegacion');
          } else {
            alert(datos.m);
          }
        });
      }
    },
    subirVoucher: function subirVoucher() {
      this.$refs.image.click();
    },
    registrarVoucher: function registrarVoucher(url, archivo) {
      this.voucherURL = url;
      this.libre.voucher = encodeURIComponent(url);
      this.voucherArchivo = archivo;
    },
    mostrarVoucher: function mostrarVoucher(archivo) {
      if (archivo !== null) {
        return decodeURIComponent(archivo);
      }
      return '';
    },
    onSubirVoucher: function onSubirVoucher(e) {
      var _this2 = this;

      var files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return;
        }
        var fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', function () {
          var img = document.createElement('img');
          img.src = fr.result;
          img.addEventListener('load', function () {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            var MAX_WIDTH = 400;
            var MAX_HEIGHT = 400;
            var width = img.width;
            var height = img.height;

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
              }
            }
            canvas.width = width;
            canvas.height = height;
            ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            _this2.registrarVoucher(canvas.toDataURL(files[0].type), files[0]);
          });
        });
      } else {
        this.voucherArchivo = '';
        this.voucherURL = '';
      }
    },
    limpiarFormulario: function limpiarFormulario() {
      this.libre = {
        colegio: '',
        tipoColegio: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        nombres: '',
        dni: '',
        telefono: '',
        correo: '',
        grado: '',
        departamento: { id: '21', nombre: 'PUNO' },
        provincia: { id: '', nombre: '' },
        distrito: { id: '', nombre: '' },
        operacion: undefined,
        monto: '0.00',
        voucher: undefined,
        sede: '',
        form: 'alumno'
      };
      this.voucherURL = '';
      this.voucherArchivo = '';
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  data: function data() {
    return {
      dialog: false,
      disabledRegistro: false,
      disabledAsesor: false,
      validarAlumno: true,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      menu: false,
      cierreFecha: null,
      headers: [{ text: 'Apellido paterno', value: 0 }, { text: 'Apellido materno', value: 1 }, { text: 'Nombres', value: 2 }, { text: 'DNI', value: 3 }, { text: 'Teléfono', value: 4 }, { text: 'Correo', value: 5 }, { text: 'Colegio', value: 6 }, { text: 'Grado', value: 7 }, { text: 'Actions', align: 'center', value: '', sortable: false }],
      datos: [],
      registro: {},
      grado: '',
      asesor: []
    };
  },
  computed: {
    computedCierreFecha: function computedCierreFecha() {
      return this.formatoFecha(this.registro.cierreFecha);
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.cerrar();
    },
    'registro.cierreFecha': function registroCierreFecha(val) {
      this.cierreFecha = this.formatoFecha(this.registro.cierreFecha);
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.initialize();
    if (this.login === false) {
      this.$router.push('/Ingresar');
    }
    this.pagination.rowsPerPage = 10;
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina,
        grado: ''
      };
      solicitudApi.datos = datos;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=ficha&accion=listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.datos = datos.d;
          _this.totalRegistros = _this.datos.registros;
          if (parseInt(_this.datos.pagina) !== parseInt(_this.pagination.page)) {
            _this.pagination.page = parseInt(_this.datos.pagina);
          }
          _this.loading = false;
        }
      });
    },

    setTotal: function setTotal(total) {
      this.registro.comprobanteTotal = total;
    },
    registrarAlumo: function registrarAlumo() {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      this.registro.grado = this.grado;
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=ficha&accion=guardar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.e === 1) {
          _this2.registro = {
            apellidoPaterno: '',
            apellidoMaterno: '',
            nombres: '',
            dni: '',
            telefono: '',
            correo: ''
          };
          var descendente = 0;
          if (_this2.pagination.descending) {
            descendente = 1;
          }
          _this2.apiListaRegistros(_this2.pagination.sortBy, descendente, _this2.pagination.page);
        } else {
          alert(datos.m);
        }
      });
    },
    verRegistro: function verRegistro(item) {
      var _this3 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = [];
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'ventas/cierre/ver/id/' + item.fila[0], { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this3.$emit('login', datos.m);
        } else {
          _this3.registro = datos.d;
          _this3.productosDetalle = {};
          if (item.fila[0] !== 0) {
            _this3.disabledRegistro = true;
          } else {
            _this3.disabledRegistro = false;
          }
          _this3.dialog = true;
        }
      });
    },
    nuevoRegistro: function nuevoRegistro() {
      this.verRegistro({ fila: [0] });
    },
    cerrar: function cerrar() {
      this.dialog = false;
      setTimeout(function () {}, 300);
    },
    guardar: function guardar() {
      var _this4 = this;

      this.cerrar();
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'ventas/cierre/agregar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this4.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this4.verRegistro({ fila: [datos.d.id] });
            var descendente = 0;
            if (_this4.pagination.descending) {
              descendente = 1;
            }
            _this4.apiListaRegistros(_this4.pagination.sortBy, descendente, _this4.pagination.page);
          }
        }
      });
    },
    verAlumnos: function verAlumnos(grado) {
      this.grado = grado;
    },
    imprimirCredencial: function imprimirCredencial() {
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { datos: this.datos.data };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'credencial.php', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.blob();
      }).then(function (fileBlob) {
        var newBlob = new Blob([fileBlob], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        var data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
        link.href = data;
        link.target = '_blank';
        link.click();
      });
    }
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  data: function data() {
    return {
      dialog: false,
      disabledRegistro: false,
      disabledAsesor: false,
      validarAlumno: true,
      validarAsesor: true,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      menu: false,
      cierreFecha: null,
      headers: [{ text: 'Apellido paterno', value: 0 }, { text: 'Apellido materno', value: 1 }, { text: 'Nombres', value: 2 }, { text: 'DNI', value: 3 }, { text: 'Correo', value: 4 }, { text: 'Grado', value: 5 }, { text: 'Actions', align: 'center', value: '', sortable: false }],
      asesor: {
        dni: ''
      },
      grados: {
        '3A': { id: '3A', nombre: 'INICIAL 3 AÑOS', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true },
        '4A': { id: '4A', nombre: 'INICIAL 4 AÑOS', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true },
        '5A': { id: '5A', nombre: 'INICIAL 5 AÑOS', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true },
        '1P': { id: '1P', nombre: '1º PRIMARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true },
        '2P': { id: '2P', nombre: '2º PRIMARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true },
        '3P': { id: '3P', nombre: '3º PRIMARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true },
        '4P': { id: '4P', nombre: '4º PRIMARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true },
        '5P': { id: '5P', nombre: '5º PRIMARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true },
        '6P': { id: '6P', nombre: '6º PRIMARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true },
        '1S': { id: '1S', nombre: '1º SECUNDARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true },
        '2S': { id: '2S', nombre: '2º SECUNDARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true },
        '3S': { id: '3S', nombre: '3º SECUNDARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true },
        '4S': { id: '4S', nombre: '4º SECUNDARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true },
        '5S': { id: '5S', nombre: '5º SECUNDARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true }
      },
      datos: [],
      registro: {},
      grado: ''
    };
  },
  computed: {
    computedCierreFecha: function computedCierreFecha() {
      return this.formatoFecha(this.registro.cierreFecha);
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.cerrar();
    },
    'registro.cierreFecha': function registroCierreFecha(val) {
      this.cierreFecha = this.formatoFecha(this.registro.cierreFecha);
    }
  },
  created: function created() {
    this.initialize();
    if (this.login === false) {
      this.$router.push('/Ingresar');
    }
    this.apiListaRegistros(0, 0, 1, '3A');
    this.apiListaRegistros(0, 0, 1, '4A');
    this.apiListaRegistros(0, 0, 1, '5A');
    this.apiListaRegistros(0, 0, 1, '1P');
    this.apiListaRegistros(0, 0, 1, '2P');
    this.apiListaRegistros(0, 0, 1, '3P');
    this.apiListaRegistros(0, 0, 1, '4P');
    this.apiListaRegistros(0, 0, 1, '5P');
    this.apiListaRegistros(0, 0, 1, '6P');
    this.apiListaRegistros(0, 0, 1, '1S');
    this.apiListaRegistros(0, 0, 1, '2S');
    this.apiListaRegistros(0, 0, 1, '3S');
    this.apiListaRegistros(0, 0, 1, '4S');
    this.apiListaRegistros(0, 0, 1, '5S');
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina, grado) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina,
        grado: grado
      };
      solicitudApi.datos = datos;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=ficha&accion=listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$router.push('Ingresar');
        } else {
          _this.grados[grado].alumnos = datos.d.data;
          _this.totalRegistros = _this.datos.registros;
          _this.loading = false;
          _this.grados[grado].disabledAsesor = false;
          if (1 in datos.d.asesor) {
            _this.grados[grado].asesor.dni = datos.d.asesor[4];
            _this.grados[grado].asesor.apellidoPaterno = datos.d.asesor[1];
            _this.grados[grado].asesor.apellidoMaterno = datos.d.asesor[2];
            _this.grados[grado].asesor.nombres = datos.d.asesor[3];
            _this.grados[grado].asesor.correo = datos.d.asesor[6];
            _this.grados[grado].asesor.telefono = datos.d.asesor[5];
            _this.grados[grado].disabledAsesor = true;
          }
        }
      });
    },

    setTotal: function setTotal(total) {
      this.registro.comprobanteTotal = total;
    },
    registrarAlumo: function registrarAlumo(grado) {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      this.grados[grado].alumno.grado = grado;
      this.grados[grado].alumno.tipo = 'D';
      this.grados[grado].alumno.telefono = '';
      solicitudApi.datos = this.grados[grado].alumno;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=ficha&accion=guardar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.e === 1) {
          _this2.grados[grado].alumno = {
            apellidoPaterno: '',
            apellidoMaterno: '',
            nombres: '',
            dni: '',
            telefono: '',
            correo: ''
          };
          _this2.verAlumnos(grado);
        } else {
          alert(datos.m);
        }
      });
    },
    registrarAsesor: function registrarAsesor(grado) {
      var _this3 = this;

      var solicitudApi = this.crearSolicitud();
      this.grados[grado].asesor.grado = grado;
      this.grados[grado].asesor.tipo = 'A';
      solicitudApi.datos = this.grados[grado].asesor;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=ficha&accion=guardar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.e === 1) {
          _this3.grados[grado].disabledAsesor = true;
        } else {
          alert(datos.m);
        }
      });
    },
    verRegistro: function verRegistro(item) {
      var _this4 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = [];
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'ventas/cierre/ver/id/' + item.fila[0], { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this4.$emit('login', datos.m);
        } else {
          _this4.registro = datos.d;
          _this4.productosDetalle = {};
          if (item.fila[0] !== 0) {
            _this4.disabledRegistro = true;
          } else {
            _this4.disabledRegistro = false;
          }
          _this4.dialog = true;
        }
      });
    },
    nuevoRegistro: function nuevoRegistro() {
      this.verRegistro({ fila: [0] });
    },
    cerrar: function cerrar() {
      this.dialog = false;
      setTimeout(function () {}, 300);
    },
    verAlumnos: function verAlumnos(grado) {
      this.apiListaRegistros(0, 0, 1, grado);
    },
    imprimirCredencial: function imprimirCredencial() {
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { datos: this.datos.data };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'credencial.php', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.blob();
      }).then(function (fileBlob) {
        var newBlob = new Blob([fileBlob], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        var data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
        link.href = data;
        link.target = '_blank';
        link.click();
      });
    }
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  data: function data() {
    return {
      tabActivo: 0,
      dialog: false,
      disabledSede: false,
      disabledRegistro: false,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      menu: false,
      cierreFecha: null,
      headers: [{ text: 'Usuario', value: 0 }, { text: 'Estado', value: 1 }, { text: '', align: 'center', value: '', sortable: false }],
      datos: [],
      sedes: [],
      registro: { permisos: {} },
      estados: [{ id: 'A', nombre: 'Activo' }, { id: 'I', nombre: 'Inactivo' }],
      estados2: { 'A': 'Activo', 'I': 'Inactivo' }
    };
  },
  computed: {},
  watch: {
    dialog: function dialog(val) {
      val || this.cerrar();
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.initialize();
    if (this.login === false) {
      this.$router.push('/Ingresar');
    }
    this.pagination.rowsPerPage = 10;
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      };
      solicitudApi.datos = datos;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=usuarios&accion=listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.datos = datos.d;
          _this.totalRegistros = _this.datos.registros;
          if (parseInt(_this.datos.pagina) !== parseInt(_this.pagination.page)) {
            _this.pagination.page = parseInt(_this.datos.pagina);
          }
          _this.loading = false;
        }
      });
    },
    verRegistro: function verRegistro(item) {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { 'id': item.fila[0] };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=usuarios&accion=ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          _this2.registro = datos.d;
          if (item.fila[0] !== 0) {
            _this2.disabledRegistro = true;
            _this2.disabledSede = false;
          } else {
            _this2.disabledRegistro = false;
            _this2.disabledSede = true;
          }
          _this2.dialog = true;
        }
      });
    },
    editarRegistro: function editarRegistro(item) {
      var _this3 = this;

      this.disabledSede = false;
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { 'id': item.fila[0] };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=usuarios&accion=ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this3.$emit('login', datos.m);
        } else {
          _this3.registro = datos.d;
          _this3.disabledRegistro = false;
          _this3.dialog = true;
        }
      });
    },
    nuevoRegistro: function nuevoRegistro() {
      this.tabActivo = 0;
      this.verRegistro({ fila: [0] });
    },
    cerrar: function cerrar() {
      this.dialog = false;
      setTimeout(function () {}, 300);
    },
    guardar: function guardar() {
      var _this4 = this;

      this.cerrar();
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=usuarios&accion=guardar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this4.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this4.verRegistro({ fila: [datos.d.id] });
            var descendente = 0;
            if (_this4.pagination.descending) {
              descendente = 1;
            }
            _this4.apiListaRegistros(_this4.pagination.sortBy, descendente, _this4.pagination.page);
          } else {
            alert(datos.m);
          }
        }
      });
    }
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  data: function data() {
    return {
      dialog: false,
      disabledRegistro: false,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      menu: false,
      cierreFecha: null,
      headers: [{ text: 'Apellido paterno', value: 0 }, { text: 'Apellido materno', value: 1 }, { text: 'Nombres', value: 2 }, { text: 'DNI', value: 3 }, { text: 'Teléfono', value: 4 }, { text: 'Correo', value: 5 }, { text: 'Colegio', value: 6 }, { text: 'Grado', value: 7 }, { text: 'Actions', align: 'center', value: '', sortable: false }],
      tiposColegio: [{ id: 'E', nombre: 'ESTATAL' }, { id: 'P', nombre: 'PRIVADO' }],
      sedes: [{ id: '1', nombre: 'PUNO' }, { id: '2', nombre: 'JULIACA' }, { id: '3', nombre: 'ILAVE' }],
      datos: [],
      registro: {},
      requeridoRegla: [function (v) {
        return !!v || 'Requerido';
      }
      // v => (v && v.length <= 10) || 'Name must be less than 10 characters'
      ],
      emailRegla: [function (v) {
        return !!v || 'Correo es requerido';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Correo debe ser válido'
        );
      }]
    };
  },
  computed: {
    computedCierreFecha: function computedCierreFecha() {
      return this.formatoFecha(this.registro.cierreFecha);
    },
    registroTotal: function registroTotal() {
      var total = 0;
      if (this.registro.cierreBilletes200) total += parseFloat(this.registro.cierreBilletes200);
      if (this.registro.cierreBilletes100) total += parseFloat(this.registro.cierreBilletes100);
      if (this.registro.cierreBilletes50) total += parseFloat(this.registro.cierreBilletes50);
      if (this.registro.cierreBilletes20) total += parseFloat(this.registro.cierreBilletes20);
      if (this.registro.cierreBilletes10) total += parseFloat(this.registro.cierreBilletes10);
      if (this.registro.cierreMonedas) total += parseFloat(this.registro.cierreMonedas);
      return total;
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.cerrar();
    },
    'registro.cierreFecha': function registroCierreFecha(val) {
      this.cierreFecha = this.formatoFecha(this.registro.cierreFecha);
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.initialize();
    if (this.login === false) {
      this.$router.push('/Ingresar');
    }
    this.verRegistro();
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      };
      solicitudApi.datos = datos;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=colegio&accion=listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.datos = datos.d;
          _this.totalRegistros = _this.datos.registros;
          if (parseInt(_this.datos.pagina) !== parseInt(_this.pagination.page)) {
            _this.pagination.page = parseInt(_this.datos.pagina);
          }
          _this.loading = false;
        }
      });
    },

    setTotal: function setTotal(total) {
      this.registro.comprobanteTotal = total;
    },
    verRegistro: function verRegistro() {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = [];
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=colegio&accion=ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          _this2.registro = datos.d;
          _this2.disabledRegistro = true;
        }
      });
    },
    nuevoRegistro: function nuevoRegistro() {
      this.verRegistro({ fila: [0] });
    },
    cerrar: function cerrar() {
      this.dialog = false;
      setTimeout(function () {}, 300);
    },
    guardar: function guardar() {
      var _this3 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=colegio&accion=guardar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this3.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this3.verRegistro();
            _this3.disabledRegistro = true;
          }
        }
      });
    }
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  props: ['login', 'tipoUsuario', 'usuarioApp', 'sedes'],
  data: function data() {
    return {
      dialog: false,
      disabledRegistro: false,
      disabledAsesor: false,
      validarAlumno: true,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      menu: false,
      cierreFecha: null,
      buscar: '',
      eliminar: false,
      headers: [{ text: 'Código', value: 0 }, { text: 'Nombre', value: 1 }, { text: 'RUC', value: 2 }, { text: 'Teléfono', value: 3 }, { text: 'Correo', value: 4 }, { text: 'Sede', value: 5 }, { text: 'Ver', align: 'center', value: '', sortable: false }],
      datos: [],
      registro: {},
      grado: '',
      tiposColegio: [{ 'id': 'E', 'nombre': 'ESTATAL' }, { 'id': 'P', 'nombre': 'PRIVADO' }],
      asesor: []
    };
  },
  computed: {},
  watch: {
    dialog: function dialog(val) {
      val || this.cerrar();
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.initialize();
    if (this.login === false) {
      this.$router.push('/Ingresar');
    }
    this.pagination.rowsPerPage = 10;
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina,
        grado: '',
        buscar: this.buscar
      };
      solicitudApi.datos = datos;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=colegios&accion=listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.datos = datos.d;
          _this.totalRegistros = _this.datos.registros;
          if (parseInt(_this.datos.pagina) !== parseInt(_this.pagination.page)) {
            _this.pagination.page = parseInt(_this.datos.pagina);
          }
          _this.loading = false;
        }
      });
    },
    verRegistro: function verRegistro(item) {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { 'id': item.fila[0] };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=colegios&accion=ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          _this2.registro = datos.d;
          _this2.productosDetalle = {};
          if (item.fila[0] !== 0) {
            _this2.disabledRegistro = true;
          } else {
            _this2.disabledRegistro = false;
          }
          _this2.dialog = true;
        }
      });
    },
    editarRegistro: function editarRegistro(item) {
      var _this3 = this;

      this.disabledSede = false;
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { 'id': item.fila[0] };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=colegios&accion=ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this3.$emit('login', datos.m);
        } else {
          _this3.registro = datos.d;
          _this3.disabledRegistro = false;
          _this3.dialog = true;
        }
      });
    },
    nuevoRegistro: function nuevoRegistro() {
      this.verRegistro({ fila: [0] });
    },
    cerrar: function cerrar() {
      this.eliminar = false;
      this.dialog = false;
      setTimeout(function () {}, 300);
    },
    guardar: function guardar() {
      var _this4 = this;

      this.cerrar();
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=colegios&accion=guardar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this4.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this4.verRegistro({ fila: [datos.d.id] });
            var descendente = 0;
            if (_this4.pagination.descending) {
              descendente = 1;
            }
            _this4.apiListaRegistros(_this4.pagination.sortBy, descendente, _this4.pagination.page);
          } else {
            alert(datos.m);
          }
        }
      });
    },
    actualizar: function actualizar() {
      var descendente = 0;
      if (this.pagination.descending) {
        descendente = 1;
      }
      this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
    },
    eliminarRegistro: function eliminarRegistro(item) {
      var _this5 = this;

      if (!this.eliminar) {
        this.eliminar = true;
        return;
      }
      this.cerrar();
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { 'id': this.registro.id };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=colegios&accion=eliminar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this5.$emit('login', datos.m);
        } else {
          _this5.disabledRegistro = false;
          _this5.eliminar = false;
          _this5.dialog = false;
          var descendente = 0;
          if (_this5.pagination.descending) {
            descendente = 1;
          }
          _this5.apiListaRegistros(_this5.pagination.sortBy, descendente, _this5.pagination.page);
        }
      });
    }
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ubicacion_js__ = __webpack_require__(31);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__ubicacion_js__["a" /* default */]],
  props: ['login', 'tipoUsuario', 'usuarioApp'],
  data: function data() {
    return {
      dialog: false,
      dialogMover: false,
      dialogPago: false,
      disabledRegistro: false,
      disabledExcel: false,
      validarInscripcion: true,
      eliminar: false,
      eliminarRegistrosCheck: false,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      menu: false,
      cierreFecha: null,
      colegioFiltro: 'LIBRE',
      colegios: [],
      tiposColegio: ['ESTATAL', 'PRIVADO'],
      tiposInscripcion: ['VIRTUAL', 'PRESENCIAL'],
      buscar: '',
      grados: [{ id: '3A', nombre: 'INICIAL 3 AÑOS' }, { id: '4A', nombre: 'INICIAL 4 AÑOS' }, { id: '5A', nombre: 'INICIAL 5 AÑOS' }, { id: '1P', nombre: '1º PRIMARIA' }, { id: '2P', nombre: '2º PRIMARIA' }, { id: '3P', nombre: '3º PRIMARIA' }, { id: '4P', nombre: '4º PRIMARIA' }, { id: '5P', nombre: '5º PRIMARIA' }, { id: '6P', nombre: '6º PRIMARIA' }, { id: '1S', nombre: '1º SECUNDARIA' }, { id: '2S', nombre: '2º SECUNDARIA' }, { id: '3S', nombre: '3º SECUNDARIA' }, { id: '4S', nombre: '4º SECUNDARIA' }, { id: '5S', nombre: '5º SECUNDARIA' }],
      sedes: [{ id: '1', nombre: 'PUNO' }, { id: '2', nombre: 'JULIACA' }, { id: '3', nombre: 'ILAVE' }],
      selected: [],
      seleccionarTodo: true,
      headers: [{ text: '#', value: 0, sortable: false }, { text: 'Código', value: 1 }, { text: 'Apellido paterno', value: 2 }, { text: 'Apellido materno', value: 3 }, { text: 'Nombres', value: 4 }, { text: 'DNI', value: 5 }, { text: 'Teléfono', value: 6 }, { text: 'Correo', value: 7 }, { text: 'Colegio', value: 8 }, { text: 'Grado', value: 9 }, { text: 'Pago', value: '', sortable: false }, { text: 'Ver', align: 'center', value: '', sortable: false }, { text: 'Opciones', align: 'center', value: '', sortable: false }],
      datos: [],
      registro: {
        colegio: '',
        tipoColegio: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        nombres: '',
        dni: '',
        telefono: '',
        correo: '',
        grado: '',
        departamento: { id: '', nombre: '' },
        provincia: { id: '', nombre: '' },
        distrito: { id: '', nombre: '' },
        sede: ''
      },
      registro2: {
        codigo: '',
        nuevoColegio: ''
      },
      registro3: {
        codigoAlumno: '',
        codigoColegio: '',
        operacion: '',
        monto: '',
        voucher: ''
      },
      voucherURL: '',
      voucherArchivo: '',
      excel: ''
    };
  },
  computed: {
    provincias: function provincias() {
      return this.listaProvincias[this.registro.departamento.id];
    },
    distritos: function distritos() {
      return this.listaDistritos[this.registro.provincia.id];
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.cerrar();
    },
    'registro.cierreFecha': function registroCierreFecha(val) {
      this.cierreFecha = this.formatoFecha(this.registro.cierreFecha);
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    },
    'colegioFiltro': function colegioFiltro(val) {
      var descendente = 0;
      if (this.pagination.descending) {
        descendente = 1;
      }
      this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
    }
  },
  created: function created() {
    this.initialize();
    if (this.login === false) {
      this.$router.push('/Ingresar');
    }
    this.pagination.rowsPerPage = 10;
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    toggleAll: function toggleAll() {
      if (this.seleccionarTodo) {
        for (var item in this.datos.data) {
          this.datos.data[item].fila[19] = false;
        }
        this.seleccionarTodo = false;
        this.$forceUpdate();
      } else {
        for (var _item in this.datos.data) {
          this.datos.data[_item].fila[19] = true;
        }
        this.seleccionarTodo = true;
        this.$forceUpdate();
      }
    },
    changeSort: function changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina,
        filtro: this.colegioFiltro,
        buscar: this.buscar
      };
      solicitudApi.datos = datos;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=libres&accion=listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          var contar = (datos.d.pagina - 1) * _this.pagination.rowsPerPage + 1;
          for (var indice in datos.d.data) {
            datos.d.data[indice].fila[18] = contar;
            datos.d.data[indice].fila[19] = true;
            contar++;
          }
          _this.datos = datos.d;
          _this.totalRegistros = _this.datos.registros;
          if (_this.colegios.length === 0) {
            _this.colegios = _this.datos.colegios;
          }
          _this.datos.colegios = [];
          if (parseInt(_this.datos.pagina) !== parseInt(_this.pagination.page)) {
            _this.pagination.page = parseInt(_this.datos.pagina);
          }
          _this.loading = false;
          _this.$forceUpdate();
        }
      });
    },

    setTotal: function setTotal(total) {
      this.registro.comprobanteTotal = total;
    },
    cambiarColegio: function cambiarColegio(item) {
      this.registro2 = {
        codigo: item.fila[15],
        nuevoColegio: ''
      };
      this.dialogMover = true;
    },
    cerrarCambiarColegio: function cerrarCambiarColegio(item) {
      this.dialogMover = false;
    },
    guardarCambiarColegio: function guardarCambiarColegio() {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro2;
      solicitudApi.datos.filtro = this.colegioFiltro;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=libres&accion=guardar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this2.cerrarCambiarColegio();
            var descendente = 0;
            if (_this2.pagination.descending) {
              descendente = 1;
            }
            _this2.apiListaRegistros(_this2.pagination.sortBy, descendente, _this2.pagination.page);
          } else {
            alert(datos.m);
          }
        }
      });
    },
    verRegistro: function verRegistro(item) {
      var _this3 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { 'id': item.fila[0], filtro: this.colegioFiltro };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=libres&accion=ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this3.$emit('login', datos.m);
        } else {
          _this3.registro = datos.d;
          if (item.fila[0] !== 0) {
            _this3.disabledRegistro = true;
          } else {
            _this3.disabledRegistro = false;
          }
          _this3.dialog = true;
        }
      });
    },
    editarRegistro: function editarRegistro(item) {
      var _this4 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { 'id': item.fila[0] };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=libres&accion=ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this4.$emit('login', datos.m);
        } else {
          _this4.registro = datos.d;
          _this4.disabledRegistro = false;
          _this4.dialog = true;
        }
      });
    },
    eliminarRegistrosConfirmar: function eliminarRegistrosConfirmar(estado) {
      if (estado === 0) {
        this.eliminarRegistrosCheck = false;
      } else {
        this.eliminarRegistrosCheck = true;
      }
    },
    eliminarRegistro: function eliminarRegistro(item) {
      var _this5 = this;

      if (!this.eliminar) {
        this.eliminar = true;
        return;
      }
      this.cerrar();
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { 'id': this.registro.id };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=libres&accion=eliminar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this5.$emit('login', datos.m);
        } else {
          _this5.disabledRegistro = false;
          _this5.eliminar = false;
          _this5.dialog = false;
          var descendente = 0;
          if (_this5.pagination.descending) {
            descendente = 1;
          }
          _this5.apiListaRegistros(_this5.pagination.sortBy, descendente, _this5.pagination.page);
        }
      });
    },
    eliminarRegistros: function eliminarRegistros() {
      var _this6 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { datos: this.datos.data };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=libres&accion=eliminarRegistros', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this6.$emit('login', datos.m);
        } else {
          var descendente = 0;
          if (_this6.pagination.descending) {
            descendente = 1;
          }
          _this6.eliminarRegistrosCheck = false;
          _this6.apiListaRegistros(_this6.pagination.sortBy, descendente, _this6.pagination.page);
        }
      });
    },
    nuevoRegistro: function nuevoRegistro() {
      this.verRegistro({ fila: [0] });
    },
    cerrar: function cerrar() {
      this.eliminar = false;
      this.dialog = false;
      setTimeout(function () {}, 300);
    },
    guardar: function guardar(mostrar) {
      var _this7 = this;

      /* if (!this.$refs.form.validate()) {
        return
      } */
      if (this.registro.recibo === '' && this.registro.monto !== '0.00') {
        alert('Debe colocar el número de recibo');
        return;
      }
      if (this.registro.recibo !== '' && this.registro.monto === '0.00') {
        alert('El monto no puede ser 0');
        return;
      }
      this.cerrar();
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      solicitudApi.datos.filtro = this.colegioFiltro;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=libres&accion=guardar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this7.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            if (mostrar === 1) {
              _this7.verRegistro({ fila: [datos.d.id] });
            }
            var descendente = 0;
            if (_this7.pagination.descending) {
              descendente = 1;
            }
            _this7.apiListaRegistros(_this7.pagination.sortBy, descendente, _this7.pagination.page);
          } else {
            alert(datos.m);
          }
        }
      });
    },
    imprimirCredencial: function imprimirCredencial(item) {
      // this.$router.push('/Credenciales/' + item.fila[0])
      var solicitudApi = this.crearSolicitud();
      if (item === '') {
        solicitudApi.datos = { datos: this.datos.data };
      } else {
        solicitudApi.datos = { datos: [item] };
      }
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'credencial.php', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.blob();
      }).then(function (fileBlob) {
        var newBlob = new Blob([fileBlob], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        var data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
        link.href = data;
        link.target = '_blank';
        link.click();
      });
    },
    informarPago: function informarPago(item) {
      // this.$router.push('/Pago/' + item.fila[0])
      if (this.colegioFiltro !== 'LIBRE') {
        this.registro3 = {
          codigoAlumno: '',
          codigoColegio: this.colegioFiltro,
          numero: '',
          monto: '',
          voucher: ''
        };
      } else {
        this.registro3 = {
          codigoAlumno: item.fila[15],
          codigoColegio: '',
          numero: '',
          monto: '',
          voucher: ''
        };
      }
      this.dialogPago = true;
    },
    cerrarInformarPago: function cerrarInformarPago(item) {
      this.dialogPago = false;
    },
    registrarPago: function registrarPago() {
      var _this8 = this;

      var solicitudApi = this.crearSolicitud();
      if (this.registro3.operacion === undefined || this.registro3.monto === undefined || this.registro3.operacion === '' || this.registro3.monto === '') {
        alert('Debe llenar todos los campos');
      } else if (this.registro3.monto === '0.00') {
        alert('Monto no puede ser 0');
      } else {
        solicitudApi.datos = this.registro3;
        var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=pago&accion=guardar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
        return fetch(myRequest).then(function (response) {
          return response.json();
        }).then(function (datos) {
          if (datos.l === false) {
            _this8.$emit('login', datos.m);
          } else {
            if (datos.e === 1) {
              var descendente = 0;
              if (_this8.pagination.descending) {
                descendente = 1;
              }
              _this8.registro3 = {};
              _this8.voucherURL = '';
              _this8.apiListaRegistros(_this8.pagination.sortBy, descendente, _this8.pagination.page);
              _this8.cerrarInformarPago();
            } else {
              alert(datos.m);
            }
          }
        });
      }
    },
    subirVoucher: function subirVoucher() {
      this.$refs.image.click();
    },
    registrarVoucher: function registrarVoucher(url, archivo) {
      this.voucherURL = url;
      this.registro3.voucher = encodeURIComponent(url);
      this.voucherArchivo = archivo;
    },
    mostrarVoucher: function mostrarVoucher(archivo) {
      if (archivo !== null) {
        return decodeURIComponent(archivo);
      }
      return '';
    },
    onSubirVoucher: function onSubirVoucher(e) {
      var _this9 = this;

      var files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return;
        }
        var fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', function () {
          var img = document.createElement('img');
          img.src = fr.result;
          img.addEventListener('load', function () {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            var MAX_WIDTH = 400;
            var MAX_HEIGHT = 400;
            var width = img.width;
            var height = img.height;

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
              }
            }
            canvas.width = width;
            canvas.height = height;
            ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            _this9.registrarVoucher(canvas.toDataURL(files[0].type), files[0]);
          });
        });
      } else {
        this.voucherArchivo = '';
        this.voucherURL = '';
      }
    },
    setExcel: function setExcel(data) {
      this.excel = data;
    },
    onSubirExcel: function onSubirExcel() {
      var _this10 = this;

      var files = this.$refs.excelFile.files;
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return;
        }
        var fr = new FileReader();
        // fr.readAsDataURL(files[0])
        fr.readAsBinaryString(files[0]);
        fr.onload = function () {
          _this10.setExcel(fr.result);
        };
        fr.onerror = function (error) {
          console.log('Error ', error);
        };
      }
    },
    validarRegistro: function validarRegistro() {
      if (this.registro.colegio === '') {
        alert('Debe rellenar el Colegio');
        return false;
      }
      if (this.registro.apellidoPaterno === '') {
        alert('Debe rellenar el apellido paterno');
        return false;
      }
      if (this.registro.apellidoMaterno === '') {
        alert('Debe rellenar el apellido materno');
        return false;
      }
      if (this.registro.nombres === '') {
        alert('Debe rellenar el nombre');
        return false;
      }
      if (this.registro.dni === '' || this.registro.dni.length !== 8) {
        alert('DNI incorrecto: ' + this.registro.dni);
        return false;
      }
      if (this.registro.telefono === '') {
        alert('Debe rellenar el teléfono');
        return false;
      }
      return true;
    },
    registrarExcel: function registrarExcel() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var XLSX, libro, primeraHoja, excelFilas, excelFila, nSede, nDepartamento, nProvincia, nDistrito;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this11.disabledExcel = true;
                XLSX = __webpack_require__(47);
                libro = XLSX.read(_this11.excel, {
                  type: 'binary'
                });
                primeraHoja = libro.SheetNames[0];
                excelFilas = XLSX.utils.sheet_to_json(libro.Sheets[primeraHoja]);
                _context.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(excelFilas);

              case 6:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 52;
                  break;
                }

                excelFila = _context.t1.value;

                if (excelFilas[excelFila]['Sede'] === undefined) {
                  excelFilas[excelFila]['Sede'] = localStorage.getItem('local');
                }

                if (!(excelFilas[excelFila]['Colegio'] === undefined || excelFilas[excelFila]['Tipo de colegio'] === undefined || excelFilas[excelFila]['Apellido paterno'] === undefined || excelFilas[excelFila]['Apellido materno'] === undefined || excelFilas[excelFila]['Nombres'] === undefined || excelFilas[excelFila]['DNI'] === undefined || excelFilas[excelFila]['Teléfono'] === undefined || excelFilas[excelFila]['Correo'] === undefined || excelFilas[excelFila]['Grado'] === undefined || excelFilas[excelFila]['Departamento'] === undefined || excelFilas[excelFila]['Provincia'] === undefined || excelFilas[excelFila]['Distrito'] === undefined || excelFilas[excelFila]['Recibo'] === undefined || excelFilas[excelFila]['Monto'] === undefined || excelFilas[excelFila]['Sede'] === undefined)) {
                  _context.next = 12;
                  break;
                }

                alert('Excel no reconocido');
                return _context.abrupt('return');

              case 12:
                if (!(excelFilas[excelFila]['Tipo de colegio'] !== 'E' && excelFilas[excelFila]['Tipo de colegio'] !== 'P')) {
                  _context.next = 15;
                  break;
                }

                alert('Tipo de colegio no reconocido - Fila ' + excelFila);
                return _context.abrupt('return');

              case 15:
                if (!(excelFilas[excelFila]['Grado'] !== '3A' && excelFilas[excelFila]['Grado'] !== '4A' && excelFilas[excelFila]['Grado'] !== '5A' && excelFilas[excelFila]['Grado'] !== '1P' && excelFilas[excelFila]['Grado'] !== '2P' && excelFilas[excelFila]['Grado'] !== '3P' && excelFilas[excelFila]['Grado'] !== '4P' && excelFilas[excelFila]['Grado'] !== '5P' && excelFilas[excelFila]['Grado'] !== '6P' && excelFilas[excelFila]['Grado'] !== '1S' && excelFilas[excelFila]['Grado'] !== '2S' && excelFilas[excelFila]['Grado'] !== '3S' && excelFilas[excelFila]['Grado'] !== '4S' && excelFilas[excelFila]['Grado'] !== '5S')) {
                  _context.next = 18;
                  break;
                }

                alert('Grado no reconocido - Fila ' + excelFila);
                return _context.abrupt('return');

              case 18:
                if (typeof excelFilas[excelFila]['DNI'] !== 'string') {
                  excelFilas[excelFila]['DNI'] = excelFilas[excelFila]['DNI'].toString();
                }
                _this11.registro = {
                  'colegio': excelFilas[excelFila]['Colegio'],
                  'tipoColegio': excelFilas[excelFila]['Tipo de colegio'],
                  'inscripcion': 'PRESENCIAL',
                  'id': '0',
                  'apellidoPaterno': excelFilas[excelFila]['Apellido paterno'],
                  'apellidoMaterno': excelFilas[excelFila]['Apellido materno'],
                  'nombres': excelFilas[excelFila]['Nombres'],
                  'dni': excelFilas[excelFila]['DNI'],
                  'telefono': excelFilas[excelFila]['Teléfono'],
                  'correo': excelFilas[excelFila]['Correo'],
                  'grado': excelFilas[excelFila]['Grado'],
                  'departamento': {},
                  'provincia': {},
                  'distrito': {},
                  'sede': excelFilas[excelFila]['Sede'],
                  'recibo': excelFilas[excelFila]['Recibo'],
                  'monto': excelFilas[excelFila]['Monto'] + '.00',
                  'codigo': '',
                  'clave': ''
                  // console.log(excelFilas[excelFila]['Sede'])
                };nSede = _this11.sedes.findIndex(function (i) {
                  return i.nombre === excelFilas[excelFila]['Sede'].toUpperCase();
                });

                if (!(nSede < 0)) {
                  _context.next = 26;
                  break;
                }

                alert('Sede no reconocida - Fila ' + excelFila);
                return _context.abrupt('return');

              case 26:
                _this11.registro.sede = _this11.sedes[nSede].id;

              case 27:
                nDepartamento = _this11.departamentos.findIndex(function (i) {
                  return i.nombre === excelFilas[excelFila]['Departamento'].toUpperCase();
                });

                if (!(nDepartamento < 0)) {
                  _context.next = 33;
                  break;
                }

                alert('Departamento no reconocido - Fila ' + excelFila);
                return _context.abrupt('return');

              case 33:
                _this11.registro.departamento = _this11.departamentos[nDepartamento];

              case 34:
                nProvincia = _this11.listaProvincias[_this11.registro.departamento.id].findIndex(function (i) {
                  return i.nombre === excelFilas[excelFila]['Provincia'].toUpperCase();
                });

                if (!(nProvincia < 0)) {
                  _context.next = 40;
                  break;
                }

                alert('Provincia no reconocida - Fila ' + excelFila);
                return _context.abrupt('return');

              case 40:
                _this11.registro.provincia = _this11.listaProvincias[_this11.registro.departamento.id][nProvincia];

              case 41:
                nDistrito = _this11.listaDistritos[_this11.registro.provincia.id].findIndex(function (i) {
                  return i.nombre === excelFilas[excelFila]['Distrito'].toUpperCase();
                });

                if (!(nDistrito < 0)) {
                  _context.next = 47;
                  break;
                }

                alert('Distrito no reconocido - Fila ' + excelFila);
                return _context.abrupt('return');

              case 47:
                _this11.registro.distrito = _this11.listaDistritos[_this11.registro.provincia.id][nDistrito];

              case 48:
                if (_this11.validarRegistro()) {
                  _context.next = 50;
                  break;
                }

                return _context.abrupt('return');

              case 50:
                _context.next = 6;
                break;

              case 52:
                _context.t2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(excelFilas);

              case 53:
                if ((_context.t3 = _context.t2()).done) {
                  _context.next = 68;
                  break;
                }

                excelFila = _context.t3.value;

                _this11.registro = {
                  'colegio': excelFilas[excelFila]['Colegio'],
                  'tipoColegio': excelFilas[excelFila]['Tipo de colegio'],
                  'inscripcion': 'PRESENCIAL',
                  'id': '0',
                  'apellidoPaterno': excelFilas[excelFila]['Apellido paterno'],
                  'apellidoMaterno': excelFilas[excelFila]['Apellido materno'],
                  'nombres': excelFilas[excelFila]['Nombres'],
                  'dni': excelFilas[excelFila]['DNI'],
                  'telefono': excelFilas[excelFila]['Teléfono'],
                  'correo': excelFilas[excelFila]['Correo'],
                  'grado': excelFilas[excelFila]['Grado'],
                  'departamento': {},
                  'provincia': {},
                  'distrito': {},
                  'sede': excelFilas[excelFila]['Sede'],
                  'recibo': excelFilas[excelFila]['Recibo'],
                  'monto': excelFilas[excelFila]['Monto'] + '.00',
                  'codigo': '',
                  'clave': ''
                };
                nSede = _this11.sedes.findIndex(function (i) {
                  return i.nombre === excelFilas[excelFila]['Sede'].toUpperCase();
                });
                _this11.registro.sede = _this11.sedes[nSede].id;
                nDepartamento = _this11.departamentos.findIndex(function (i) {
                  return i.nombre === excelFilas[excelFila]['Departamento'].toUpperCase();
                });
                _this11.registro.departamento = _this11.departamentos[nDepartamento];
                nProvincia = _this11.listaProvincias[_this11.registro.departamento.id].findIndex(function (i) {
                  return i.nombre === excelFilas[excelFila]['Provincia'].toUpperCase();
                });
                _this11.registro.provincia = _this11.listaProvincias[_this11.registro.departamento.id][nProvincia];
                nDistrito = _this11.listaDistritos[_this11.registro.provincia.id].findIndex(function (i) {
                  return i.nombre === excelFilas[excelFila]['Distrito'].toUpperCase();
                });
                _this11.registro.distrito = _this11.listaDistritos[_this11.registro.provincia.id][nDistrito];
                _context.next = 66;
                return _this11.guardar(0);

              case 66:
                _context.next = 53;
                break;

              case 68:
                _this11.disabledExcel = false;

              case 69:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this11);
      }))();
    },
    actualizar: function actualizar() {
      var descendente = 0;
      if (this.pagination.descending) {
        descendente = 1;
      }
      this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
    }
  }
});

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ubicacion_js__ = __webpack_require__(31);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__ubicacion_js__["a" /* default */]],
  props: ['login', 'tipoUsuario', 'usuarioApp'],
  data: function data() {
    return {
      dialog: false,
      disabledRegistro: false,
      validarInscripcion: true,
      eliminar: false,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      menu: false,
      cierreFecha: null,
      tiposColegio: ['ESTATAL', 'PRIVADO'],
      tiposInscripcion: ['VIRTUAL', 'PRESENCIAL'],
      grados: [{ id: '3A', nombre: 'INICIAL 3 AÑOS' }, { id: '4A', nombre: 'INICIAL 4 AÑOS' }, { id: '5A', nombre: 'INICIAL 5 AÑOS' }, { id: '1P', nombre: '1º PRIMARIA' }, { id: '2P', nombre: '2º PRIMARIA' }, { id: '3P', nombre: '3º PRIMARIA' }, { id: '4P', nombre: '4º PRIMARIA' }, { id: '5P', nombre: '5º PRIMARIA' }, { id: '6P', nombre: '6º PRIMARIA' }, { id: '1S', nombre: '1º SECUNDARIA' }, { id: '2S', nombre: '2º SECUNDARIA' }, { id: '3S', nombre: '3º SECUNDARIA' }, { id: '4S', nombre: '4º SECUNDARIA' }, { id: '5S', nombre: '5º SECUNDARIA' }],
      sedes: [{ id: '1', nombre: 'PUNO' }, { id: '2', nombre: 'JULIACA' }, { id: '3', nombre: 'ILAVE' }],
      headers: [{ text: '#', value: 0 }, { text: 'Código', value: 1 }, { text: 'Apellido paterno', value: 2 }, { text: 'Apellido materno', value: 3 }, { text: 'Nombres', value: 4 }, { text: 'DNI', value: 5 }, { text: 'Teléfono', value: 6 }, { text: 'Correo', value: 7 }, { text: 'Colegio', value: 8 }, { text: 'Grado', value: 9 }, { text: 'Ver', align: 'center', value: '', sortable: false }],
      datos: [],
      registro: {
        colegio: '',
        tipoColegio: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        nombres: '',
        dni: '',
        telefono: '',
        correo: '',
        grado: '',
        departamento: { id: '', nombre: '' },
        provincia: { id: '', nombre: '' },
        distrito: { id: '', nombre: '' },
        sede: ''
      }
    };
  },
  computed: {
    provincias: function provincias() {
      return this.listaProvincias[this.registro.departamento.id];
    },
    distritos: function distritos() {
      return this.listaDistritos[this.registro.provincia.id];
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.cerrar();
    },
    'registro.cierreFecha': function registroCierreFecha(val) {
      this.cierreFecha = this.formatoFecha(this.registro.cierreFecha);
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.initialize();
    if (this.login === false) {
      this.$router.push('/Ingresar');
    }
    this.pagination.rowsPerPage = 10;
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      };
      solicitudApi.datos = datos;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=delegacion&accion=listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          var contar = 1;
          for (var indice in datos.d.data) {
            datos.d.data[indice].fila.splice(1, 0, contar);
            contar++;
          }
          _this.datos = datos.d;
          _this.totalRegistros = _this.datos.registros;
          if (parseInt(_this.datos.pagina) !== parseInt(_this.pagination.page)) {
            _this.pagination.page = parseInt(_this.datos.pagina);
          }
          _this.loading = false;
        }
      });
    },

    setTotal: function setTotal(total) {
      this.registro.comprobanteTotal = total;
    },
    verRegistro: function verRegistro(item) {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { 'id': item.fila[0] };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=delegacion&accion=ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          _this2.registro = datos.d;
          _this2.productosDetalle = {};
          if (item.fila[0] !== 0) {
            _this2.disabledRegistro = true;
          } else {
            _this2.disabledRegistro = false;
          }
          _this2.dialog = true;
        }
      });
    },
    editarRegistro: function editarRegistro(item) {
      var _this3 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { 'id': item.fila[0] };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=delegacion&accion=ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this3.$emit('login', datos.m);
        } else {
          _this3.registro = datos.d;
          _this3.disabledRegistro = false;
          _this3.dialog = true;
        }
      });
    },
    eliminarRegistro: function eliminarRegistro(item) {
      var _this4 = this;

      if (!this.eliminar) {
        this.eliminar = true;
        return;
      }
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { 'id': this.registro.id };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=delegacion&accion=eliminar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this4.$emit('login', datos.m);
        } else {
          _this4.disabledRegistro = false;
          _this4.eliminar = false;
          _this4.dialog = false;
          var descendente = 0;
          if (_this4.pagination.descending) {
            descendente = 1;
          }
          _this4.apiListaRegistros(_this4.pagination.sortBy, descendente, _this4.pagination.page);
          _this4.cerrar();
        }
      });
    },
    nuevoRegistro: function nuevoRegistro() {
      this.verRegistro({ fila: [0] });
    },
    cerrar: function cerrar() {
      this.eliminar = false;
      this.dialog = false;
      setTimeout(function () {}, 300);
    },
    guardar: function guardar() {
      var _this5 = this;

      this.cerrar();
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=delegacion&accion=guardar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this5.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this5.verRegistro({ fila: [datos.d.id] });
            var descendente = 0;
            if (_this5.pagination.descending) {
              descendente = 1;
            }
            _this5.apiListaRegistros(_this5.pagination.sortBy, descendente, _this5.pagination.page);
          }
        }
      });
    },
    imprimirCredencial: function imprimirCredencial(item) {
      this.$router.push('/Credenciales/' + item.fila[0]);
      /* var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {datos: [item]}
      const myRequest = new Request(`${process.env.API}credencial.php`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.blob())
        .then(fileBlob => {
          var newBlob = new Blob([fileBlob], {type: 'application/pdf'})
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
          }
          const data = window.URL.createObjectURL(newBlob)
          var link = document.createElement('a')
          link.href = data
          link.target = '_blank'
          link.click()
        }) */
    },
    informarPago: function informarPago(item) {
      this.$router.push('/Pago/' + item.fila[0]);
      /* var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {datos: [item]}
      const myRequest = new Request(`${process.env.API}credencial.php`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.blob())
        .then(fileBlob => {
          var newBlob = new Blob([fileBlob], {type: 'application/pdf'})
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
          }
          const data = window.URL.createObjectURL(newBlob)
          var link = document.createElement('a')
          link.href = data
          link.target = '_blank'
          link.click()
        }) */
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  data: function data() {
    return {
      dialog: false,
      disabledRegistro: false,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      menu: false,
      cierreFecha: null,
      headers: [{ text: 'Apellido paterno', value: 0 }, { text: 'Apellido materno', value: 1 }, { text: 'Nombres', value: 2 }, { text: 'DNI', value: 3 }, { text: 'Teléfono', value: 4 }, { text: 'Correo', value: 5 }, { text: 'Colegio', value: 6 }, { text: 'Grado', value: 7 }, { text: 'Actions', align: 'center', value: '', sortable: false }],
      datos: [],
      registro: {},
      lista: {},
      estados: ['', 'Por verificar', 'Procesado'],
      requeridoRegla: [function (v) {
        return !!v || 'Requerido';
      }
      // v => (v && v.length <= 10) || 'Name must be less than 10 characters'
      ],
      emailRegla: [function (v) {
        return !!v || 'Correo es requerido';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Correo debe ser válido'
        );
      }],
      voucherURL: '',
      voucherArchivo: ''
    };
  },
  computed: {
    computedCierreFecha: function computedCierreFecha() {
      return this.formatoFecha(this.registro.cierreFecha);
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.cerrar();
    },
    'registro.cierreFecha': function registroCierreFecha(val) {
      this.cierreFecha = this.formatoFecha(this.registro.cierreFecha);
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.initialize();
    if (this.login === false) {
      this.$router.push('/Ingresar');
    }
    this.verRegistro();
    this.apiListaRegistros(0, 0, 1);
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      };
      solicitudApi.datos = datos;
      if (this.$route.params.idAlumno !== undefined) {
        datos.idAlumno = this.$route.params.idAlumno;
      }
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=pago&accion=listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.datos = datos.d;
          _this.totalRegistros = _this.datos.registros;
          if (parseInt(_this.datos.pagina) !== parseInt(_this.pagination.page)) {
            _this.pagination.page = parseInt(_this.datos.pagina);
          }
          _this.loading = false;
        }
      });
    },

    setTotal: function setTotal(total) {
      this.registro.comprobanteTotal = total;
    },
    verRegistro: function verRegistro() {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = {};
      if (this.$route.params.idAlumno !== undefined) {
        solicitudApi.datos.idAlumno = this.$route.params.idAlumno;
      }
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=pago&accion=ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          _this2.lista = datos.d;
          _this2.disabledRegistro = true;
        }
      });
    },
    nuevoRegistro: function nuevoRegistro() {
      this.verRegistro({ fila: [0] });
    },
    cerrar: function cerrar() {
      this.dialog = false;
      setTimeout(function () {}, 300);
    },
    registrarPago: function registrarPago() {
      var _this3 = this;

      var totalPagar = this.lista.total;
      for (var item in this.datos.data) {
        totalPagar -= this.datos.data[item].fila[2];
      }
      if (parseFloat(this.registro.monto) !== parseFloat(totalPagar.replace(/,/g, ''))) {
        alert('Monto no corresponde con lo que debe pagar: ' + totalPagar);
        return;
      }
      var solicitudApi = this.crearSolicitud();
      if (this.registro.operacion === undefined || this.registro.monto === undefined || this.registro.voucher === undefined || this.registro.operacion === '' || this.registro.monto === '' || this.registro.voucher === '') {
        alert('Debe llenar todos los campos');
      } else if (this.registro.monto === '0.00') {
        alert('Monto no puede ser 0');
      } else {
        solicitudApi.datos = this.registro;
        if (this.$route.params.idAlumno !== undefined) {
          solicitudApi.datos.idAlumno = this.$route.params.idAlumno;
        }
        var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=pago&accion=guardar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
        return fetch(myRequest).then(function (response) {
          return response.json();
        }).then(function (datos) {
          if (datos.l === false) {
            _this3.$emit('login', datos.m);
          } else {
            if (datos.e === 1) {
              var descendente = 0;
              if (_this3.pagination.descending) {
                descendente = 1;
              }
              _this3.registro = {};
              _this3.voucherURL = '';
              _this3.apiListaRegistros(_this3.pagination.sortBy, descendente, _this3.pagination.page);
            } else {
              alert(datos.m);
            }
          }
        });
      }
    },
    subirVoucher: function subirVoucher() {
      this.$refs.image.click();
    },
    registrarVoucher: function registrarVoucher(url, archivo) {
      this.voucherURL = url;
      this.registro.voucher = encodeURIComponent(url);
      this.voucherArchivo = archivo;
    },
    mostrarVoucher: function mostrarVoucher(archivo) {
      if (archivo !== null) {
        return decodeURIComponent(archivo);
      }
      return '';
    },
    onSubirVoucher: function onSubirVoucher(e) {
      var _this4 = this;

      var files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return;
        }
        var fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', function () {
          var img = document.createElement('img');
          img.src = fr.result;
          img.addEventListener('load', function () {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            var MAX_WIDTH = 400;
            var MAX_HEIGHT = 400;
            var width = img.width;
            var height = img.height;

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
              }
            }
            canvas.width = width;
            canvas.height = height;
            ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            _this4.registrarVoucher(canvas.toDataURL(files[0].type), files[0]);
          });
        });
      } else {
        this.voucherArchivo = '';
        this.voucherURL = '';
      }
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  props: ['login', 'tipoUsuario', 'usuarioApp'],
  data: function data() {
    return {
      dialog: false,
      dialogVoucher: false,
      disabledRegistro: true,
      eliminar: false,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      menu: false,
      cierreFecha: null,
      voucherVer: '',
      voucherVerClase: '',
      buscar: '',
      headers: [{ text: 'Código', value: 0 }, { text: 'Tipo', value: 1 }, { text: 'Nombre', value: 2 }, { text: 'Número de operación', value: 3 }, { text: 'Monto', value: 4 }, { text: 'Estado', value: 5 }, { text: 'Voucher', align: 'center', value: '', sortable: false }, { text: 'Verificar', align: 'center', value: '', sortable: false }],
      datos: [],
      registro: {},
      lista: {},
      estados: ['', 'Por verificar', 'Procesado'],
      requeridoRegla: [function (v) {
        return !!v || 'Requerido';
      }
      // v => (v && v.length <= 10) || 'Name must be less than 10 characters'
      ],
      emailRegla: [function (v) {
        return !!v || 'Correo es requerido';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Correo debe ser válido'
        );
      }],
      voucherURL: '',
      voucherArchivo: ''
    };
  },
  computed: {
    computedCierreFecha: function computedCierreFecha() {
      return this.formatoFecha(this.registro.cierreFecha);
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.cerrar();
    },
    'registro.cierreFecha': function registroCierreFecha(val) {
      this.cierreFecha = this.formatoFecha(this.registro.cierreFecha);
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.initialize();
    if (this.login === false) {
      this.$router.push('/Ingresar');
    }
    this.pagination.rowsPerPage = 10;
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina) {
      var _this = this;

      this.loading = true;
      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina,
        buscar: this.buscar
      };
      solicitudApi.datos = datos;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=pagos&accion=listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.datos = datos.d;
          _this.totalRegistros = _this.datos.registros;
          if (parseInt(_this.datos.pagina) !== parseInt(_this.pagination.page)) {
            _this.pagination.page = parseInt(_this.datos.pagina);
          }
          _this.loading = false;
        }
      });
    },

    setTotal: function setTotal(total) {
      this.registro.comprobanteTotal = total;
    },
    verificarRegistro: function verificarRegistro(item, estado) {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { id: item.id, valor: estado };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=pagos&accion=guardar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            var descendente = 0;
            if (_this2.pagination.descending) {
              descendente = 1;
            }
            _this2.registro = {};
            _this2.voucherURL = '';
            _this2.apiListaRegistros(_this2.pagination.sortBy, descendente, _this2.pagination.page);
          } else {
            alert(datos.m);
          }
        }
      });
    },
    actualizar: function actualizar() {
      var descendente = 0;
      if (this.pagination.descending) {
        descendente = 1;
      }
      this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
    },
    eliminarRegistro: function eliminarRegistro(item, estado) {
      var _this3 = this;

      if (!this.eliminar) {
        this.registro.id = item.fila[0];
        this.registro.operacion = item.fila[4];
        this.dialog = true;
        this.eliminar = true;
        return;
      }
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { id: this.registro.id };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=pagos&accion=eliminar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this3.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            var descendente = 0;
            if (_this3.pagination.descending) {
              descendente = 1;
            }
            _this3.registro = {};
            _this3.voucherURL = '';
            _this3.dialog = false;
            _this3.apiListaRegistros(_this3.pagination.sortBy, descendente, _this3.pagination.page);
          } else {
            alert(datos.m);
          }
        }
      });
    },
    nuevoRegistro: function nuevoRegistro() {
      this.verRegistro({ fila: [0] });
    },
    abrirVoucher: function abrirVoucher(voucher) {
      this.voucherVerClase = '';
      this.voucherVer = voucher;
      this.dialogVoucher = true;
    },
    cerrarVoucher: function cerrarVoucher(voucher) {
      this.dialogVoucher = false;
    },
    cerrar: function cerrar() {
      this.dialog = false;
      this.eliminar = false;
      setTimeout(function () {}, 300);
    },
    registrarPago: function registrarPago() {
      var _this4 = this;

      var totalPagar = this.lista.total;
      for (var item in this.datos.data) {
        totalPagar -= this.datos.data[item].fila[2];
      }
      if (parseFloat(this.registro.monto) !== parseFloat(totalPagar.replace(/,/g, ''))) {
        alert('Monto no corresponde con lo que debe pagar: ' + totalPagar);
        return;
      }
      var solicitudApi = this.crearSolicitud();
      if (this.registro.operacion === undefined || this.registro.monto === undefined || this.registro.voucher === undefined || this.registro.operacion === '' || this.registro.monto === '' || this.registro.voucher === '') {
        alert('Debe llenar todos los campos');
      } else if (this.registro.monto === '0.00') {
        alert('Monto no puede ser 0');
      } else {
        solicitudApi.datos = this.registro;
        if (this.$route.params.idAlumno !== undefined) {
          solicitudApi.datos.idAlumno = this.$route.params.idAlumno;
        }
        var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=pago&accion=guardar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
        return fetch(myRequest).then(function (response) {
          return response.json();
        }).then(function (datos) {
          if (datos.l === false) {
            _this4.$emit('login', datos.m);
          } else {
            if (datos.e === 1) {
              var descendente = 0;
              if (_this4.pagination.descending) {
                descendente = 1;
              }
              _this4.registro = {};
              _this4.voucherURL = '';
              _this4.apiListaRegistros(_this4.pagination.sortBy, descendente, _this4.pagination.page);
            } else {
              alert(datos.m);
            }
          }
        });
      }
    },
    subirVoucher: function subirVoucher() {
      this.$refs.image.click();
    },
    registrarVoucher: function registrarVoucher(url, archivo) {
      this.voucherURL = url;
      this.registro.voucher = encodeURIComponent(url);
      this.voucherArchivo = archivo;
    },
    mostrarVoucher: function mostrarVoucher(archivo) {
      if (archivo !== null) {
        return decodeURIComponent(archivo);
      }
      return '';
    },
    rotar: function rotar() {
      if (this.voucherVerClase === '') {
        this.voucherVerClase = 'rotate90';
      } else if (this.voucherVerClase === 'rotate90') {
        this.voucherVerClase = 'rotate180';
      } else if (this.voucherVerClase === 'rotate180') {
        this.voucherVerClase = 'rotate270';
      } else {
        this.voucherVerClase = '';
      }
      this.$forceUpdate();
    },
    onSubirVoucher: function onSubirVoucher(e) {
      var _this5 = this;

      var files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return;
        }
        var fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', function () {
          var img = document.createElement('img');
          img.src = fr.result;
          img.addEventListener('load', function () {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            var MAX_WIDTH = 400;
            var MAX_HEIGHT = 400;
            var width = img.width;
            var height = img.height;

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
              }
            }
            canvas.width = width;
            canvas.height = height;
            ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            _this5.registrarVoucher(canvas.toDataURL(files[0].type), files[0]);
          });
        });
      } else {
        this.voucherArchivo = '';
        this.voucherURL = '';
      }
    }
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);

//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  data: function data() {
    return {
      loading: false,
      datos: [],
      registro: {},
      grado: '',
      asesor: {},
      lista: [],
      deuda: []
    };
  },
  created: function created() {
    this.initialize();
    if (this.login === false) {
      this.$router.push('/Ingresar');
    }
    this.verRegistro();
    this.listarDeudas(0, 0, 1);
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      this.loading = true;
      var datos = {
        tipo: 'lista',
        nfilas: 1000,
        idx: idx,
        ord: ord,
        pag: pagina,
        grado: ''
      };
      solicitudApi.datos = datos;
      if (this.$route.params.idAlumno !== undefined) {
        solicitudApi.datos.idAlumno = this.$route.params.idAlumno;
      }
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=ficha&accion=listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$router.push('Ingresar');
        } else {
          _this.datos = datos.d;
          _this.totalRegistros = _this.datos.registros;
          _this.loading = false;
          _this.imprimirCredencial();
        }
      });
    },
    listarDeudas: function listarDeudas(idx, ord, pagina) {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      var datos = {
        tipo: 'lista',
        nfilas: 0,
        idx: idx,
        ord: ord,
        pag: pagina
      };
      if (this.$route.params.idAlumno !== undefined) {
        datos.idAlumno = this.$route.params.idAlumno;
      }
      solicitudApi.datos = datos;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=pago&accion=listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          _this2.deuda = datos.d;
          _this2.totalRegistros = _this2.datos.registros;
          _this2.loading = false;
        }
      });
    },
    verRegistro: function verRegistro() {
      var _this3 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = {};
      if (this.$route.params.idAlumno !== undefined) {
        solicitudApi.datos.idAlumno = this.$route.params.idAlumno;
      }
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=pago&accion=ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this3.$emit('login', datos.m);
        } else {
          _this3.lista = datos.d;
          _this3.disabledRegistro = true;
        }
      });
    },
    imprimirCredencial: function imprimirCredencial() {
      var totalPagar = this.lista.total;
      for (var item in this.deuda.data) {
        totalPagar -= this.deuda.data[item].fila[2];
      }
      if (parseFloat(totalPagar) > 0) {
        alert('Debe registrar su pago: Falta S/' + totalPagar);
        return;
      }
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { datos: this.datos.data, asesores: this.datos.asesores };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'credencial.php', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.blob();
      }).then(function (fileBlob) {
        var newBlob = new Blob([fileBlob], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        var data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
        link.href = data;
        link.target = '_blank';
        link.click();
      });
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);

//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  data: function data() {
    return {
      loading: false,
      datos: [],
      registro: {},
      grado: '',
      asesor: {}
    };
  },
  created: function created() {
    if (this.login === false) {
      this.$router.push('/Ingresar');
    }
  },

  methods: {
    imprimirInscritos: function imprimirInscritos() {
      var solicitudApi = this.crearSolicitud();
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inscritos.php', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.blob();
      }).then(function (fileBlob) {
        var newBlob = new Blob([fileBlob], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        var data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
        link.href = data;
        link.target = '_blank';
        link.click();
      });
    }
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  props: ['login', 'tipoUsuario', 'usuarioApp'],
  data: function data() {
    return {
      dialog: false,
      disabledRegistro: false,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      menu: false,
      cierreFecha: null,
      headers: [],
      datos: [],
      registro: {},
      lista: {},
      voucherURL: '',
      voucherArchivo: ''
    };
  },
  computed: {
    computedCierreFecha: function computedCierreFecha() {
      return this.formatoFecha(this.registro.cierreFecha);
    }
  },
  watch: {},
  created: function created() {
    this.initialize();
    if (this.login === false) {
      this.$router.push('/Ingresar');
    }
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    buscarAlumno: function buscarAlumno(campo) {
      var _this = this;

      if (campo === 1) this.registro.codigo = '';else this.registro.dni = '';
      if ('codigo' in this.registro && this.registro.codigo.length >= 8 || 'dni' in this.registro && this.registro.dni.length === 8) {
        var solicitudApi = this.crearSolicitud();
        solicitudApi.datos = { codigo: this.registro.codigo, dni: this.registro.dni };
        var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=resultados&accion=ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
        return fetch(myRequest).then(function (response) {
          return response.json();
        }).then(function (datos) {
          if (datos.l === false) {
            _this.$emit('login', datos.m);
          } else {
            if (datos.e === 1) {
              _this.registro = datos.d;
              _this.$refs.buenas.focus();
            }
          }
        });
      } else {
        this.registro.alumno = '';
        this.registro.buenas = '';
        this.registro.malas = '';
        this.registro.vacias = '';
        this.registro.horaFin = '';
      }
    },
    calcularRespuestas: function calcularRespuestas() {
      if (parseInt(this.registro.buenas) === this.registro.totalPreguntas) {
        this.registro.malas = '00';
      }
      if (this.registro.buenas.length > 1 && this.registro.malas.length < 1) {
        this.$refs.malas.focus();
      } else if (this.registro.buenas.length > 1 && this.registro.malas.length > 1 && this.registro.horaFin.length < 1) {
        this.$refs.hora_fin.focus();
      }
      this.registro.vacias = this.registro.totalPreguntas - parseInt(this.registro.buenas) - parseInt(this.registro.malas);
      this.$forceUpdate();
    },
    nuevoRegistro: function nuevoRegistro() {
      this.verRegistro({ fila: [0] });
    },
    guardar: function guardar() {
      var _this2 = this;

      if (this.registro.codigo === undefined || this.registro.buenas === undefined || this.registro.malas === undefined || this.registro.horaFin === undefined) {
        alert('Debe llenar la cantidad de respuestas');
        return;
      }
      if (this.registro.buenas.length <= 0 || this.registro.malas.length <= 0 || this.registro.horaFin.length <= 3) {
        alert('Debe llenar la cantidad de respuestas');
        return;
      }
      if (parseInt(this.registro.buenas) + 0 + parseInt(this.registro.malas) > parseInt(this.registro.totalPreguntas)) {
        alert('Error en respuestas');
        return;
      }
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=resultados&accion=guardar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this2.registro = {};
          } else {
            alert(datos.m);
          }
        }
      });
    },
    editar: function editar() {
      var _this3 = this;

      if (this.registro.codigo === undefined || this.registro.buenas === undefined || this.registro.malas === undefined || this.registro.horaFin === undefined) {
        alert('Debe llenar la cantidad de respuestas');
        return;
      }
      if (this.registro.buenas.length <= 0 || this.registro.malas.length <= 0 || this.registro.horaFin.length <= 3) {
        alert('Debe llenar la cantidad de respuestas');
        return;
      }
      if (parseInt(this.registro.buenas) + 0 + parseInt(this.registro.malas) > parseInt(this.registro.totalPreguntas)) {
        alert('Error en respuestas');
        return;
      }
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=resultados&accion=editar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this3.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this3.registro = {};
          } else {
            alert(datos.m);
          }
        }
      });
    },
    subirVoucher: function subirVoucher() {
      this.$refs.image.click();
    },
    registrarVoucher: function registrarVoucher(url, archivo) {
      this.voucherURL = url;
      this.registro.voucher = encodeURIComponent(url);
      this.voucherArchivo = archivo;
    },
    mostrarVoucher: function mostrarVoucher(archivo) {
      if (archivo !== null) {
        return decodeURIComponent(archivo);
      }
      return '';
    },
    onSubirVoucher: function onSubirVoucher(e) {
      var _this4 = this;

      var files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return;
        }
        var fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', function () {
          var img = document.createElement('img');
          img.src = fr.result;
          img.addEventListener('load', function () {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            var MAX_WIDTH = 400;
            var MAX_HEIGHT = 400;
            var width = img.width;
            var height = img.height;

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
              }
            }
            canvas.width = width;
            canvas.height = height;
            ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            _this4.registrarVoucher(canvas.toDataURL(files[0].type), files[0]);
          });
        });
      } else {
        this.voucherArchivo = '';
        this.voucherURL = '';
      }
    }
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  props: ['login', 'tipoUsuario', 'usuarioApp'],
  data: function data() {
    return {
      tabActivo: 0,
      dialog: false,
      disabledRegistro: false,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      menu: false,
      cierreFecha: null,
      headers: [],
      datos: [],
      registro: { popup: false, registro: 'I' },
      registroTarifas: {},
      registroPuntos: {},
      registroMedallas: {},
      lista: {},
      popupURL: '',
      popupArchivo: '',
      logoURL: '',
      logoArchivo: '',
      popupLink: "https://www.colegiossanignacio.edu.pe/omsil/" + '/archivos/resultados2.png',
      logoLink: "https://www.colegiossanignacio.edu.pe/omsil/" + '/archivos/logo.png'
    };
  },
  computed: {
    popupSrc: function popupSrc() {
      return "https://www.colegiossanignacio.edu.pe/omsil/" + '/archivos/resultados2.png';
    },
    logoSrc: function logoSrc() {
      return "https://www.colegiossanignacio.edu.pe/omsil/" + '/archivos/logo.png';
    }
  },
  watch: {},
  created: function created() {
    this.initialize();
    this.cargarConfiguracion();
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    cargarConfiguracion: function cargarConfiguracion() {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { codigo: this.registro.codigo };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=configuracion&accion=ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            if (datos.d.popup === 't') _this.registro.popup = true;else _this.registro.popup = false;
            if (datos.d.etapa === 'I') _this.registro.resultados = false;else _this.registro.resultados = true;
            _this.registroTarifas = datos.d.tarifas;
            _this.registroPuntos = datos.d.puntos;
            _this.registroMedallas = datos.d.medallas;
          }
        }
      });
    },
    subirPopup: function subirPopup() {
      this.$refs.popupFile.click();
    },
    subirLogo: function subirLogo() {
      this.$refs.logoFile.click();
    },
    activarPopup: function activarPopup(url, archivo) {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro.popup;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=configuracion&accion=activarPopup', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            // this.registro = {}
          } else {
            alert(datos.m);
          }
        }
      });
    },
    registrarPopup: function registrarPopup(url, archivo) {
      var _this3 = this;

      this.popupURL = url;
      this.registro.popup = encodeURIComponent(url);
      this.popupArchivo = archivo;
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=configuracion&accion=subirPopup', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this3.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this3.registro = {};
          } else {
            alert(datos.m);
          }
        }
        _this3.popupLink = "https://www.colegiossanignacio.edu.pe/omsil/" + '/archivos/resultados2.png?actualizar=' + Math.random();
      });
    },
    mostrarPopup: function mostrarPopup(archivo) {
      if (archivo !== null) {
        return decodeURIComponent(archivo);
      }
      return '';
    },
    onSubirPopup: function onSubirPopup(e) {
      var _this4 = this;

      var files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return;
        }
        var fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', function () {
          var img = document.createElement('img');
          img.src = fr.result;
          img.addEventListener('load', function () {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            var MAX_WIDTH = 1024;
            var MAX_HEIGHT = 768;
            var width = img.width;
            var height = img.height;

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
              }
            }
            canvas.width = width;
            canvas.height = height;
            ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            _this4.registrarPopup(canvas.toDataURL(files[0].type), files[0]);
          });
        });
      } else {
        this.popupArchivo = '';
        this.popupURL = '';
      }
    },
    activarResultados: function activarResultados(url, archivo) {
      var _this5 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro.resultados;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=configuracion&accion=activarResultados', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this5.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            // this.registro = {}
          } else {
            alert(datos.m);
          }
        }
      });
    },
    activarInscripciones: function activarInscripciones(url, archivo) {
      var _this6 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro.inscripciones;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=configuracion&accion=activarInscripciones', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this6.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            // this.registro = {}
          } else {
            alert(datos.m);
          }
        }
      });
    },
    registrarLogo: function registrarLogo(url, archivo) {
      var _this7 = this;

      this.logoURL = url;
      this.registro.logo = encodeURIComponent(url);
      this.logoArchivo = archivo;
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=configuracion&accion=subirLogo', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this7.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this7.registro = {};
          } else {
            alert(datos.m);
          }
        }
        _this7.$refs.logoFile.value = '';
        _this7.logoLink = "https://www.colegiossanignacio.edu.pe/omsil/" + '/archivos/logo.png?actualizar=' + Math.random();
      });
    },
    mostrarLogo: function mostrarLogo(archivo) {
      if (archivo !== null) {
        return decodeURIComponent(archivo);
      }
      return '';
    },
    onSubirLogo: function onSubirLogo(e) {
      var _this8 = this;

      var files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return;
        }
        var fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', function () {
          var img = document.createElement('img');
          img.src = fr.result;
          img.addEventListener('load', function () {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            var MAX_WIDTH = 1024;
            var MAX_HEIGHT = 768;
            var width = img.width;
            var height = img.height;

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
              }
            }
            canvas.width = width;
            canvas.height = height;
            ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            _this8.registrarLogo(canvas.toDataURL(files[0].type), files[0]);
          });
        });
      } else {
        this.logoArchivo = '';
        this.logoURL = '';
      }
    },
    guardarTarifas: function guardarTarifas(url, archivo) {
      var _this9 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registroTarifas;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=configuracion&accion=guardarTarifas', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this9.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            // this.registro = {}
          } else {
            alert(datos.m);
          }
        }
      });
    },
    guardarPuntos: function guardarPuntos(url, archivo) {
      var _this10 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registroPuntos;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=configuracion&accion=guardarPuntos', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this10.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            // this.registro = {}
          } else {
            alert(datos.m);
          }
        }
      });
    },
    guardarMedallas: function guardarMedallas(url, archivo) {
      var _this11 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registroMedallas;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=configuracion&accion=guardarPuntosPuesto', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this11.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            // this.registro = {}
          } else {
            alert(datos.m);
          }
        }
      });
    }
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  props: ['login', 'tipoUsuario', 'usuarioApp', 'sedes'],
  data: function data() {
    return {
      dialog: false,
      disabledRegistro: false,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      menu: false,
      cierreFecha: null,
      buscar: '',
      eliminar: false,
      headers: [{ text: 'Sede', value: 0 }, { text: 'Colegio', value: 1 }, { text: 'Dirección', value: 2 }, { text: 'Ver', align: 'center', value: '', sortable: false }],
      datos: [],
      registro: {}
    };
  },
  computed: {},
  watch: {
    dialog: function dialog(val) {
      val || this.cerrar();
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.initialize();
    if (this.login === false) {
      this.$router.push('/Ingresar');
    }
    this.pagination.rowsPerPage = 10;
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina,
        grado: '',
        buscar: this.buscar
      };
      solicitudApi.datos = datos;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=sedes&accion=listar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.datos = datos.d;
          _this.totalRegistros = _this.datos.registros;
          if (parseInt(_this.datos.pagina) !== parseInt(_this.pagination.page)) {
            _this.pagination.page = parseInt(_this.datos.pagina);
          }
          _this.loading = false;
        }
      });
    },
    verRegistro: function verRegistro(item) {
      var _this2 = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { 'id': item.fila[0] };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=sedes&accion=ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this2.$emit('login', datos.m);
        } else {
          _this2.registro = datos.d;
          _this2.productosDetalle = {};
          if (item.fila[0] !== 0) {
            _this2.disabledRegistro = true;
          } else {
            _this2.disabledRegistro = false;
          }
          _this2.dialog = true;
        }
      });
    },
    editarRegistro: function editarRegistro(item) {
      var _this3 = this;

      this.disabledSede = false;
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { 'id': item.fila[0] };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=sedes&accion=ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this3.$emit('login', datos.m);
        } else {
          _this3.registro = datos.d;
          _this3.disabledRegistro = false;
          _this3.dialog = true;
        }
      });
    },
    nuevoRegistro: function nuevoRegistro() {
      this.verRegistro({ fila: [0] });
    },
    cerrar: function cerrar() {
      this.eliminar = false;
      this.dialog = false;
      setTimeout(function () {}, 300);
    },
    guardar: function guardar() {
      var _this4 = this;

      this.cerrar();
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=sedes&accion=guardar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this4.$emit('login', datos.m);
        } else {
          if (datos.e === 1) {
            _this4.verRegistro({ fila: [datos.d.id] });
            var descendente = 0;
            if (_this4.pagination.descending) {
              descendente = 1;
            }
            _this4.apiListaRegistros(_this4.pagination.sortBy, descendente, _this4.pagination.page);
          } else {
            alert(datos.m);
          }
        }
      });
    },
    actualizar: function actualizar() {
      var descendente = 0;
      if (this.pagination.descending) {
        descendente = 1;
      }
      this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
    },
    eliminarRegistro: function eliminarRegistro(item) {
      var _this5 = this;

      if (!this.eliminar) {
        this.eliminar = true;
        return;
      }
      this.cerrar();
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = { 'id': this.registro.id };
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=sedes&accion=eliminar', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this5.$emit('login', datos.m);
        } else {
          _this5.disabledRegistro = false;
          _this5.eliminar = false;
          _this5.dialog = false;
          var descendente = 0;
          if (_this5.pagination.descending) {
            descendente = 1;
          }
          _this5.apiListaRegistros(_this5.pagination.sortBy, descendente, _this5.pagination.page);
        }
      });
    }
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  props: ['login', 'tipoUsuario', 'usuarioApp'],
  data: function data() {
    return {
      loading: false,
      datos: [],
      registro: {},
      grado: '',
      asesor: {},
      headers: [{ text: '#', value: 0 }, { text: 'Código', value: 1 }, { text: 'Alumno', value: 2 }, { text: 'Grado', value: 3 }, { text: 'Buenas', value: 4 }, { text: 'Malas', value: 5 }, { text: 'Vacías', value: 6 }, { text: 'Puntos', value: 7 }, { text: 'Nota', value: 8 }, { text: 'Ord. mérito', value: 9 }, { text: 'Mérito', value: 10 }],
      totalRegistros: 0,
      pagination: {}
    };
  },
  watch: {
    dialog: function dialog(val) {
      val || this.cerrar();
    },
    'registro.cierreFecha': function registroCierreFecha(val) {
      this.cierreFecha = this.formatoFecha(this.registro.cierreFecha);
    },

    pagination: {
      handler: function handler() {
        if (this.loading === false) {
          var descendente = 0;
          if (this.pagination.descending) {
            descendente = 1;
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page);
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.initialize();
    if (this.login === false) {
      this.$router.push('/Ingresar');
    }
    this.pagination.rowsPerPage = 10;
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    apiListaRegistros: function apiListaRegistros(idx, ord, pagina) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      if (this.datos.pagina === undefined) {
        pagina = 0;
      }
      this.loading = true;
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      };
      solicitudApi.datos = datos;
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'resultado.php', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.datos = datos.d;
          _this.totalRegistros = _this.datos.registros;
          if (parseInt(_this.datos.pagina) !== parseInt(_this.pagination.page)) {
            _this.pagination.page = parseInt(_this.datos.pagina);
          }
          _this.loading = false;
          _this.$forceUpdate();
        }
      });
    },
    imprimirInscritos: function imprimirInscritos() {
      var solicitudApi = this.crearSolicitud();
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'resultado.php', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.blob();
      }).then(function (fileBlob) {
        var newBlob = new Blob([fileBlob], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        var data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
        link.href = data;
        link.target = '_blank';
        link.click();
      });
    }
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */]],
  data: function data() {
    return {
      disabledRegistro: false,
      totalRegistros: 0,
      loading: false,
      pagination: {},
      menuFechaInicio: false,
      menuFechaFin: false,
      fechaInicio: null,
      fechaFin: null,
      datos: [],
      reportes: [],
      registro: {}
    };
  },
  computed: {},
  created: function created() {
    this.initialize();
    this.nuevoRegistro();
  },

  methods: {
    initialize: function initialize() {
      this.datos = {};
    },
    verRegistro: function verRegistro(item) {
      var _this = this;

      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = [];
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'inicio.php?mod=reportes&accion=ver', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.json();
      }).then(function (datos) {
        if (datos.l === false) {
          _this.$emit('login', datos.m);
        } else {
          _this.reportes = datos.d.tipoReporte;
          if (item.id !== 0) {
            _this.disabledRegistro = true;
          } else {
            _this.disabledRegistro = false;
          }
          _this.dialog = true;
        }
      });
    },
    nuevoRegistro: function nuevoRegistro() {
      this.verRegistro({ id: 0 });
    },
    generar: function generar() {
      var solicitudApi = this.crearSolicitud();
      solicitudApi.datos = this.registro;
      var nombreReporte = 'Reporte';
      for (var reporte in this.reportes) {
        if (this.reportes[reporte].id === this.registro.tipoReporte) {
          nombreReporte = this.reportes[reporte].value;
        }
      }
      var myRequest = new Request("https://www.colegiossanignacio.edu.pe/omsil/" + 'reportes.php', { method: 'POST', body: 'd=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(solicitudApi), headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }) });
      return fetch(myRequest).then(function (response) {
        return response.blob();
      }).then(function (fileBlob) {
        var newBlob = new Blob([fileBlob], { type: 'application/xlsx' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        var data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
        link.href = data;
        link.download = nombreReporte + '.xlsx';
        link.click();
      });
    }
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cambiar-clave',
  props: ['cambiarClave'],
  methods: {
    cambiarClaveForm: function cambiarClaveForm(event) {
      self.cambiarClave = true;
    }
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(102);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c61d156_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(101);
function injectStyle (ssrContext) {
  __webpack_require__(77)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c61d156_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"aula"}},[(_vm.login)?_c('v-navigation-drawer',{attrs:{"clipped":_vm.$vuetify.breakpoint.lgAndUp,"mobile-break-point":"500","fixed":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.itemsMenu),function(item){return [(item.heading)?_c('v-layout',{key:item.heading,attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"xs6":""}},[(item.heading)?_c('v-subheader',[_vm._v("\n              "+_vm._s(item.heading)+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs6":""}},[_c('a',{staticClass:"body-2 black--text",attrs:{"href":"#!"}},[_vm._v("EDIT")])])],1):(item.children)?_c('v-list-group',{key:item.text,attrs:{"prepend-icon":item.model ? item.icon : item['icon-alt'],"append-icon":""},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                "+_vm._s(item.text)+"\n              ")])],1)],1),_vm._v(" "),_vm._l((item.children),function(child,i){return _c('v-list-tile',{key:i},[(child.icon)?_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(child.icon))])],1):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                "+_vm._s(child.text)+"\n              ")])],1)],1)})],2):_c('v-list-tile',{key:item.text,attrs:{"to":item.url}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n              "+_vm._s(item.text)+"\n            ")])],1)],1)]}),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.cerrarSesion()}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n            Salir\n          ")])],1)],1)],2)],1):_vm._e(),_vm._v(" "),(_vm.login)?_c('v-toolbar',{attrs:{"clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"color":"blue darken-3","dark":"","app":"","fixed":""}},[_c('v-toolbar-title',{staticClass:"ml-0",staticStyle:{"width":"300px"}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v(_vm._s(_vm.empresa))])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("notifications")])],1),_vm._v(" "),_c('div',{staticClass:"v-toolbar__items"},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"v-btn--flat",attrs:{"slot":"activator"},slot:"activator"},[_c('span',[_c('v-icon',[_vm._v("home")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.local))])]),_vm._v(" "),_c('v-list',_vm._l((_vm.locales),function(item,index){return _c('v-list-tile',{key:index,on:{"click":function($event){return _vm.setLocal(item.nombre)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.nombre))])],1)}),1)],1)],1),_vm._v(" "),_c('div',{staticClass:"v-toolbar__items"},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"v-btn--flat",attrs:{"slot":"activator"},slot:"activator"},[_c('span',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.usuario))])]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){$event.stopPropagation();_vm.cambiarClave.open = true}}},[_c('v-list-tile-title',[_vm._v("Cambiar clave")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.cerrarSesion()}}},[_c('v-list-tile-title',[_vm._v("Cerrar sesión")])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-content',[(_vm.entorno === 'development')?_c('v-alert',{attrs:{"value":true,"type":"warning"}},[_vm._v("Entorno de desarrollo")]):_vm._e(),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('main',[_c('router-view',{attrs:{"usuarioApp":_vm.usuario,"tipoUsuario":_vm.tipoUsuario,"sedes":_vm.sedes,"etapa":_vm.etapa,"login":_vm.login},on:{"login":_vm.loginOff,"set-token":_vm.setToken}})],1)])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":_vm.dialogW},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{attrs:{"fixed":"","top":"","right":"","icon":""},on:{"click":_vm.cerrar}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('center',[_c('img',{attrs:{"src":_vm.popupSrc}})])],1),_vm._v(" "),_c('cambiar-clave',{attrs:{"cambiarClave":_vm.cambiarClave}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_v_money__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_design_icons_iconfont_dist_material_design_icons_css__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_design_icons_iconfont_dist_material_design_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_design_icons_iconfont_dist_material_design_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Inicio__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Ingresar__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Ficha__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_FichaInscripcion__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Usuarios__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Colegio__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Colegios__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Libres__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Delegaciones__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Pago__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Pagos__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Credenciales__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Inscritos__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Resultados__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Configuracion__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Sedes__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Resultado__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Reportes__ = __webpack_require__(193);



























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('cambiar-clave', __webpack_require__(196).default);
// Vue.component('venta-producto', require('@/components/VentaProducto').default)
// Vue.component('venta-seleccionar-producto', require('@/components/VentaSeleccionarProducto').default)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__lib_v_money__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_xlsx___default.a);

if (localStorage.getItem('tokenId') === null) {
  localStorage.setItem('tokenId', '');
}
if (localStorage.getItem('local') === null) {
  localStorage.setItem('local', '');
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Inicio',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Inicio__["a" /* default */]
  }, {
    path: '/Ingresar',
    name: 'Ingresar',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Ingresar__["a" /* default */]
  }, {
    path: '/Ingresar/:tipoIngreso',
    name: 'IngresarParam',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Ingresar__["a" /* default */]
  }, {
    path: '/Ficha',
    name: 'Ficha',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Ficha__["a" /* default */]
  }, {
    path: '/Pago',
    name: 'Pago',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Pago__["a" /* default */]
  }, {
    path: '/Pago/:idAlumno',
    name: 'PagoParam',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Pago__["a" /* default */]
  }, {
    path: '/Pagos',
    name: 'Pagos',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Pagos__["a" /* default */]
  }, {
    path: '/FichaInscripcion',
    name: 'FichaInscripcion',
    component: __WEBPACK_IMPORTED_MODULE_10__components_FichaInscripcion__["a" /* default */]
  }, {
    path: '/Usuarios',
    name: 'Usuarios',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Usuarios__["a" /* default */]
  }, {
    path: '/Colegio',
    name: 'Colegio',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Colegio__["a" /* default */]
  }, {
    path: '/Sedes',
    name: 'Sedes',
    component: __WEBPACK_IMPORTED_MODULE_22__components_Sedes__["a" /* default */]
  }, {
    path: '/Colegios',
    name: 'Colegios',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Colegios__["a" /* default */]
  }, {
    path: '/Estudiantes',
    name: 'Alumnos',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Libres__["a" /* default */]
  }, {
    path: '/Delegaciones',
    name: 'Delegaciones',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Delegaciones__["a" /* default */]
  }, {
    path: '/Credenciales',
    name: 'Credenciales',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Credenciales__["a" /* default */]
  }, {
    path: '/Credenciales/:idAlumno',
    name: 'CredencialesParam',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Credenciales__["a" /* default */]
  }, {
    path: '/Inscritos',
    name: 'Inscritos',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Inscritos__["a" /* default */]
  }, {
    path: '/Resultados',
    name: 'Resultados',
    component: __WEBPACK_IMPORTED_MODULE_20__components_Resultados__["a" /* default */]
  }, {
    path: '/Configuracion',
    name: 'Configuracion',
    component: __WEBPACK_IMPORTED_MODULE_21__components_Configuracion__["a" /* default */]
  }, {
    path: '/Resultado',
    name: 'Resultado',
    component: __WEBPACK_IMPORTED_MODULE_23__components_Resultado__["a" /* default */]
  }, {
    path: '/Reportes',
    name: 'Reportes',
    component: __WEBPACK_IMPORTED_MODULE_24__components_Reportes__["a" /* default */]
  }]
}));

/***/ }),
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directive__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__options__ = __webpack_require__(46);
/* unused harmony reexport VMoney */
/* unused harmony reexport options */






function install(Vue, globalOptions) {
  if (globalOptions) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(globalOptions).forEach(function (key) {
      __WEBPACK_IMPORTED_MODULE_2__options__["a" /* default */][key] = globalOptions[key];
    });
  }

  Vue.directive('money', __WEBPACK_IMPORTED_MODULE_1__directive__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (install);

// Install by default if included from script tag
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install);
}

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(46);



function run(el, eventName) {
  var positionFromEnd = el.value.length - el.selectionEnd;
  el.value = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* format */])(el.value, __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */]);
  positionFromEnd = el.value.length - positionFromEnd;
  positionFromEnd = Math.max(positionFromEnd, __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */].prefix.length + 1); // left
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* setCursor */])(el, positionFromEnd);
  el.dispatchEvent(new Event(eventName));
}

function getInput(el) {
  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    var els = el.getElementsByTagName('input');
    if (els.length !== 1) {
      throw new Error('v-money requires 1 input, found ' + els.length);
    } else {
      el = els[0];
    }
  }
  return el;
}

function bind(el) {
  el = getInput(el);

  el.addEventListener('input', run(el, 'input'));
  el.addEventListener('change', run(el, 'change'));

  run(el, 'input');
}

function componentUpdated(el, binding, vnode, oldVnode) {
  // Prevent firing endless events
  if (vnode.data.model && vnode.data.model.value === oldVnode.data.model.value) {
    return;
  }

  el = getInput(el);
  el.value = vnode.data.model ? vnode.data.model.value : el.value;
  run(el, 'input');
}

/* harmony default export */ __webpack_exports__["a"] = ({ bind: bind, componentUpdated: componentUpdated });

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setCursor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

function toStr(value) {
  return value ? value.toString() : '';
}

function onlyNumbers(input) {
  return toStr(input).replace(/\D+/g, '') || '0';
}

function between(min, n, max) {
  return Math.max(min, Math.min(n, max));
}

function fixed(precision) {
  return between(0, precision, 20);
}

function numbersToCurrency(numbers, precision) {
  var exp = Math.pow(10, precision);
  var float = parseFloat(numbers) / exp;
  return float.toFixed(fixed(precision));
}

function addThousandSeparator(integer, separator) {
  return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, '$1' + separator);
}

function joinIntegerAndDecimal(integer, decimal, separator) {
  return decimal ? integer + separator + decimal : integer;
}

function format() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var opt = arguments[1];

  var value = typeof input === 'number' ? input.toFixed(fixed(opt.precision)) : input || '0';
  var numbers = onlyNumbers(value);
  var currency = numbersToCurrency(numbers, opt.precision);
  var parts = toStr(currency).split('.');

  var _parts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(parts, 2),
      integerDirty = _parts[0],
      decimal = _parts[1];

  var integer = addThousandSeparator(integerDirty, opt.thousands);
  return [opt.prefix, joinIntegerAndDecimal(integer, decimal, opt.decimal)].join('');
}

function setCursor(el, position) {
  function setSelectionRange() {
    el.setSelectionRange(position, position);
  }
  if (el === document.activeElement) {
    setSelectionRange();
    setTimeout(setSelectionRange, 1); // Android Fix
  }
}



/***/ }),
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 118 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inicio_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48f61757_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inicio_vue__ = __webpack_require__(123);
function injectStyle (ssrContext) {
  __webpack_require__(122)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inicio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48f61757_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inicio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inicio"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ingresar_vue__ = __webpack_require__(51);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54316fdb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ingresar_vue__ = __webpack_require__(126);
function injectStyle (ssrContext) {
  __webpack_require__(125)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ingresar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54316fdb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ingresar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","lg5":"","offset-sm2":"","offset-lg3":""}},[_c('center',[_c('img',{attrs:{"src":"archivos/logo.png","width":"100%"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[(_vm.formulario == 1)?_c('v-flex',{attrs:{"xs12":""}},[(_vm.etapa === 'I')?_c('center',[_c('h3',[_vm._v("BIENVENIDO AL SISTEMA DE INSCRIPCIÓN")])]):_vm._e(),_vm._v(" "),(_vm.etapa === 'R')?_c('center',[_c('h3',[_vm._v("BIENVENIDO AL SISTEMA DE RESULTADOS")])]):_vm._e(),_vm._v(" "),_c('br'),_c('br')],1):_vm._e(),_vm._v(" "),(_vm.formulario == 1)?_c('v-flex',{attrs:{"xs4":"","offset-xs1":""}},[_c('v-card',{staticClass:"mx-auto",attrs:{"outline":"","elevation":"10","height":"250px"}},[_c('center',[_c('br'),_vm._v(" "),_c('h4',[_vm._v("Estudiante independiente")]),_c('br'),_vm._v(" "),(_vm.etapa === 'I')?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.loginIngresarForm('RI')}}},[_vm._v("Registrar")]):_vm._e(),_vm._v(" "),(_vm.etapa === 'R')?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.loginIngresarForm('I')}}},[_vm._v("Ingresar")]):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.formulario == 1)?_c('v-flex',{attrs:{"xs5":"","offset-xs1":""}},[_c('v-card',{staticClass:"mx-auto",attrs:{"outline":"","elevation":"10","height":"250px"}},[_c('center',[_c('br'),_vm._v(" "),_c('h4',[_vm._v("Delegación")]),_c('br'),_vm._v(" "),(_vm.etapa !== 'R')?_c('div',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.registrarColegio()}}},[_vm._v("Registrar")]),_vm._v(" "),_c('h6',[_vm._v("Obtenga su código y contraseña")]),_vm._v(" "),_c('br')],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.loginIngresarForm('D')}}},[_vm._v("Ingresar")]),_vm._v(" "),_c('h6',[_vm._v("Click, si ya cuenta con código y contraseña")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.formulario == 2)?_c('v-flex',{attrs:{"xs12":""}},[_c('h3',[_vm._v("Delegación")]),_vm._v(" "),_c('form',{attrs:{"action":"/"}},[_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"name":"colegio","id":"colegio","label":"Ingrese su código (Recibido en su correo)","prepend-icon":"location_city","required":""},model:{value:(_vm.usuario),callback:function ($$v) {_vm.usuario=$$v},expression:"usuario"}}),_vm._v(" "),_c('v-text-field',{attrs:{"type":"password","name":"password","id":"password","label":"Ingrese la contraseña","prepend-icon":"https","required":""},model:{value:(_vm.clave),callback:function ($$v) {_vm.clave=$$v},expression:"clave"}}),_vm._v(" "),_c('div',{staticClass:"red--text"},[_vm._v(_vm._s(_vm.mensaje))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.loginIngresar()}}},[_vm._v("Ingresar")])],1)]):_vm._e(),_vm._v(" "),(_vm.formulario == 3)?_c('v-flex',{attrs:{"xs12":""}},[_c('h3',[_vm._v("Estudiante")]),_vm._v(" "),_c('form',{attrs:{"action":"/"}},[_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"name":"colegio","id":"colegio","label":"Ingrese el código de estudiante si Ud. ya está registrado","prepend-icon":"person","required":""},model:{value:(_vm.usuario),callback:function ($$v) {_vm.usuario=$$v},expression:"usuario"}}),_vm._v(" "),_c('v-text-field',{attrs:{"type":"password","name":"password","id":"password","label":"Ingrese la contraseña","prepend-icon":"https","required":""},model:{value:(_vm.clave),callback:function ($$v) {_vm.clave=$$v},expression:"clave"}}),_vm._v(" "),_c('div',{staticClass:"red--text"},[_vm._v(_vm._s(_vm.mensaje))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.loginIngresar()}}},[_vm._v("Ingresar")])],1)]):_vm._e(),_vm._v(" "),(_vm.formulario == 4)?_c('v-flex',{attrs:{"xs12":""}},[_c('h3',[_vm._v("Registro de estudiante independiente")]),_vm._v(" "),_c('v-form',{attrs:{"action":"/","lazy-validation":""},model:{value:(_vm.validarInscripcion),callback:function ($$v) {_vm.validarInscripcion=$$v},expression:"validarInscripcion"}},[_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Colegio","name":"colegio_insc","id":"colegio_insc","prepend-icon":"business_center","rules":_vm.requeridoRegla},on:{"keyup":function($event){_vm.libre.colegio = _vm.libre.colegio.toUpperCase();}},model:{value:(_vm.libre.colegio),callback:function ($$v) {_vm.$set(_vm.libre, "colegio", $$v)},expression:"libre.colegio"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Tipo de colegio","name":"tipo_colegio","id":"tipo_colegio","items":_vm.tiposColegio,"prepend-icon":"business_center"},model:{value:(_vm.libre.tipoColegio),callback:function ($$v) {_vm.$set(_vm.libre, "tipoColegio", $$v)},expression:"libre.tipoColegio"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Apellido Paterno","name":"apellido_paterno","id":"apellido_paterno","prepend-icon":"person","rules":_vm.requeridoRegla},on:{"keyup":function($event){_vm.libre.apellidoPaterno = _vm.libre.apellidoPaterno.toUpperCase();}},model:{value:(_vm.libre.apellidoPaterno),callback:function ($$v) {_vm.$set(_vm.libre, "apellidoPaterno", $$v)},expression:"libre.apellidoPaterno"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Apellido materno","name":"apellido_materno","id":"apellido_materno","prepend-icon":"person","rules":_vm.requeridoRegla},on:{"keyup":function($event){_vm.libre.apellidoMaterno = _vm.libre.apellidoMaterno.toUpperCase();}},model:{value:(_vm.libre.apellidoMaterno),callback:function ($$v) {_vm.$set(_vm.libre, "apellidoMaterno", $$v)},expression:"libre.apellidoMaterno"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Nombres","name":"nombres","id":"nombres","prepend-icon":"person","rules":_vm.requeridoRegla},on:{"keyup":function($event){_vm.libre.nombres = _vm.libre.nombres.toUpperCase();}},model:{value:(_vm.libre.nombres),callback:function ($$v) {_vm.$set(_vm.libre, "nombres", $$v)},expression:"libre.nombres"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"DNI","name":"dni","id":"dni","prepend-icon":"person","mask":"########","rules":_vm.dniRegla},model:{value:(_vm.libre.dni),callback:function ($$v) {_vm.$set(_vm.libre, "dni", $$v)},expression:"libre.dni"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Teléfono","name":"telefono","id":"telefono","mask":"#########","prepend-icon":"person","rules":_vm.requeridoRegla},model:{value:(_vm.libre.telefono),callback:function ($$v) {_vm.$set(_vm.libre, "telefono", $$v)},expression:"libre.telefono"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Correo electrónico","name":"correo","id":"correo","prepend-icon":"person","rules":_vm.emailRegla},on:{"keyup":function($event){_vm.libre.correo = _vm.libre.correo.toUpperCase();}},model:{value:(_vm.libre.correo),callback:function ($$v) {_vm.$set(_vm.libre, "correo", $$v)},expression:"libre.correo"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Grado","name":"grado","id":"grado","items":_vm.grados,"item-text":"nombre","item-value":"id","return-object":"","prepend-icon":"business_center","required":""},model:{value:(_vm.libre.grado),callback:function ($$v) {_vm.$set(_vm.libre, "grado", $$v)},expression:"libre.grado"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Departamento","name":"departamento","id":"departamento","items":_vm.departamentos,"item-text":"nombre","item-value":"id","return-object":"","prepend-icon":"my_location","required":""},model:{value:(_vm.libre.departamento),callback:function ($$v) {_vm.$set(_vm.libre, "departamento", $$v)},expression:"libre.departamento"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Provincia","name":"provincia","id":"provincia","items":_vm.provincias,"item-text":"nombre","item-value":"id","return-object":"","prepend-icon":"my_location","required":""},model:{value:(_vm.libre.provincia),callback:function ($$v) {_vm.$set(_vm.libre, "provincia", $$v)},expression:"libre.provincia"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Distrito","name":"distrito","id":"distrito","items":_vm.distritos,"item-text":"nombre","item-value":"id","return-object":"","prepend-icon":"my_location","required":""},model:{value:(_vm.libre.distrito),callback:function ($$v) {_vm.$set(_vm.libre, "distrito", $$v)},expression:"libre.distrito"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Sede","name":"sede","id":"sede","items":_vm.sedes,"item-text":"nombre","item-value":"id","return-object":"","prepend-icon":"my_location"},model:{value:(_vm.libre.sede),callback:function ($$v) {_vm.$set(_vm.libre, "sede", $$v)},expression:"libre.sede"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Número de operación","rules":_vm.operacionRegla,"mask":"########","prepend-icon":"photo"},model:{value:(_vm.libre.operacion),callback:function ($$v) {_vm.$set(_vm.libre, "operacion", $$v)},expression:"libre.operacion"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"money",rawName:"v-money"}],attrs:{"label":"Monto","rules":_vm.requeridoRegla,"prepend-icon":"photo"},model:{value:(_vm.libre.monto),callback:function ($$v) {_vm.$set(_vm.libre, "monto", $$v)},expression:"libre.monto"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.subirVoucher()}}},[_vm._v("Adjuntar voucher")]),_vm._v(" "),_c('p',[_c('input',{ref:"image",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onSubirVoucher}}),_vm._v(" "),_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.mostrarVoucher(_vm.voucherURL)}})]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.validarInscripcion},on:{"click":function($event){return _vm.loginIngresar()}}},[_vm._v("Registrar")])],1)],1):_vm._e(),_vm._v(" "),(_vm.formulario == 5)?_c('v-flex',{attrs:{"xs12":""}},[_c('h3',[_vm._v("Registro de colegio")]),_vm._v(" "),_c('v-form',{attrs:{"action":"/","lazy-validation":""},model:{value:(_vm.validarInscripcion),callback:function ($$v) {_vm.validarInscripcion=$$v},expression:"validarInscripcion"}},[_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Colegio","name":"colegio_insc","id":"colegio_insc","prepend-icon":"business_center","rules":_vm.requeridoRegla},on:{"keyup":function($event){_vm.libre.colegio = _vm.libre.colegio.toUpperCase();}},model:{value:(_vm.libre.colegio),callback:function ($$v) {_vm.$set(_vm.libre, "colegio", $$v)},expression:"libre.colegio"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Tipo de colegio","name":"tipo_colegio","id":"tipo_colegio","items":_vm.tiposColegio,"prepend-icon":"business_center"},model:{value:(_vm.libre.tipoColegio),callback:function ($$v) {_vm.$set(_vm.libre, "tipoColegio", $$v)},expression:"libre.tipoColegio"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Responsable - Apellido Paterno","name":"apellido_paterno","id":"apellido_paterno","prepend-icon":"person","rules":_vm.requeridoRegla},on:{"keyup":function($event){_vm.libre.apellidoPaterno = _vm.libre.apellidoPaterno.toUpperCase();}},model:{value:(_vm.libre.apellidoPaterno),callback:function ($$v) {_vm.$set(_vm.libre, "apellidoPaterno", $$v)},expression:"libre.apellidoPaterno"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Responsable - Apellido materno","name":"apellido_materno","id":"apellido_materno","prepend-icon":"person","rules":_vm.requeridoRegla},on:{"keyup":function($event){_vm.libre.apellidoMaterno = _vm.libre.apellidoMaterno.toUpperCase();}},model:{value:(_vm.libre.apellidoMaterno),callback:function ($$v) {_vm.$set(_vm.libre, "apellidoMaterno", $$v)},expression:"libre.apellidoMaterno"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Responsable - Nombres","name":"nombres","id":"nombres","prepend-icon":"person","rules":_vm.requeridoRegla},on:{"keyup":function($event){_vm.libre.nombres = _vm.libre.nombres.toUpperCase();}},model:{value:(_vm.libre.nombres),callback:function ($$v) {_vm.$set(_vm.libre, "nombres", $$v)},expression:"libre.nombres"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Responsable - DNI","name":"dni","id":"dni","prepend-icon":"person","mask":"########","rules":_vm.dniRegla},model:{value:(_vm.libre.dni),callback:function ($$v) {_vm.$set(_vm.libre, "dni", $$v)},expression:"libre.dni"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Teléfono","name":"telefono","id":"telefono","mask":"#########","prepend-icon":"person","rules":_vm.requeridoRegla},model:{value:(_vm.libre.telefono),callback:function ($$v) {_vm.$set(_vm.libre, "telefono", $$v)},expression:"libre.telefono"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Correo electrónico","name":"correo","id":"correo","prepend-icon":"person","rules":_vm.emailRegla},on:{"keyup":function($event){_vm.libre.correo = _vm.libre.correo.toUpperCase();}},model:{value:(_vm.libre.correo),callback:function ($$v) {_vm.$set(_vm.libre, "correo", $$v)},expression:"libre.correo"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Sede","name":"sede","id":"sede","items":_vm.sedes,"item-text":"nombre","item-value":"id","return-object":"","prepend-icon":"my_location"},model:{value:(_vm.libre.sede),callback:function ($$v) {_vm.$set(_vm.libre, "sede", $$v)},expression:"libre.sede"}}),_vm._v(" "),_c('p',[_vm._v("- Una vez registrado se le enviará su usuario y contraseña a su correo electrónico.")]),_vm._v(" "),_c('p',{staticStyle:{"color":"red"}},[_vm._v("- Los colegios deben tener al menos 5 estudiantes inscritos para poder participar como delegación.")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.validarInscripcion},on:{"click":function($event){return _vm.loginIngresar()}}},[_vm._v("Registrar")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',[_vm._v("\n          Puede descargar las bases en este enlace: "),_c('a',{attrs:{"target":"_blank","href":"archivos/BASES_XII_OMSIL_2019.pdf"}},[_vm._v("Bases")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ficha_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aca6aa2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ficha_vue__ = __webpack_require__(129);
function injectStyle (ssrContext) {
  __webpack_require__(128)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ficha_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aca6aa2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ficha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Alumno")]),_vm._v(" "),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.datos.data,"pagination":_vm.pagination,"total-items":_vm.totalRegistros,"loading":_vm.loading,"rows-per-page-text":"Filas por página"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.fila[1]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[2]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[3]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[4]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[5]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[6]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[8]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[9]))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"})]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.initialize}},[_vm._v("Reset")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FichaInscripcion_vue__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79c53bb2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FichaInscripcion_vue__ = __webpack_require__(132);
function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FichaInscripcion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79c53bb2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FichaInscripcion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.grados),function(grado,index){return _c('v-card',{key:index},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v(_vm._s(grado.nombre))])],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticStyle:{"background":"lightsteelblue","padding":"10px"}},[_c('p'),_c('h3',[_vm._v("Asesor")]),_c('p'),_vm._v(" "),_c('v-form',{attrs:{"action":"/","lazy-validation":""},model:{value:(_vm.validarAsesor),callback:function ($$v) {_vm.validarAsesor=$$v},expression:"validarAsesor"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"lg1":""}},[_c('v-text-field',{attrs:{"label":"DNI","readonly":_vm.grados[index].disabledAsesor,"rules":_vm.dniRegla,"mask":"########"},model:{value:(_vm.grados[index].asesor.dni),callback:function ($$v) {_vm.$set(_vm.grados[index].asesor, "dni", $$v)},expression:"grados[index].asesor.dni"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"lg2":""}},[_c('v-text-field',{attrs:{"label":"Apellido paterno","readonly":_vm.grados[index].disabledAsesor,"rules":_vm.requeridoRegla},on:{"keyup":function($event){_vm.grados[index].asesor.apellidoPaterno = _vm.grados[index].asesor.apellidoPaterno.toUpperCase();}},model:{value:(_vm.grados[index].asesor.apellidoPaterno),callback:function ($$v) {_vm.$set(_vm.grados[index].asesor, "apellidoPaterno", $$v)},expression:"grados[index].asesor.apellidoPaterno"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"lg2":""}},[_c('v-text-field',{attrs:{"label":"Apellido materno","readonly":_vm.grados[index].disabledAsesor,"rules":_vm.requeridoRegla},on:{"keyup":function($event){_vm.grados[index].asesor.apellidoMaterno = _vm.grados[index].asesor.apellidoMaterno.toUpperCase();}},model:{value:(_vm.grados[index].asesor.apellidoMaterno),callback:function ($$v) {_vm.$set(_vm.grados[index].asesor, "apellidoMaterno", $$v)},expression:"grados[index].asesor.apellidoMaterno"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"lg2":""}},[_c('v-text-field',{attrs:{"label":"Nombres","readonly":_vm.grados[index].disabledAsesor,"rules":_vm.requeridoRegla},on:{"keyup":function($event){_vm.grados[index].asesor.nombres = _vm.grados[index].asesor.nombres.toUpperCase();}},model:{value:(_vm.grados[index].asesor.nombres),callback:function ($$v) {_vm.$set(_vm.grados[index].asesor, "nombres", $$v)},expression:"grados[index].asesor.nombres"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"lg2":""}},[_c('v-text-field',{attrs:{"label":"Correo","readonly":_vm.grados[index].disabledAsesor,"rules":_vm.emailRegla},on:{"keyup":function($event){_vm.grados[index].asesor.correo = _vm.grados[index].asesor.correo.toUpperCase();}},model:{value:(_vm.grados[index].asesor.correo),callback:function ($$v) {_vm.$set(_vm.grados[index].asesor, "correo", $$v)},expression:"grados[index].asesor.correo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"lg2":""}},[_c('v-text-field',{attrs:{"label":"Teléfono","readonly":_vm.grados[index].disabledAsesor,"rules":_vm.requeridoRegla,"mask":"#########"},model:{value:(_vm.grados[index].asesor.telefono),callback:function ($$v) {_vm.$set(_vm.grados[index].asesor, "telefono", $$v)},expression:"grados[index].asesor.telefono"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"lg1":""}},[(!_vm.grados[index].disabledAsesor)?_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.grados[index].validarAsesor},on:{"click":function($event){return _vm.registrarAsesor(grado.id)}}},[_vm._v("Guardar")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('p'),_c('h3',[_vm._v("Alumnos")]),_c('p'),_vm._v(" "),_c('v-form',{attrs:{"action":"/","lazy-validation":""},model:{value:(_vm.validarAlumno),callback:function ($$v) {_vm.validarAlumno=$$v},expression:"validarAlumno"}},[_c('table',{staticStyle:{"width":"100%"}},[_c('thead',[_c('tr',{attrs:{"align":"left"}},[_c('th',{staticStyle:{"padding":"10px 0px 10px 0px"}},[_vm._v("Apellido paterno")]),_vm._v(" "),_c('th',[_vm._v("Apellido materno")]),_vm._v(" "),_c('th',[_vm._v("Nombres")]),_vm._v(" "),_c('th',[_vm._v("DNI")]),_vm._v(" "),_c('th',[_vm._v("Correo")]),_vm._v(" "),_c('th',[_vm._v("Grado")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_vm._l((grado.alumnos),function(alumno){return _c('tr',[_c('td',{staticStyle:{"padding":"10px 0px 10px 0px"}},[_vm._v(_vm._s(alumno.fila[1]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(alumno.fila[2]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(alumno.fila[3]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(alumno.fila[4]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(alumno.fila[6]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(alumno.fila[9]))]),_vm._v(" "),_c('td')])}),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"10px 0px 10px 0px"}},[_c('v-text-field',{attrs:{"label":"Apellido paterno","readonly":_vm.grados[index].disabledRegistro,"rules":_vm.requeridoRegla},on:{"keyup":function($event){_vm.grados[index].alumno.apellidoPaterno = _vm.grados[index].alumno.apellidoPaterno.toUpperCase();}},model:{value:(_vm.grados[index].alumno.apellidoPaterno),callback:function ($$v) {_vm.$set(_vm.grados[index].alumno, "apellidoPaterno", $$v)},expression:"grados[index].alumno.apellidoPaterno"}})],1),_vm._v(" "),_c('td',[_c('v-text-field',{attrs:{"label":"Apellido materno","readonly":_vm.grados[index].disabledRegistro,"rules":_vm.requeridoRegla},on:{"keyup":function($event){_vm.grados[index].alumno.apellidoMaterno = _vm.grados[index].alumno.apellidoMaterno.toUpperCase();}},model:{value:(_vm.grados[index].alumno.apellidoMaterno),callback:function ($$v) {_vm.$set(_vm.grados[index].alumno, "apellidoMaterno", $$v)},expression:"grados[index].alumno.apellidoMaterno"}})],1),_vm._v(" "),_c('td',[_c('v-text-field',{attrs:{"label":"Nombres","readonly":_vm.grados[index].disabledRegistro,"rules":_vm.requeridoRegla},on:{"keyup":function($event){_vm.grados[index].alumno.nombres = _vm.grados[index].alumno.nombres.toUpperCase();}},model:{value:(_vm.grados[index].alumno.nombres),callback:function ($$v) {_vm.$set(_vm.grados[index].alumno, "nombres", $$v)},expression:"grados[index].alumno.nombres"}})],1),_vm._v(" "),_c('td',[_c('v-text-field',{attrs:{"label":"DNI","readonly":_vm.grados[index].disabledRegistro,"rules":_vm.dniRegla,"mask":"########"},model:{value:(_vm.grados[index].alumno.dni),callback:function ($$v) {_vm.$set(_vm.grados[index].alumno, "dni", $$v)},expression:"grados[index].alumno.dni"}})],1),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.grados[index].validarAlumno},on:{"click":function($event){return _vm.registrarAlumo(grado.id)}}},[_vm._v("Guardar")])],1)])],2)])])],1)],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuarios_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e9eae55_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuarios_vue__ = __webpack_require__(135);
function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuarios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e9eae55_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuarios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Usuarios")]),_vm._v(" "),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_vm._v("Nuevo usuario")]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-tabs',{model:{value:(_vm.tabActivo),callback:function ($$v) {_vm.tabActivo=$$v},expression:"tabActivo"}},[_c('v-tab',[_c('b',[_vm._v("Usuario")])]),_vm._v(" "),_c('v-tab',{attrs:{"disabled":_vm.disabledSede}},[_c('b',[_vm._v("Sedes")])]),_vm._v(" "),_c('v-tab',{attrs:{"disabled":_vm.disabledSede}},[_c('b',[_vm._v("Permisos")])]),_vm._v(" "),_c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"Usuario","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.usuario),callback:function ($$v) {_vm.$set(_vm.registro, "usuario", $$v)},expression:"registro.usuario"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"Clave","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.clave),callback:function ($$v) {_vm.$set(_vm.registro, "clave", $$v)},expression:"registro.clave"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-select',{attrs:{"name":"estado","id":"estado","items":_vm.estados,"item-text":"nombre","item-value":"id","return-object":"","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.estado),callback:function ($$v) {_vm.$set(_vm.registro, "estado", $$v)},expression:"registro.estado"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_vm._v("Nuevo")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.disabledRegistro=false}}},[_vm._v("Editar")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.cerrar($event)}}},[_vm._v("Cerrar")]),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.guardar($event)}}},[_vm._v("Guardar")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},_vm._l((_vm.registro.accesos),function(acceso){return _c('v-layout',{key:acceso[0],attrs:{"align-center":""}},[_c('v-checkbox',{attrs:{"label":("" + (acceso.nombre)),"readonly":_vm.disabledRegistro},model:{value:(acceso.acceso),callback:function ($$v) {_vm.$set(acceso, "acceso", $$v)},expression:"acceso.acceso"}})],1)}),1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_vm._v("Nuevo")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.disabledRegistro=false}}},[_vm._v("Editar")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.cerrar($event)}}},[_vm._v("Cerrar")]),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.guardar($event)}}},[_vm._v("Guardar")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-checkbox',{attrs:{"label":"Administrador","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.permisos.administrador),callback:function ($$v) {_vm.$set(_vm.registro.permisos, "administrador", $$v)},expression:"registro.permisos.administrador"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":""}},[_c('v-checkbox',{attrs:{"label":"Usuarios","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.permisos.usuarios),callback:function ($$v) {_vm.$set(_vm.registro.permisos, "usuarios", $$v)},expression:"registro.permisos.usuarios"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":""}},[_c('v-checkbox',{attrs:{"label":"Sedes","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.permisos.sedes),callback:function ($$v) {_vm.$set(_vm.registro.permisos, "sedes", $$v)},expression:"registro.permisos.sedes"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":""}},[_c('v-checkbox',{attrs:{"label":"Configuración","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.permisos.configuracion),callback:function ($$v) {_vm.$set(_vm.registro.permisos, "configuracion", $$v)},expression:"registro.permisos.configuracion"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":""}},[_c('v-checkbox',{attrs:{"label":"Colegios","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.permisos.colegios),callback:function ($$v) {_vm.$set(_vm.registro.permisos, "colegios", $$v)},expression:"registro.permisos.colegios"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":""}},[_c('v-checkbox',{attrs:{"label":"Inscritos","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.permisos.inscritos),callback:function ($$v) {_vm.$set(_vm.registro.permisos, "inscritos", $$v)},expression:"registro.permisos.inscritos"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":""}},[_c('v-checkbox',{attrs:{"label":"Verificar pagos","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.permisos.verificarPagos),callback:function ($$v) {_vm.$set(_vm.registro.permisos, "verificarPagos", $$v)},expression:"registro.permisos.verificarPagos"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":""}},[_c('v-checkbox',{attrs:{"label":"Resultados","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.permisos.resultados),callback:function ($$v) {_vm.$set(_vm.registro.permisos, "resultados", $$v)},expression:"registro.permisos.resultados"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":""}},[_c('v-checkbox',{attrs:{"label":"Reportes","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.permisos.reportes),callback:function ($$v) {_vm.$set(_vm.registro.permisos, "reportes", $$v)},expression:"registro.permisos.reportes"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":""}},[_c('v-checkbox',{attrs:{"label":"Modificar resultados","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.permisos.modificarResultados),callback:function ($$v) {_vm.$set(_vm.registro.permisos, "modificarResultados", $$v)},expression:"registro.permisos.modificarResultados"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.disabledRegistro=false}}},[_vm._v("Editar")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.cerrar($event)}}},[_vm._v("Cerrar")]),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.guardar($event)}}},[_vm._v("Guardar")]):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.datos.data,"pagination":_vm.pagination,"total-items":_vm.totalRegistros,"loading":_vm.loading,"rows-per-page-text":"Filas por página"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.fila[1]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(_vm.estados2[props.item.fila[2]]))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[(props.item.fila[0] !== 0)?_c('v-icon',{on:{"click":function($event){return _vm.verRegistro(props.item)}}},[_vm._v("\n          open_in_browser\n        ")]):_vm._e()],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("\n      -\n    ")])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Colegio_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a129ad32_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Colegio_vue__ = __webpack_require__(138);
function injectStyle (ssrContext) {
  __webpack_require__(137)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Colegio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a129ad32_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Colegio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Datos del colegio")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-select',{attrs:{"label":"Tipo de colegio","name":"tipo_colegio","id":"tipo_colegio","items":_vm.tiposColegio,"rules":_vm.requeridoRegla,"item-text":"nombre","item-value":"id","return-object":"","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.tipo),callback:function ($$v) {_vm.$set(_vm.registro, "tipo", $$v)},expression:"registro.tipo"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"Nombre","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.nombre = _vm.registro.nombre.toUpperCase();}},model:{value:(_vm.registro.nombre),callback:function ($$v) {_vm.$set(_vm.registro, "nombre", $$v)},expression:"registro.nombre"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"Director(a)","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.director = _vm.registro.director.toUpperCase();}},model:{value:(_vm.registro.director),callback:function ($$v) {_vm.$set(_vm.registro, "director", $$v)},expression:"registro.director"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"Dirección","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.direccion = _vm.registro.direccion.toUpperCase();}},model:{value:(_vm.registro.direccion),callback:function ($$v) {_vm.$set(_vm.registro, "direccion", $$v)},expression:"registro.direccion"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"Teléfono","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro,"mask":"##############"},model:{value:(_vm.registro.telefono),callback:function ($$v) {_vm.$set(_vm.registro, "telefono", $$v)},expression:"registro.telefono"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"Correo Electrónico","rules":_vm.emailRegla,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.correo = _vm.registro.correo.toUpperCase();}},model:{value:(_vm.registro.correo),callback:function ($$v) {_vm.$set(_vm.registro, "correo", $$v)},expression:"registro.correo"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-select',{attrs:{"label":"Sede","name":"sede","id":"sede","items":_vm.sedes,"item-text":"nombre","item-value":"id","return-object":"","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.sede),callback:function ($$v) {_vm.$set(_vm.registro, "sede", $$v)},expression:"registro.sede"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"RUC","rules":_vm.rucRegla,"readonly":_vm.disabledRegistro,"maxlength":"11"},model:{value:(_vm.registro.ruc),callback:function ($$v) {_vm.$set(_vm.registro, "ruc", $$v)},expression:"registro.ruc"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.disabledRegistro = !_vm.disabledRegistro}}},[_vm._v("Editar")]):_vm._e(),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.guardar($event)}}},[_vm._v("Guardar")]):_vm._e(),_vm._v(" "),_c('v-spacer')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Colegios_vue__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_494f1c43_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Colegios_vue__ = __webpack_require__(141);
function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Colegios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_494f1c43_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Colegios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Colegios")]),_vm._v(" "),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Buscar","single-line":"","hide-details":""},on:{"change":function($event){return _vm.actualizar()}},model:{value:(_vm.buscar),callback:function ($$v) {_vm.buscar=$$v},expression:"buscar"}}),_vm._v(" "),_c('v-btn',{attrs:{"text":"","icon":""},on:{"click":function($event){return _vm.actualizar()}}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_vm._v("Nuevo colegio")]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"550px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Colegio")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-text-field',{attrs:{"label":"Colegio","name":"colegio_insc","id":"colegio_insc","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.nombre = _vm.registro.nombre.toUpperCase();}},model:{value:(_vm.registro.nombre),callback:function ($$v) {_vm.$set(_vm.registro, "nombre", $$v)},expression:"registro.nombre"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Tipo de colegio","name":"tipo_colegio","id":"tipo_colegio","items":_vm.tiposColegio,"disabled":_vm.disabledRegistro,"item-text":"nombre","item-value":"id"},model:{value:(_vm.registro.tipo),callback:function ($$v) {_vm.$set(_vm.registro, "tipo", $$v)},expression:"registro.tipo"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Dirección","name":"direccion","id":"direccion","readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.direccion = _vm.registro.direccion.toUpperCase();}},model:{value:(_vm.registro.direccion),callback:function ($$v) {_vm.$set(_vm.registro, "direccion", $$v)},expression:"registro.direccion"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"RUC","name":"ruc","id":"ruc","mask":"###########","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.ruc),callback:function ($$v) {_vm.$set(_vm.registro, "ruc", $$v)},expression:"registro.ruc"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Responsable - Apellido Paterno","name":"apellido_paterno","id":"apellido_paterno","readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.asesorApellido1 = _vm.registro.asesorApellido1.toUpperCase();}},model:{value:(_vm.registro.asesorApellido1),callback:function ($$v) {_vm.$set(_vm.registro, "asesorApellido1", $$v)},expression:"registro.asesorApellido1"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Responsable - Apellido materno","name":"apellido_materno","id":"apellido_materno","readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.asesorApellido2 = _vm.registro.asesorApellido2.toUpperCase();}},model:{value:(_vm.registro.asesorApellido2),callback:function ($$v) {_vm.$set(_vm.registro, "asesorApellido2", $$v)},expression:"registro.asesorApellido2"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Responsable - Nombres","name":"nombres","id":"nombres","readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.asesorNombres = _vm.registro.asesorNombres.toUpperCase();}},model:{value:(_vm.registro.asesorNombres),callback:function ($$v) {_vm.$set(_vm.registro, "asesorNombres", $$v)},expression:"registro.asesorNombres"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Responsable - DNI","name":"dni","id":"dni","mask":"########","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.asesorDNI),callback:function ($$v) {_vm.$set(_vm.registro, "asesorDNI", $$v)},expression:"registro.asesorDNI"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Teléfono","name":"telefono","id":"telefono","mask":"#########","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.telefono),callback:function ($$v) {_vm.$set(_vm.registro, "telefono", $$v)},expression:"registro.telefono"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Correo electrónico","name":"correo","id":"correo","readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.correo = _vm.registro.correo.toUpperCase();}},model:{value:(_vm.registro.correo),callback:function ($$v) {_vm.$set(_vm.registro, "correo", $$v)},expression:"registro.correo"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Sede","name":"sede","id":"sede","items":_vm.sedes,"item-text":"nombre","item-value":"id","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.sede),callback:function ($$v) {_vm.$set(_vm.registro, "sede", $$v)},expression:"registro.sede"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Código","name":"codigo","mask":"########","id":"codigo","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.codigo),callback:function ($$v) {_vm.$set(_vm.registro, "codigo", $$v)},expression:"registro.codigo"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Clave","name":"clave","id":"clave","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.clave),callback:function ($$v) {_vm.$set(_vm.registro, "clave", $$v)},expression:"registro.clave"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.disabledRegistro && _vm.usuarioApp.toUpperCase() === 'ADMINSAN' && !_vm.eliminar)?_c('v-btn',{attrs:{"color":"error"},nativeOn:{"click":function($event){return _vm.eliminarRegistro($event)}}},[_vm._v("Eliminar")]):_vm._e(),_vm._v(" "),(_vm.eliminar)?_c('v-btn',{attrs:{"color":"error"},nativeOn:{"click":function($event){return _vm.eliminarRegistro($event)}}},[_vm._v("Confirmar eliminación")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_vm._v("Nuevo")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.disabledRegistro=false}}},[_vm._v("Editar")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.cerrar($event)}}},[_vm._v("Cerrar")]),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.guardar($event)}}},[_vm._v("Guardar")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.datos.data,"pagination":_vm.pagination,"total-items":_vm.totalRegistros,"loading":_vm.loading,"rows-per-page-text":"Filas por página"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.fila[1]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[2]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[3]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[4]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[5]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[7]))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[(props.item.fila[0] !== 0)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-icon',{attrs:{"slot":"activator"},on:{"click":function($event){return _vm.verRegistro(props.item)}},slot:"activator"},[_vm._v("open_in_browser")]),_vm._v(" "),_c('span',[_vm._v("Ver")])],1):_vm._e()],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("\n      -\n    ")])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Libres_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_577daacb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Libres_vue__ = __webpack_require__(164);
function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Libres_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_577daacb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Libres_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Alumnos")]),_vm._v(" "),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Colegio: ")]),_vm._v("\n     \n    "),_c('v-autocomplete',{attrs:{"loading":_vm.loading,"items":_vm.colegios,"hide-no-data":"","hide-details":"","label":""},model:{value:(_vm.colegioFiltro),callback:function ($$v) {_vm.colegioFiltro=$$v},expression:"colegioFiltro"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Buscar","single-line":"","hide-details":""},on:{"change":function($event){return _vm.actualizar()}},model:{value:(_vm.buscar),callback:function ($$v) {_vm.buscar=$$v},expression:"buscar"}}),_vm._v(" "),_c('v-btn',{attrs:{"text":"","icon":""},on:{"click":function($event){return _vm.actualizar()}}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_vm._v("Inscribir alumno")]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Alumno independiente")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{ref:"form",attrs:{"action":"/","lazy-validation":""},model:{value:(_vm.validarInscripcion),callback:function ($$v) {_vm.validarInscripcion=$$v},expression:"validarInscripcion"}},[_c('v-text-field',{attrs:{"label":"Colegio","name":"colegio_insc","id":"colegio_insc","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.colegio = _vm.registro.colegio.toUpperCase();}},model:{value:(_vm.registro.colegio),callback:function ($$v) {_vm.$set(_vm.registro, "colegio", $$v)},expression:"registro.colegio"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Tipo de colegio","name":"tipo_colegio","id":"tipo_colegio","items":_vm.tiposColegio,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.tipoColegio),callback:function ($$v) {_vm.$set(_vm.registro, "tipoColegio", $$v)},expression:"registro.tipoColegio"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Apellido Paterno","name":"apellido_paterno","id":"apellido_paterno","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.apellidoPaterno = _vm.registro.apellidoPaterno.toUpperCase();}},model:{value:(_vm.registro.apellidoPaterno),callback:function ($$v) {_vm.$set(_vm.registro, "apellidoPaterno", $$v)},expression:"registro.apellidoPaterno"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Apellido materno","name":"apellido_materno","id":"apellido_materno","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.apellidoMaterno = _vm.registro.apellidoMaterno.toUpperCase();}},model:{value:(_vm.registro.apellidoMaterno),callback:function ($$v) {_vm.$set(_vm.registro, "apellidoMaterno", $$v)},expression:"registro.apellidoMaterno"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Nombres","name":"nombres","id":"nombres","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.nombres = _vm.registro.nombres.toUpperCase();}},model:{value:(_vm.registro.nombres),callback:function ($$v) {_vm.$set(_vm.registro, "nombres", $$v)},expression:"registro.nombres"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"DNI","name":"dni","id":"dni","mask":"########","rules":_vm.dniRegla,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.dni),callback:function ($$v) {_vm.$set(_vm.registro, "dni", $$v)},expression:"registro.dni"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Teléfono","name":"telefono","id":"telefono","mask":"#########","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.telefono),callback:function ($$v) {_vm.$set(_vm.registro, "telefono", $$v)},expression:"registro.telefono"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Correo electrónico","name":"correo","id":"correo","readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.correo = _vm.registro.correo.toUpperCase();}},model:{value:(_vm.registro.correo),callback:function ($$v) {_vm.$set(_vm.registro, "correo", $$v)},expression:"registro.correo"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Grado","name":"grado","id":"grado","items":_vm.grados,"item-text":"nombre","item-value":"id","rules":_vm.requeridoRegla,"required":"","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.grado),callback:function ($$v) {_vm.$set(_vm.registro, "grado", $$v)},expression:"registro.grado"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Departamento","name":"departamento","id":"departamento","items":_vm.departamentos,"item-text":"nombre","item-value":"id","rules":_vm.requeridoRegla,"return-object":"","required":"","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.departamento),callback:function ($$v) {_vm.$set(_vm.registro, "departamento", $$v)},expression:"registro.departamento"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Provincia","name":"provincia","id":"provincia","items":_vm.provincias,"item-text":"nombre","item-value":"id","rules":_vm.requeridoRegla,"required":"","return-object":"","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.provincia),callback:function ($$v) {_vm.$set(_vm.registro, "provincia", $$v)},expression:"registro.provincia"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Distrito","name":"distrito","id":"distrito","items":_vm.distritos,"item-text":"nombre","item-value":"id","rules":_vm.requeridoRegla,"required":"","return-object":"","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.distrito),callback:function ($$v) {_vm.$set(_vm.registro, "distrito", $$v)},expression:"registro.distrito"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Sede","name":"sede","id":"sede","items":_vm.sedes,"item-text":"nombre","item-value":"id","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.sede),callback:function ($$v) {_vm.$set(_vm.registro, "sede", $$v)},expression:"registro.sede"}}),_vm._v(" "),(_vm.registro.inscripcion !== '')?_c('v-select',{attrs:{"label":"Tipo de inscripción","name":"inscripcion","id":"inscripcion","items":_vm.tiposInscripcion,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.inscripcion),callback:function ($$v) {_vm.$set(_vm.registro, "inscripcion", $$v)},expression:"registro.inscripcion"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Recibo"},model:{value:(_vm.registro.recibo),callback:function ($$v) {_vm.$set(_vm.registro, "recibo", $$v)},expression:"registro.recibo"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"money",rawName:"v-money"}],attrs:{"label":"Monto"},model:{value:(_vm.registro.monto),callback:function ($$v) {_vm.$set(_vm.registro, "monto", $$v)},expression:"registro.monto"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Código","name":"codigo","mask":"########","id":"codigo","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.codigo),callback:function ($$v) {_vm.$set(_vm.registro, "codigo", $$v)},expression:"registro.codigo"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Clave","name":"clave","id":"clave","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.clave),callback:function ($$v) {_vm.$set(_vm.registro, "clave", $$v)},expression:"registro.clave"}}),_vm._v(" "),(_vm.registro.usuario !== '' && _vm.registro.usuario !== null)?_c('span',[_vm._v("Registrado por "+_vm._s(_vm.registro.usuario))]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.disabledRegistro && _vm.usuarioApp.toUpperCase() === 'ADMINSAN' && !_vm.eliminar)?_c('v-btn',{attrs:{"color":"error"},nativeOn:{"click":function($event){return _vm.eliminarRegistro($event)}}},[_vm._v("Eliminar")]):_vm._e(),_vm._v(" "),(_vm.eliminar)?_c('v-btn',{attrs:{"color":"error"},nativeOn:{"click":function($event){return _vm.eliminarRegistro($event)}}},[_vm._v("Confirmar eliminación")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_vm._v("Nuevo")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.disabledRegistro=false}}},[_vm._v("Editar")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.cerrar($event)}}},[_vm._v("Cerrar")]),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.guardar(1)}}},[_vm._v("Guardar")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400px"},model:{value:(_vm.dialogMover),callback:function ($$v) {_vm.dialogMover=$$v},expression:"dialogMover"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Mover alumno")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{ref:"form",attrs:{"action":"/"}},[_c('v-text-field',{attrs:{"label":"Alumno","name":"alumno","id":"alumno","readonly":"readonly"},model:{value:(_vm.registro2.codigo),callback:function ($$v) {_vm.$set(_vm.registro2, "codigo", $$v)},expression:"registro2.codigo"}}),_vm._v("\n                Escoger colegio:\n                "),_c('v-autocomplete',{attrs:{"label":"Nuevo colegio","loading":_vm.loading,"items":_vm.colegios,"hide-no-data":"","hide-details":""},model:{value:(_vm.registro2.nuevoColegio),callback:function ($$v) {_vm.$set(_vm.registro2, "nuevoColegio", $$v)},expression:"registro2.nuevoColegio"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.cerrarCambiarColegio($event)}}},[_vm._v("Cerrar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.guardarCambiarColegio($event)}}},[_vm._v("Guardar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400px"},model:{value:(_vm.dialogPago),callback:function ($$v) {_vm.dialogPago=$$v},expression:"dialogPago"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Mover alumno")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{ref:"form",attrs:{"action":"/"}},[(_vm.registro3.codigoAlumno !== '')?_c('v-text-field',{attrs:{"label":"Alumno","name":"alumno3","id":"alumno3","readonly":"readonly"},model:{value:(_vm.registro3.codigoAlumno),callback:function ($$v) {_vm.$set(_vm.registro3, "codigoAlumno", $$v)},expression:"registro3.codigoAlumno"}}):_vm._e(),_vm._v(" "),(_vm.registro3.codigoColegio !== '')?_c('v-text-field',{attrs:{"label":"Colegio","name":"colegio","id":"colegio","readonly":"readonly"},model:{value:(_vm.registro3.codigoColegio),callback:function ($$v) {_vm.$set(_vm.registro3, "codigoColegio", $$v)},expression:"registro3.codigoColegio"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Número de operación","rules":_vm.operacionRegla,"mask":"########"},model:{value:(_vm.registro3.operacion),callback:function ($$v) {_vm.$set(_vm.registro3, "operacion", $$v)},expression:"registro3.operacion"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"money",rawName:"v-money"}],attrs:{"label":"Monto","rules":_vm.requeridoRegla},model:{value:(_vm.registro3.monto),callback:function ($$v) {_vm.$set(_vm.registro3, "monto", $$v)},expression:"registro3.monto"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.subirVoucher()}}},[_vm._v("Adjuntar voucher")]),_vm._v(" "),_c('input',{ref:"image",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onSubirVoucher}}),_vm._v(" "),_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.mostrarVoucher(_vm.voucherURL)}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.cerrarInformarPago()}}},[_vm._v("Cerrar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.registrarPago()}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.datos.data,"pagination":_vm.pagination,"total-items":_vm.totalRegistros,"loading":_vm.loading,"rows-per-page-text":"Filas por página"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',[_c('th',[_c('v-checkbox',{attrs:{"primary":"","hide-details":""},on:{"click":function($event){$event.stopPropagation();return _vm.toggleAll($event)}},model:{value:(_vm.seleccionarTodo),callback:function ($$v) {_vm.seleccionarTodo=$$v},expression:"seleccionarTodo"}})],1),_vm._v(" "),_vm._l((props.headers),function(header){return _c('th',{key:header.text,class:['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : ''],on:{"click":function($event){return _vm.changeSort(header.value)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("arrow_upward")]),_vm._v("\n          "+_vm._s(header.text)+"\n        ")],1)})],2)]}},{key:"items",fn:function(props){return [_c('td',{class:{filaAsesor: props.item.fila[14] === 'A'}},[_c('v-checkbox',{model:{value:(props.item.fila[19]),callback:function ($$v) {_vm.$set(props.item.fila, 19, $$v)},expression:"props.item.fila[19]"}})],1),_vm._v(" "),_c('td',{class:{filaAsesor: props.item.fila[14] === 'A'}},[_vm._v(_vm._s(props.item.fila[18]))]),_vm._v(" "),_c('td',{class:{filaAsesor: props.item.fila[14] === 'A'}},[_vm._v(_vm._s(props.item.fila[15]))]),_vm._v(" "),_c('td',{class:{filaAsesor: props.item.fila[14] === 'A'}},[_vm._v(_vm._s(props.item.fila[1]))]),_vm._v(" "),_c('td',{class:{filaAsesor: props.item.fila[14] === 'A'}},[_vm._v(_vm._s(props.item.fila[2]))]),_vm._v(" "),_c('td',{class:{filaAsesor: props.item.fila[14] === 'A'}},[_vm._v(_vm._s(props.item.fila[3]))]),_vm._v(" "),_c('td',{class:{filaAsesor: props.item.fila[14] === 'A'}},[_vm._v(_vm._s(props.item.fila[4]))]),_vm._v(" "),_c('td',{class:{filaAsesor: props.item.fila[14] === 'A'}},[_vm._v(_vm._s(props.item.fila[5]))]),_vm._v(" "),_c('td',{class:{filaAsesor: props.item.fila[14] === 'A'}},[_vm._v(_vm._s(props.item.fila[6]))]),_vm._v(" "),_c('td',{class:{filaAsesor: props.item.fila[14] === 'A'}},[_vm._v(_vm._s(props.item.fila[8]))]),_vm._v(" "),_c('td',{class:{filaAsesor: props.item.fila[14] === 'A'}},[_vm._v(_vm._s(props.item.fila[9]))]),_vm._v(" "),_c('td',{class:{filaAsesor: props.item.fila[14] === 'A'}},[_vm._v(_vm._s(props.item.fila[17]))]),_vm._v(" "),_c('td',{class:{filaAsesor: props.item.fila[14] === 'A'},attrs:{"align":"center"}},[(props.item.fila[0] !== 0)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-icon',{attrs:{"slot":"activator"},on:{"click":function($event){return _vm.verRegistro(props.item)}},slot:"activator"},[_vm._v("open_in_browser")]),_vm._v(" "),_c('span',[_vm._v("Ver")])],1):_vm._e()],1),_vm._v(" "),_c('td',{class:{filaAsesor: props.item.fila[14] === 'A'},attrs:{"align":"center"}},[_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.informarPago(props.item)}}},[_c('v-list-tile-title',[_vm._v("Informar pago")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.imprimirCredencial(props.item)}}},[_c('v-list-tile-title',[_vm._v("Imprimir credencial")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.cambiarColegio(props.item)}}},[_c('v-list-tile-title',[_vm._v("Cambiar colegio")])],1)],1)],1)],1)]}}])},[_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.initialize}},[_vm._v("Reset")])],1)],2),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.imprimirCredencial('')}}},[_vm._v("Credenciales")]),_vm._v(" "),_c('input',{ref:"excelFile",attrs:{"type":"file","accept":"xlsx/*"},on:{"change":_vm.onSubirExcel}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.disabledExcel},on:{"click":function($event){return _vm.registrarExcel()}}},[_vm._v("Subir excel")]),_vm._v(" "),(!_vm.eliminarRegistrosCheck)?_c('v-btn',{attrs:{"color":"error","dark":""},nativeOn:{"click":function($event){return _vm.eliminarRegistrosConfirmar(1)}}},[_vm._v("Eliminar registros")]):_vm._e(),_vm._v(" "),(_vm.eliminarRegistrosCheck)?_c('v-btn',{attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.eliminarRegistrosConfirmar(0)}}},[_vm._v("Cancelar eliminación")]):_vm._e(),_vm._v(" "),(_vm.eliminarRegistrosCheck)?_c('v-btn',{attrs:{"color":"error","dark":""},nativeOn:{"click":function($event){return _vm.eliminarRegistros()}}},[_vm._v("Confirmar eliminación")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delegaciones_vue__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d9953de_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delegaciones_vue__ = __webpack_require__(167);
function injectStyle (ssrContext) {
  __webpack_require__(166)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delegaciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d9953de_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delegaciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Alumnos de delegaciones")]),_vm._v(" "),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Alumno independiente")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{ref:"form",attrs:{"action":"/","lazy-validation":""},model:{value:(_vm.validarInscripcion),callback:function ($$v) {_vm.validarInscripcion=$$v},expression:"validarInscripcion"}},[_c('v-text-field',{attrs:{"label":"Colegio","name":"colegio_insc","id":"colegio_insc","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.colegio = _vm.registro.colegio.toUpperCase();}},model:{value:(_vm.registro.colegio),callback:function ($$v) {_vm.$set(_vm.registro, "colegio", $$v)},expression:"registro.colegio"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Tipo de colegio","name":"tipo_colegio","id":"tipo_colegio","items":_vm.tiposColegio,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.tipoColegio),callback:function ($$v) {_vm.$set(_vm.registro, "tipoColegio", $$v)},expression:"registro.tipoColegio"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Apellido Paterno","name":"apellido_paterno","id":"apellido_paterno","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.apellidoPaterno = _vm.registro.apellidoPaterno.toUpperCase();}},model:{value:(_vm.registro.apellidoPaterno),callback:function ($$v) {_vm.$set(_vm.registro, "apellidoPaterno", $$v)},expression:"registro.apellidoPaterno"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Apellido materno","name":"apellido_materno","id":"apellido_materno","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.apellidoMaterno = _vm.registro.apellidoMaterno.toUpperCase();}},model:{value:(_vm.registro.apellidoMaterno),callback:function ($$v) {_vm.$set(_vm.registro, "apellidoMaterno", $$v)},expression:"registro.apellidoMaterno"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Nombres","name":"nombres","id":"nombres","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.nombres = _vm.registro.nombres.toUpperCase();}},model:{value:(_vm.registro.nombres),callback:function ($$v) {_vm.$set(_vm.registro, "nombres", $$v)},expression:"registro.nombres"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"DNI","name":"dni","id":"dni","mask":"########","rules":_vm.dniRegla,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.dni),callback:function ($$v) {_vm.$set(_vm.registro, "dni", $$v)},expression:"registro.dni"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Teléfono","name":"telefono","id":"telefono","mask":"#########","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.telefono),callback:function ($$v) {_vm.$set(_vm.registro, "telefono", $$v)},expression:"registro.telefono"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Correo electrónico","name":"correo","id":"correo","readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.correo = _vm.registro.correo.toUpperCase();}},model:{value:(_vm.registro.correo),callback:function ($$v) {_vm.$set(_vm.registro, "correo", $$v)},expression:"registro.correo"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Grado","name":"grado","id":"grado","items":_vm.grados,"item-text":"nombre","item-value":"id","rules":_vm.requeridoRegla,"return-object":"","required":"","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.grado),callback:function ($$v) {_vm.$set(_vm.registro, "grado", $$v)},expression:"registro.grado"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Departamento","name":"departamento","id":"departamento","items":_vm.departamentos,"item-text":"nombre","item-value":"id","rules":_vm.requeridoRegla,"return-object":"","required":"","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.departamento),callback:function ($$v) {_vm.$set(_vm.registro, "departamento", $$v)},expression:"registro.departamento"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Provincia","name":"provincia","id":"provincia","items":_vm.provincias,"item-text":"nombre","item-value":"id","rules":_vm.requeridoRegla,"return-object":"","required":"","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.provincia),callback:function ($$v) {_vm.$set(_vm.registro, "provincia", $$v)},expression:"registro.provincia"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Distrito","name":"distrito","id":"distrito","items":_vm.distritos,"item-text":"nombre","item-value":"id","rules":_vm.requeridoRegla,"return-object":"","required":"","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.distrito),callback:function ($$v) {_vm.$set(_vm.registro, "distrito", $$v)},expression:"registro.distrito"}}),_vm._v(" "),_c('v-select',{attrs:{"label":"Sede","name":"sede","id":"sede","items":_vm.sedes,"item-text":"nombre","item-value":"id","rules":_vm.requeridoRegla,"return-object":"","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.sede),callback:function ($$v) {_vm.$set(_vm.registro, "sede", $$v)},expression:"registro.sede"}}),_vm._v(" "),(_vm.registro.inscripcion !== '')?_c('v-select',{attrs:{"label":"Tipo de inscripción","name":"inscripcion","id":"inscripcion","items":_vm.tiposInscripcion,"readonly":_vm.disabledRegistro},model:{value:(_vm.registro.inscripcion),callback:function ($$v) {_vm.$set(_vm.registro, "inscripcion", $$v)},expression:"registro.inscripcion"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Código","name":"codigo","id":"codigo","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.codigo),callback:function ($$v) {_vm.$set(_vm.registro, "codigo", $$v)},expression:"registro.codigo"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Clave","name":"clave","id":"clave","readonly":_vm.disabledRegistro},model:{value:(_vm.registro.clave),callback:function ($$v) {_vm.$set(_vm.registro, "clave", $$v)},expression:"registro.clave"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.disabledRegistro && _vm.usuarioApp.toUpperCase() === 'ADMINSAN' && !_vm.eliminar)?_c('v-btn',{attrs:{"color":"error"},nativeOn:{"click":function($event){return _vm.eliminarRegistro($event)}}},[_vm._v("Eliminar")]):_vm._e(),_vm._v(" "),(_vm.eliminar)?_c('v-btn',{attrs:{"color":"error"},nativeOn:{"click":function($event){return _vm.eliminarRegistro($event)}}},[_vm._v("Confirmar eliminación")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro && _vm.usuarioApp.toUpperCase() === 'ADMINSAN')?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.disabledRegistro=false}}},[_vm._v("Editar")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.cerrar($event)}}},[_vm._v("Cerrar")]),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.guardar($event)}}},[_vm._v("Guardar")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.datos.data,"pagination":_vm.pagination,"total-items":_vm.totalRegistros,"loading":_vm.loading,"rows-per-page-text":"Filas por página"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.fila[1]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.fila[16]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.fila[2]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[3]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[4]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[5]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[6]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[7]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[9]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[10]))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[(props.item.fila[0] !== 0)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-icon',{staticClass:"mr-2",attrs:{"slot":"activator","small":""},on:{"click":function($event){return _vm.verRegistro(props.item)}},slot:"activator"},[_vm._v("open_in_browser")]),_vm._v(" "),_c('span',[_vm._v("Ver")])],1):_vm._e(),_vm._v(" "),(props.item.fila[0] !== 0)?_c('v-tooltip',{attrs:{"bottom":""}},[(_vm.usuarioApp.toUpperCase() === 'ADMINSAN')?_c('v-icon',{staticClass:"mr-2",attrs:{"slot":"activator","small":""},on:{"click":function($event){return _vm.editarRegistro(props.item)}},slot:"activator"},[_vm._v("edit")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Editar")])],1):_vm._e()],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.initialize}},[_vm._v("Reset")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pago_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aabef5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pago_vue__ = __webpack_require__(170);
function injectStyle (ssrContext) {
  __webpack_require__(169)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pago_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aabef5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pago_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title',[_c('v-flex',{attrs:{"d-flex":"","lg4":""}},[_c('center',[_c('img',{attrs:{"src":"archivos/logo.png","width":"100%"}})])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Ficha de pago")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('p',[_vm._v("Se ha registrado la inscripción de:")]),_vm._v(" "),_vm._l((_vm.lista.lista),function(item){return _c('v-layout',{key:item[0],attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","lg2":""}},[_vm._v(_vm._s(item[0]))]),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","lg2":""}},[_vm._v(_vm._s(item[1])+" ALUMNOS")]),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","lg2":""}},[_vm._v("= S/ "+_vm._s(item[2]))])],1)}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_c('span',{staticStyle:{"border-style":"solid"}},[_vm._v("Total a pagar: S/ "+_vm._s(_vm.lista.total))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Realice el pago en la Caja Los Andes "),_c('br'),_vm._v("\n            Nº Cuenta: 1690050021000000172008 "),_c('br'),_vm._v("\n            A nombre de: Ardiles Nuñez Wilber A.\n          ")]),_vm._v(" "),_c('p',[_vm._v("Para más información de lugares de pago visite: "),_c('a',{attrs:{"target":"_blank","href":"http://cajarurallosandes.com/web/category/ubicacion/"}},[_vm._v("http://cajarurallosandes.com")])])],2)],1),_vm._v(" "),_c('v-card-actions')],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Pagos")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('table',{staticStyle:{"width":"100%"}},[_c('thead',[_c('tr',{attrs:{"align":"left"}},[_c('th',[_vm._v("Número de operación")]),_vm._v(" "),_c('th',[_vm._v("Monto")]),_vm._v(" "),_c('th',[_vm._v("Estado")]),_vm._v(" "),_c('th',[_vm._v("Voucher")])])]),_vm._v(" "),_vm._l((_vm.datos.data),function(item){return _c('tbody',{key:item[0]},[_c('tr',[_c('td',{staticStyle:{"vertical-align":"text-top"}},[_vm._v(_vm._s(item.fila[1]))]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"text-top"}},[_vm._v("S/ "+_vm._s(item.fila[2]))]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"text-top"}},[_vm._v(_vm._s(_vm.estados[item.fila[3]]))]),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.mostrarVoucher(item.fila[4])}})])])])})],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_c('br')])],1),_vm._v(" "),_c('v-card-actions')],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Informar pago")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('p',[_c('b',[_vm._v("Debe ingresar el número de operación, monto y adjuntar una foto de su voucher para poder validar el pago.")])]),_vm._v(" "),_c('p',[_vm._v("Puede ubicar el número de operación en la parte superior derecha del voucher:   "),_c('img',{attrs:{"src":__webpack_require__(171),"width":"384px"}})])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"}},[_c('thead'),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticStyle:{"vertical-align":"text-top"}},[_c('v-text-field',{attrs:{"label":"Número de operación","rules":_vm.operacionRegla,"mask":"########"},model:{value:(_vm.registro.operacion),callback:function ($$v) {_vm.$set(_vm.registro, "operacion", $$v)},expression:"registro.operacion"}})],1),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"text-top"}},[_c('v-text-field',{directives:[{name:"money",rawName:"v-money"}],attrs:{"label":"Monto","rules":_vm.requeridoRegla},model:{value:(_vm.registro.monto),callback:function ($$v) {_vm.$set(_vm.registro, "monto", $$v)},expression:"registro.monto"}})],1),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"text-top"}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.subirVoucher()}}},[_vm._v("Adjuntar voucher")]),_vm._v(" "),_c('input',{ref:"image",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onSubirVoucher}})],1),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.mostrarVoucher(_vm.voucherURL)}})]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"text-top"}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.registrarPago()}}},[_vm._v("Guardar")])],1)])])]),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('v-card-actions')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/voucher.243d5e2.jpeg";

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagos_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cfdc0b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagos_vue__ = __webpack_require__(174);
function injectStyle (ssrContext) {
  __webpack_require__(173)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cfdc0b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"max-width":"700px"},model:{value:(_vm.dialogVoucher),callback:function ($$v) {_vm.dialogVoucher=$$v},expression:"dialogVoucher"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Voucher")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('center',[_c('img',{class:_vm.voucherVerClase,staticStyle:{"max-width":"100%"},attrs:{"src":_vm.mostrarVoucher(_vm.voucherVer)},on:{"click":function($event){return _vm.rotar()}}})])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.cerrarVoucher($event)}}},[_vm._v("Cerrar")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Pagos")]),_vm._v(" "),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Buscar","single-line":"","hide-details":""},on:{"change":function($event){return _vm.actualizar()}},model:{value:(_vm.buscar),callback:function ($$v) {_vm.buscar=$$v},expression:"buscar"}}),_vm._v(" "),_c('v-btn',{attrs:{"text":"","icon":""},on:{"click":function($event){return _vm.actualizar()}}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Pago")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_vm._v("\n            Eliminar pago "+_vm._s(_vm.registro.operacion)+"\n          ")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.eliminar)?_c('v-btn',{attrs:{"color":"error"},nativeOn:{"click":function($event){return _vm.eliminarRegistro($event)}}},[_vm._v("Confirmar eliminación")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.datos.data,"pagination":_vm.pagination,"total-items":_vm.totalRegistros,"loading":_vm.loading,"rows-per-page-text":"Filas por página"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.fila[1]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[2]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[3]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[4]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[5]))]),_vm._v(" "),(props.item.fila[6] == 1)?_c('td',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.estados[props.item.fila[6]]))]):_vm._e(),_vm._v(" "),(props.item.fila[6] == 2)?_c('td',{staticStyle:{"color":"green"}},[_vm._v(_vm._s(_vm.estados[props.item.fila[6]]))]):_vm._e(),_vm._v(" "),_c('td',{},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.mostrarVoucher(props.item.fila[7])},on:{"click":function($event){return _vm.abrirVoucher(props.item.fila[7])}}})]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[(props.item.fila[6] === '1')?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-icon',{attrs:{"slot":"activator"},on:{"click":function($event){return _vm.verificarRegistro(props.item, 2)}},slot:"activator"},[_vm._v("done")]),_vm._v(" "),_c('span',[_vm._v("Verificar")])],1):_vm._e(),_vm._v(" "),(props.item.fila[6] === '2')?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-icon',{attrs:{"slot":"activator"},on:{"click":function($event){return _vm.verificarRegistro(props.item, 1)}},slot:"activator"},[_vm._v("clear")]),_vm._v(" "),_c('span',[_vm._v("Quitar verificado")])],1):_vm._e(),_vm._v(" "),(_vm.usuarioApp.toUpperCase() === 'ADMINSAN')?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-icon',{attrs:{"slot":"activator"},on:{"click":function($event){return _vm.eliminarRegistro(props.item)}},slot:"activator"},[_vm._v("delete")]),_vm._v(" "),_c('span',[_vm._v("Eliminar")])],1):_vm._e()],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("\n      -\n    ")])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Credenciales_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43b2c2e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Credenciales_vue__ = __webpack_require__(177);
function injectStyle (ssrContext) {
  __webpack_require__(176)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Credenciales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43b2c2e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Credenciales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.apiListaRegistros(0, 0, 1)}}},[_vm._v("Generar credenciales")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inscritos_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b104ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inscritos_vue__ = __webpack_require__(180);
function injectStyle (ssrContext) {
  __webpack_require__(179)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inscritos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b104ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inscritos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Para poder participar debe tener al menos 5 alumnos inscritos.")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.imprimirInscritos(0, 0, 1)}}},[_vm._v("Imprimir listado")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resultados_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_035d59fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resultados_vue__ = __webpack_require__(183);
function injectStyle (ssrContext) {
  __webpack_require__(182)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resultados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_035d59fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resultados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title',[_c('v-flex',{attrs:{"d-flex":"","lg4":""}},[_c('center',[_c('img',{attrs:{"src":"archivos/logo.png","width":"100%"}})])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Resultados")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('table',{staticStyle:{"width":"100%"}},[_c('thead',[_c('tr',{attrs:{"align":"left"}},[_c('th',[_vm._v("Código")]),_vm._v(" "),_c('th',[_vm._v("DNI")]),_vm._v(" "),_c('th',[_vm._v("Alumno")]),_vm._v(" "),_c('th',[_vm._v("Correctas")]),_vm._v(" "),_c('th',[_vm._v("Incorrectas")]),_vm._v(" "),_c('th',[_vm._v("En Blanco")]),_vm._v(" "),_c('th',[_vm._v("Hora Final")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('v-text-field',{attrs:{"label":"Código","name":"codigo","id":"codigo","mask":"########","size":"8"},on:{"keyup":function($event){return _vm.buscarAlumno(0)}},model:{value:(_vm.registro.codigo),callback:function ($$v) {_vm.$set(_vm.registro, "codigo", $$v)},expression:"registro.codigo"}})],1),_vm._v(" "),_c('td',[_c('v-text-field',{attrs:{"label":"DNI","name":"dni","id":"dni","mask":"########","size":"8"},on:{"keyup":function($event){return _vm.buscarAlumno(1)}},model:{value:(_vm.registro.dni),callback:function ($$v) {_vm.$set(_vm.registro, "dni", $$v)},expression:"registro.dni"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.registro.alumno))]),_vm._v(" "),_c('td',[_c('v-text-field',{ref:"buenas",attrs:{"label":"Correctas","name":"buenas","id":"buenas","mask":"##","size":"2"},on:{"keyup":function($event){return _vm.calcularRespuestas()}},model:{value:(_vm.registro.buenas),callback:function ($$v) {_vm.$set(_vm.registro, "buenas", $$v)},expression:"registro.buenas"}})],1),_vm._v(" "),_c('td',[_c('v-text-field',{ref:"malas",attrs:{"label":"Incorrectas","name":"malas","id":"malas","mask":"##","size":"2"},on:{"keyup":function($event){return _vm.calcularRespuestas()}},model:{value:(_vm.registro.malas),callback:function ($$v) {_vm.$set(_vm.registro, "malas", $$v)},expression:"registro.malas"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.registro.vacias))]),_vm._v(" "),_c('td',[_c('v-text-field',{ref:"hora_fin",attrs:{"label":"Hora final","name":"hora_fin","id":"hora_fin","mask":"##:##:##","size":"2"},on:{"keyup":function($event){return _vm.calcularRespuestas()}},model:{value:(_vm.registro.horaFin),callback:function ($$v) {_vm.$set(_vm.registro, "horaFin", $$v)},expression:"registro.horaFin"}})],1),_vm._v(" "),_c('td',[_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.guardar($event)}}},[_vm._v("Guardar")]),(_vm.registro.id !== undefined && _vm.registro.id !== 0 && _vm.usuarioApp.toUpperCase() === 'ADMINSAN')?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.editar($event)}}},[_vm._v("Modificar")]):_vm._e()],1)])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_c('br')])],1),_vm._v(" "),_c('v-card-actions')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Configuracion_vue__ = __webpack_require__(68);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_694d285c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Configuracion_vue__ = __webpack_require__(186);
function injectStyle (ssrContext) {
  __webpack_require__(185)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Configuracion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_694d285c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Configuracion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title'),_vm._v(" "),_c('v-card-text',[_c('v-tabs',{model:{value:(_vm.tabActivo),callback:function ($$v) {_vm.tabActivo=$$v},expression:"tabActivo"}},[_c('v-tab',[_c('b',[_vm._v("Pop-up")])]),_vm._v(" "),_c('v-tab',[_c('b',[_vm._v("Logo")])]),_vm._v(" "),_c('v-tab',[_c('b',[_vm._v("Inscripciones")])]),_vm._v(" "),_c('v-tab',[_c('b',[_vm._v("Resultados")])]),_vm._v(" "),_c('v-tab',[_c('b',[_vm._v("Tarifas")])]),_vm._v(" "),_c('v-tab',[_c('b',[_vm._v("Puntajes")])]),_vm._v(" "),_c('v-tab',[_c('b',[_vm._v("Medallas")])]),_vm._v(" "),_c('v-tab-item',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-checkbox',{attrs:{"label":"Mostrar pop-up"},on:{"change":_vm.activarPopup},model:{value:(_vm.registro.popup),callback:function ($$v) {_vm.$set(_vm.registro, "popup", $$v)},expression:"registro.popup"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('center',[_c('img',{attrs:{"src":_vm.popupLink}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('input',{ref:"popupFile",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/png"},on:{"change":_vm.onSubirPopup}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.subirPopup()}}},[_vm._v("Actualizar pop-up")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('center',[_c('img',{attrs:{"src":_vm.logoLink}})])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('input',{ref:"logoFile",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/png"},on:{"change":_vm.onSubirLogo}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.subirLogo()}}},[_vm._v("Actualizar logo")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-checkbox',{attrs:{"label":"Activar inscripciones"},on:{"change":_vm.activarInscripciones},model:{value:(_vm.registro.inscripciones),callback:function ($$v) {_vm.$set(_vm.registro, "inscripciones", $$v)},expression:"registro.inscripciones"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-checkbox',{attrs:{"label":"Activar resultados"},on:{"change":_vm.activarResultados},model:{value:(_vm.registro.resultados),callback:function ($$v) {_vm.$set(_vm.registro, "resultados", $$v)},expression:"registro.resultados"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Estatal","rules":_vm.requeridoRegla,"mask":"##.##"},model:{value:(_vm.registroTarifas.estatal),callback:function ($$v) {_vm.$set(_vm.registroTarifas, "estatal", $$v)},expression:"registroTarifas.estatal"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Privado","rules":_vm.requeridoRegla,"mask":"##.##"},model:{value:(_vm.registroTarifas.privado),callback:function ($$v) {_vm.$set(_vm.registroTarifas, "privado", $$v)},expression:"registroTarifas.privado"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Libre","rules":_vm.requeridoRegla,"mask":"##.##"},model:{value:(_vm.registroTarifas.libre),callback:function ($$v) {_vm.$set(_vm.registroTarifas, "libre", $$v)},expression:"registroTarifas.libre"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.guardarTarifas($event)}}},[_vm._v("Guardar")])],1)],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-container',{attrs:{"grid-list-md":""}},[_vm._l((_vm.registroPuntos),function(puntosGrado){return _c('v-layout',{key:puntosGrado.grado,attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(puntosGrado.gradoAb),expression:"puntosGrado.gradoAb"}],attrs:{"type":"hidden"},domProps:{"value":(puntosGrado.gradoAb)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(puntosGrado, "gradoAb", $event.target.value)}}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Grado","rules":_vm.requeridoRegla,"disabled":"disabled"},model:{value:(puntosGrado.grado),callback:function ($$v) {_vm.$set(puntosGrado, "grado", $$v)},expression:"puntosGrado.grado"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"label":"Preguntas","rules":_vm.requeridoRegla},model:{value:(puntosGrado.preguntas),callback:function ($$v) {_vm.$set(puntosGrado, "preguntas", $$v)},expression:"puntosGrado.preguntas"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"label":"Correctas","rules":_vm.requeridoRegla},model:{value:(puntosGrado.correctas),callback:function ($$v) {_vm.$set(puntosGrado, "correctas", $$v)},expression:"puntosGrado.correctas"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"label":"Incorrectas","rules":_vm.requeridoRegla},model:{value:(puntosGrado.incorrectas),callback:function ($$v) {_vm.$set(puntosGrado, "incorrectas", $$v)},expression:"puntosGrado.incorrectas"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"label":"En blanco","rules":_vm.requeridoRegla},model:{value:(puntosGrado.blanco),callback:function ($$v) {_vm.$set(puntosGrado, "blanco", $$v)},expression:"puntosGrado.blanco"}})],1)],1)}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.guardarPuntos($event)}}},[_vm._v("Guardar")])],2)],1),_vm._v(" "),_c('v-tab-item',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Primer puesto","rules":_vm.requeridoRegla},model:{value:(_vm.registroMedallas.primer),callback:function ($$v) {_vm.$set(_vm.registroMedallas, "primer", $$v)},expression:"registroMedallas.primer"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Segundo puesto","rules":_vm.requeridoRegla},model:{value:(_vm.registroMedallas.segundo),callback:function ($$v) {_vm.$set(_vm.registroMedallas, "segundo", $$v)},expression:"registroMedallas.segundo"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Tercer puesto","rules":_vm.requeridoRegla},model:{value:(_vm.registroMedallas.tercer),callback:function ($$v) {_vm.$set(_vm.registroMedallas, "tercer", $$v)},expression:"registroMedallas.tercer"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Cuarto puesto","rules":_vm.requeridoRegla},model:{value:(_vm.registroMedallas.cuarto),callback:function ($$v) {_vm.$set(_vm.registroMedallas, "cuarto", $$v)},expression:"registroMedallas.cuarto"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Quinto puesto","rules":_vm.requeridoRegla},model:{value:(_vm.registroMedallas.quinto),callback:function ($$v) {_vm.$set(_vm.registroMedallas, "quinto", $$v)},expression:"registroMedallas.quinto"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Sexto puesto","rules":_vm.requeridoRegla},model:{value:(_vm.registroMedallas.sexto),callback:function ($$v) {_vm.$set(_vm.registroMedallas, "sexto", $$v)},expression:"registroMedallas.sexto"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.guardarMedallas($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sedes_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c1ac0ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sedes_vue__ = __webpack_require__(189);
function injectStyle (ssrContext) {
  __webpack_require__(188)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sedes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c1ac0ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sedes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Sedes")]),_vm._v(" "),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_vm._v("Nueva sede")]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"550px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Sede")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-text-field',{attrs:{"label":"Sede","name":"sede","id":"sede","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.nombreSede = _vm.registro.nombreSede.toUpperCase();}},model:{value:(_vm.registro.nombreSede),callback:function ($$v) {_vm.$set(_vm.registro, "nombreSede", $$v)},expression:"registro.nombreSede"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Colegio","name":"colegio","id":"colegio","rules":_vm.requeridoRegla,"readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.nombreColegio = _vm.registro.nombreColegio.toUpperCase();}},model:{value:(_vm.registro.nombreColegio),callback:function ($$v) {_vm.$set(_vm.registro, "nombreColegio", $$v)},expression:"registro.nombreColegio"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Dirección","name":"direccion","id":"direccion","readonly":_vm.disabledRegistro},on:{"keyup":function($event){_vm.registro.direccion = _vm.registro.direccion.toUpperCase();}},model:{value:(_vm.registro.direccion),callback:function ($$v) {_vm.$set(_vm.registro, "direccion", $$v)},expression:"registro.direccion"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.disabledRegistro && _vm.usuarioApp.toUpperCase() === 'ADMINSAN' && !_vm.eliminar)?_c('v-btn',{attrs:{"color":"error"},nativeOn:{"click":function($event){return _vm.eliminarRegistro($event)}}},[_vm._v("Eliminar")]):_vm._e(),_vm._v(" "),(_vm.eliminar)?_c('v-btn',{attrs:{"color":"error"},nativeOn:{"click":function($event){return _vm.eliminarRegistro($event)}}},[_vm._v("Confirmar eliminación")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.nuevoRegistro()}}},[_vm._v("Nuevo")]):_vm._e(),_vm._v(" "),(_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.disabledRegistro=false}}},[_vm._v("Editar")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.cerrar($event)}}},[_vm._v("Cerrar")]),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.guardar($event)}}},[_vm._v("Guardar")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.datos.data,"pagination":_vm.pagination,"total-items":_vm.totalRegistros,"loading":_vm.loading,"rows-per-page-text":"Filas por página"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.fila[1]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[2]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[3]))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[(props.item.fila[0] !== 0)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-icon',{attrs:{"slot":"activator"},on:{"click":function($event){return _vm.verRegistro(props.item)}},slot:"activator"},[_vm._v("open_in_browser")]),_vm._v(" "),_c('span',[_vm._v("Ver")])],1):_vm._e()],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("\n      -\n    ")])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resultado_vue__ = __webpack_require__(70);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63155e90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resultado_vue__ = __webpack_require__(192);
function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resultado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63155e90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resultado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title',[_c('v-flex',{attrs:{"d-flex":"","lg4":"","offset-lg4":""}},[_c('center',[_c('img',{attrs:{"src":"archivos/logo.png","width":"100%"}})])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Colegio: "+_vm._s(_vm.datos.colegio))])]),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.datos.data,"pagination":_vm.pagination,"total-items":_vm.totalRegistros,"loading":_vm.loading,"hide-actions":1 === 1,"rows-per-page-text":"Filas por página"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.fila[0]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.fila[1]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.fila[2]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[3]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[4]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[5]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[6]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[7]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[8]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[9]))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(props.item.fila[10]))])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('p',[_vm._v("No hay datos")])])],2)],1),_vm._v(" "),_c('v-card-actions')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reportes_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e76f60ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reportes_vue__ = __webpack_require__(195);
function injectStyle (ssrContext) {
  __webpack_require__(194)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reportes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e76f60ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reportes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Reportes")]),_vm._v(" "),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}})],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-select',{attrs:{"readonly":_vm.disabledRegistro,"items":_vm.reportes,"item-text":"value","item-value":"id","label":"Tipo de reporte"},model:{value:(_vm.registro.tipoReporte),callback:function ($$v) {_vm.$set(_vm.registro, "tipoReporte", $$v)},expression:"registro.tipoReporte"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.disabledRegistro)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.generar($event)}}},[_vm._v("Generar")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CambiarClave_vue__ = __webpack_require__(72);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c382e786_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CambiarClave_vue__ = __webpack_require__(197);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CambiarClave_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c382e786_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CambiarClave_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"500px"},model:{value:(_vm.cambiarClave.open),callback:function ($$v) {_vm.$set(_vm.cambiarClave, "open", $$v)},expression:"cambiarClave.open"}},[_c('v-card',[_c('v-card-title',{staticClass:"grey lighten-4 py-4 title"},[_vm._v("\n      Cambiar clave\n    ")]),_vm._v(" "),_c('v-container',{staticClass:"pa-4",attrs:{"grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","align-center":"","justify-space-between":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"Clave actual","type":"password"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","align-center":"","justify-space-between":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"Nueva clave","type":"password"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","align-center":"","justify-space-between":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-text-field',{attrs:{"label":"Repetir nueva clave","type":"password"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.cambiarClave.open = false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.cambiarClave.open = false}}},[_vm._v("Guardar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[73]);


// WEBPACK FOOTER //
// static/js/app.4481354a7fdfbe3f6562.js